"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3634],{

/***/ 86368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$B": function() { return /* binding */ ESection; },
/* harmony export */   "GI": function() { return /* binding */ menu; },
/* harmony export */   "Gh": function() { return /* binding */ SUCCESS_CODE; },
/* harmony export */   "Wx": function() { return /* binding */ DEFAULT_ALLOW_EXT; },
/* harmony export */   "aF": function() { return /* binding */ EPage; }
/* harmony export */ });
/* unused harmony exports ResumeType, SEARCHABLE_ON, SEARCHABLE_OFF, ALLOW_SEARCHABLE_DISPLAY */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98067);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(375);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46105);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41622);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62173);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68331);
/* harmony import */ var _microfrontends_react_components_components_Images__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7805);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}



var SUCCESS_CODE = 200;
var ESection;
(function(ESection) {
    ESection["SAVED_JOB"] = "saved_job";
})(ESection || (ESection = {}));
var EPage;
(function(EPage) {
    EPage["DASHBOARD"] = "dashboard";
    EPage["MY_PROFILE"] = "myProfile";
    EPage["PROFILE_SETTING"] = "profileSettings";
    EPage["MY_COMPANIES"] = "myCompanies";
    EPage["MY_JOBS"] = "myJobs";
    EPage["VIEWED_JOBS"] = "viewedJobs";
    EPage["JOB_ALERTS"] = "jobAlerts";
    EPage["ACCOUNT_SETTING"] = "accountSettings";
    EPage["RECOMMENDED_JOBS"] = "recommendedJobs";
    EPage["APPLIED_JOB"] = "appliedJobs";
    EPage["ORDER_MANAGEMENT"] = "orderMangagement";
})(EPage || (EPage = {}));
var _obj;
var menu = (_obj = {}, _defineProperty(_obj, EPage.DASHBOARD, {
    name: EPage.DASHBOARD,
    text: "Dashboard",
    link: "/my-career-center/dashboard",
    redirect: false,
    image: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
    children: {}
}), _defineProperty(_obj, EPage.MY_PROFILE, {
    name: EPage.MY_PROFILE,
    text: "My Profile",
    link: "/my-profile",
    redirect: false,
    image: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
    children: {}
}), _defineProperty(_obj, EPage.MY_COMPANIES, {
    name: EPage.MY_COMPANIES,
    text: "My Companies",
    link: "/my-career-center/my-companies",
    redirect: false,
    image: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
    children: {}
}), _defineProperty(_obj, EPage.MY_JOBS, {
    name: EPage.MY_JOBS,
    text: "My Jobs",
    link: "/my-career-center/my-jobs",
    redirect: false,
    image: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
    children: {}
}), _defineProperty(_obj, EPage.JOB_ALERTS, {
    name: EPage.JOB_ALERTS,
    text: "Job Alerts",
    link: "/my-career-center/my-job-alert",
    redirect: false,
    image: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
    children: {}
}), _defineProperty(_obj, EPage.ORDER_MANAGEMENT, {
    name: EPage.ORDER_MANAGEMENT,
    text: "Order Management",
    link: "/order-management",
    redirect: false,
    image: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_microfrontends_react_components_components_Images__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
    children: {}
}), _defineProperty(_obj, EPage.ACCOUNT_SETTING, {
    name: EPage.ACCOUNT_SETTING,
    text: "Account Settings",
    link: "/account-settings",
    redirect: false,
    image: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
    children: {}
}), _obj);
var ResumeType = {
    AttachCV: "attach-cv",
    Profile: "profile"
};
var SEARCHABLE_ON = 1;
var SEARCHABLE_OFF = 0;
var ALLOW_SEARCHABLE_DISPLAY = 1;
var DEFAULT_ALLOW_EXT = [
    ".doc",
    ".docx",
    ".pdf"
];


/***/ }),

/***/ 68321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var DefaultAvatarIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 110 : _width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: width,
        height: width,
        viewBox: "0 0 110 110",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "10",
                y: "10",
                width: "90",
                height: "90",
                rx: "45",
                fill: "#E6EFFF"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M55.9759 54.1993C62.3237 54.1993 67.8409 48.5041 67.8409 41.0884C67.8409 33.7618 62.3237 28.3335 55.9759 28.3335C49.6281 28.3335 44.1109 33.8804 44.1109 41.1477C44.1109 48.5041 49.5984 54.1993 55.9759 54.1993ZM37.3181 81.6668H74.5743C79.261 81.6668 80.9221 80.332 80.9221 77.7217C80.9221 70.0688 71.3411 59.5089 55.9462 59.5089C40.581 59.5089 31 70.0688 31 77.7217C31 80.332 32.6611 81.6668 37.3181 81.6668Z",
                fill: "#CCDEFF"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DefaultAvatarIcon);


/***/ }),

/***/ 60939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cx": function() { return /* binding */ CAREER_CENTER_SHOW_MENU; },
/* harmony export */   "EC": function() { return /* binding */ tabSection; },
/* harmony export */   "qe": function() { return /* binding */ firebaseConfig; }
/* harmony export */ });
/* unused harmony export MAKE_SEARCHABLE_CHOOSE */
/* harmony import */ var _microfrontends_app_shell_v2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64889);

var CAREER_CENTER_SHOW_MENU = "CAREER_CENTER_SHOW_MENU";
var MAKE_SEARCHABLE_CHOOSE = "MAKE_SEARCHABLE_CHOOSE";
var _NEXT_PUBLIC_FIREBASE_API_KEY, _NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN, _NEXT_PUBLIC_FIREBASE_DATABASE_URL;
var firebaseConfig = {
    apiKey: (_NEXT_PUBLIC_FIREBASE_API_KEY = "AIzaSyAJLgT_Xo5Jg_YyPaWYOrk5sFnAtEcOIfU") !== null && _NEXT_PUBLIC_FIREBASE_API_KEY !== void 0 ? _NEXT_PUBLIC_FIREBASE_API_KEY : "",
    authDomain: (_NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN = "vietnamworks-message.firebaseapp.com") !== null && _NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN !== void 0 ? _NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN : "",
    databaseURL: (_NEXT_PUBLIC_FIREBASE_DATABASE_URL = "https://vietnamworks-message.firebaseio.com") !== null && _NEXT_PUBLIC_FIREBASE_DATABASE_URL !== void 0 ? _NEXT_PUBLIC_FIREBASE_DATABASE_URL : "",
    refreshJWTUrl: "".concat("https://www.vietnamworks.com", "/my-career-center/employer-message/?action=renewFirebaseJWT")
};
var tabSection = {
    saved: _microfrontends_app_shell_v2__WEBPACK_IMPORTED_MODULE_0__/* .ESection.SAVED_JOB */ .$B.SAVED_JOB,
    applied: _microfrontends_app_shell_v2__WEBPACK_IMPORTED_MODULE_0__/* .ESection.APPLIED_JOB */ .$B.APPLIED_JOB,
    viewed: _microfrontends_app_shell_v2__WEBPACK_IMPORTED_MODULE_0__/* .ESection.VIEWED_JOB */ .$B.VIEWED_JOB
};


/***/ }),

/***/ 37696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Zh": function() { return /* binding */ ENABLE_COMPANY_INDUSTRY; },
  "Mp": function() { return /* binding */ ENABLE_JOB_FUNCTION; },
  "ZP": function() { return /* binding */ Global_MainLayout; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/PostHog/hooks/useIdentify/index.js
var useIdentify = __webpack_require__(205);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Toast/index.js + 2 modules
var Toast = __webpack_require__(60500);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/JobYouWillLove/index.js + 22 modules
var JobYouWillLove = __webpack_require__(73235);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/CompaniesYouWillLove/index.js + 4 modules
var CompaniesYouWillLove = __webpack_require__(46909);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/cookie.js
var cookie = __webpack_require__(6017);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/responsiveHelper.js
var responsiveHelper = __webpack_require__(67430);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/hooks/UseWindowResize/index.js
var UseWindowResize = __webpack_require__(86067);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/hooks/UseInitNotification/index.js
var UseInitNotification = __webpack_require__(72831);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/dist/index.modern.js
var index_modern = __webpack_require__(64889);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./store/index.tsx + 5 modules
var store = __webpack_require__(43634);
;// CONCATENATED MODULE: ./components/Global/MainLayout/MainLayout.css.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    padding: 16px;\n    background-color: #f7f8fa;\n    @media screen and (max-width: 768px) {\n        padding: 0;\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n                    flex: 0 0 ",
        ";\n                    max-width: ",
        ";\n                    padding-right: 16px;\n                "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n                    flex: 0 0 ",
        ";\n                    max-width: ",
        ";\n                    padding-right: 16px;\n                "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n                    width: ",
        ";\n                    padding-right: 16px;\n                "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n                    width: 0;\n                    height: 0;\n                "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    transition: 0.5s;\n    ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n                flex: 100vw !important;\n                overflow: hidden;\n            "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n                flex: 0 0 ",
        ";\n                max-width: ",
        ";\n            "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n                flex: 0 0 ",
        ";\n                max-width: ",
        ";\n            "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n                flex: 0 0 ",
        ";\n                max-width: ",
        ";\n            "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n                flex: 0 0 ",
        ";\n                max-width: ",
        ";\n            "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n    transition: 0.5s;\n    ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n                flex: 0 0 338px;\n                max-width: 338px;\n                padding-left: 16px;\n            "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n                flex: 1;\n            "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n    transition: 0.5s;\n    ",
        "\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}


var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5cab019c-0"
})(_templateObject());
var Body = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5cab019c-1"
})(_templateObject1());
var LeftContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5cab019c-2"
})(_templateObject6(), function(param) {
    var device = param.device, isShowMenu = param.isShowMenu;
    switch(device){
        case store/* EDevice.DESKTOP */.a2.DESKTOP:
            return (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), !isShowMenu ? "76px" : "338px", !isShowMenu ? "76px" : "338px");
        case store/* EDevice.LAPTOP */.a2.LAPTOP:
            return (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), !isShowMenu ? "76px" : "338px", !isShowMenu ? "76px" : "338px");
        case store/* EDevice.TABLET */.a2.TABLET:
            return (0,styled_components_browser_esm/* css */.iv)(_templateObject4(), isShowMenu ? "295px" : "76px");
        case store/* EDevice.MOBILE */.a2.MOBILE:
            return (0,styled_components_browser_esm/* css */.iv)(_templateObject5());
    }
});
var ChildrenContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5cab019c-3"
})(_templateObject12(), function(param) {
    var isShowMenu = param.isShowMenu, isHaveRightContainer = param.isHaveRightContainer, device = param.device;
    if (device === store/* EDevice.MOBILE */.a2.MOBILE) {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject7());
    }
    if (device === store/* EDevice.TABLET */.a2.TABLET && isHaveRightContainer) {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject8(), !isShowMenu ? "calc(100% - 76px)" : "calc(100% - 300px)", !isShowMenu ? "calc(100% - 76px)" : "calc(100% - 300px)");
    }
    if (device === store/* EDevice.TABLET */.a2.TABLET && !isHaveRightContainer) {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject9(), !isShowMenu ? "calc(100% - 76px)" : "calc(100% - 295px)", !isShowMenu ? "calc(100% - 76px)" : "calc(100% - 295px)");
    }
    if (isHaveRightContainer) {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject10(), !isShowMenu ? "calc((100% - 76px - 338px))" : "calc(100% - (338px * 2))", !isShowMenu ? "calc((100% - 76px - 338px))" : "calc(100% - (338px * 2))");
    }
    if (!isHaveRightContainer) {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject11(), !isShowMenu ? "calc(100% - 76px)" : "calc(100% - 338px)", !isShowMenu ? "calc(100% - 76px)" : "calc(100% - 338px)");
    }
});
var RightContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5cab019c-4"
})(_templateObject15(), function(param) {
    var device = param.device, isShowMenu = param.isShowMenu;
    if (device === store/* EDevice.DESKTOP */.a2.DESKTOP) {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject13());
    } else {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject14());
    }
});

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Podcast/index.js + 5 modules
var Podcast = __webpack_require__(7953);
;// CONCATENATED MODULE: ./components/PodcastAudio/index.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




var EType;
(function(EType) {
    EType["LARGE"] = "large";
    EType["MEDIUM"] = "medium";
    EType["SMALL"] = "small";
})(EType || (EType = {}));
var PodcastAudio = function(param) {
    var language = param.language;
    /**
     * VNW-23152 [Web][NaviCMS] Update podcast
     *
     * @author HieuNPM
     * @since Jul 10 2023
     */ var mode = "production";
    var podcastApi = "https://ms.vietnamworks.com/navi-api/api/podcast";
    var emptyPodcast = {
        title: "",
        time: "",
        link: "",
        url: "",
        utm: "",
        image: ""
    };
    var ref = (0,react.useState)(emptyPodcast), podcastData1 = ref[0], setPodcastData = ref[1];
    (0,react.useEffect)(function() {
        _asyncToGenerator(runtime_default().mark(function _callee() {
            var podcastRes, podcasts, item, date, displayTime, podcastData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetch(podcastApi);
                    case 2:
                        podcastRes = _ctx.sent;
                        _ctx.next = 5;
                        return podcastRes.json();
                    case 5:
                        podcasts = _ctx.sent;
                        if (!(!Array.isArray(podcasts) || podcasts.length === 0)) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 8:
                        item = podcasts.pop();
                        date = new Date(item.publishedOn);
                        displayTime = language === constants/* ELanguage.EN */.Df.EN ? "".concat(date.toLocaleString("en", {
                            month: "short"
                        }), " ").concat(date.getDate()) : "".concat(date.getDate(), " ").concat(date.toLocaleString("vi", {
                            month: "long"
                        }));
                        podcastData = {
                            title: item.title,
                            time: displayTime,
                            link: item.source,
                            url: item.url,
                            utm: item.utm,
                            image: item.thumbnail
                        };
                        setPodcastData(podcastData);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    }, []);
    return  true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Podcast/* default */.Z, {
        type: EType.SMALL,
        language: language,
        appMode: mode,
        podcastData: podcastData1
    }) : 0;
};
/* harmony default export */ var components_PodcastAudio = (PodcastAudio);

// EXTERNAL MODULE: ./components/Global/MetaTags.tsx
var MetaTags = __webpack_require__(36962);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Notifications/index.js + 4 modules
var Notifications = __webpack_require__(91295);
// EXTERNAL MODULE: ./services/userService.ts
var userService = __webpack_require__(76219);
// EXTERNAL MODULE: ./store/actions.ts
var actions = __webpack_require__(25800);
// EXTERNAL MODULE: ./helpers/cookies.ts
var cookies = __webpack_require__(61868);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./helpers/util.ts
var util = __webpack_require__(5672);
// EXTERNAL MODULE: ./services/profileService.ts
var profileService = __webpack_require__(41396);
// EXTERNAL MODULE: ./components/Global/MainLayout/constant.tsx
var constant = __webpack_require__(60939);
// EXTERNAL MODULE: ./components/ProfileStrength/const.ts
var ProfileStrength_const = __webpack_require__(42500);
;// CONCATENATED MODULE: ./components/Global/MainLayout/index.tsx
/* provided dependency */ var process = __webpack_require__(83454);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function MainLayout_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function MainLayout_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                MainLayout_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                MainLayout_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



















// not SSR because initial value isShowMenu not working on first render
var SideNavigation = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1945), __webpack_require__.e(8252), __webpack_require__.e(553)]).then(__webpack_require__.bind(__webpack_require__, 90553));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(90553)
            ];
        }
    },
    ssr: false
});
var BASE_PATH = "https://ms.vietnamworks.com";
var ENABLE_COMPANY_INDUSTRY = !!Number("1");
var ENABLE_JOB_FUNCTION = !!Number("1");
var _NEXT_PUBLIC_MICROSERVICE_DOMAIN;
var msBaseUrl = (_NEXT_PUBLIC_MICROSERVICE_DOMAIN = process.env.NEXT_PUBLIC_MICROSERVICE_DOMAIN) !== null && _NEXT_PUBLIC_MICROSERVICE_DOMAIN !== void 0 ? _NEXT_PUBLIC_MICROSERVICE_DOMAIN : "";
var MainLayout = function(props) {
    var children = props.children, pageName = props.pageName, _responsiveCornerColor = props.responsiveCornerColor, responsiveCornerColor = _responsiveCornerColor === void 0 ? "#fff" : _responsiveCornerColor, userIp = props.userIp;
    var ref = (0,store/* useStore */.oR)(), state = ref.state, dispatch = ref.dispatch;
    var user1 = state.user, langCode = state.langCode, device = state.device, t = state.t, profileLevel = state.profileLevel;
    var router = (0,next_router.useRouter)();
    (0,useIdentify/* default */.ZP)(user1, msBaseUrl);
    var ref1 = (0,react.useState)(false), isRerenderHeader = ref1[0], setReRenderHeader = ref1[1];
    var ref2 = (0,react.useState)(true), isShowMenu = ref2[0], setShowMenu = ref2[1];
    var ref3 = (0,react.useState)([]), seoKeywords = ref3[0], setSeoKeywords = ref3[1];
    var isShowReferral =  true ? "0" === "1" : 0;
    var loginUrl = "".concat("https://www.vietnamworks.com", "/").concat(langCode === index_modern/* ELanguage.EN */.Df.EN ? "login" : "dang-nhap");
    var percentage = (0,util/* calculateProfileStrength */.nD)(profileLevel, ProfileStrength_const/* strengthOption */.Uc);
    var ref4 = _slicedToArray(UseWindowResize/* default */.Z(), 1), breakpoint = ref4[0];
    var isShowNotification = UseInitNotification/* useInitNotification */.U();
    var notificationProps = {
        langCode: langCode,
        firebaseConfig: constant/* firebaseConfig */.qe,
        baseMsUrl: "https://ms.vietnamworks.com",
        jobSeekerUrl: "https://www.vietnamworks.com",
        user: user1
    };
    var isHaveRightContainer = function() {
        if (device !== store/* EDevice.DESKTOP */.a2.DESKTOP) {
            return false;
        }
        if (router.pathname.includes(t("/my-career-center/dashboard"))) {
            return false;
        }
        return true;
    };
    var getLevel = function() {
        var _ref = MainLayout_asyncToGenerator(runtime_default().mark(function _callee() {
            var level, _profileStrength;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return profileService/* default.getLevel */.ZP.getLevel();
                    case 2:
                        level = _ctx.sent;
                        if (level) {
                            ;
                            dispatch({
                                type: actions/* ACTION_SET_PROFILE_LEVEL */.sC,
                                payload: _objectSpread({}, profileLevel, {
                                    level: level.resumeLevelId,
                                    passedPoints: level.currentPoint,
                                    totalPoints: level.totalPoint,
                                    status: level.resumeStatus,
                                    profileStrength: (_profileStrength = level.profileStrength) !== null && _profileStrength !== void 0 ? _profileStrength : 0
                                })
                            });
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getLevel() {
            return _ref.apply(this, arguments);
        };
    }();
    var updateUserState = function(user2) {
        var setUserAndUserRelatedData = function(user) {
            dispatch({
                type: actions/* ACTION_SET_USER */.gS,
                payload: _objectSpread({}, user, {
                    userIp: userIp
                })
            });
        };
        setUserAndUserRelatedData(user2);
    };
    var getTokenAndDispatchUser = function() {
        var _ref = MainLayout_asyncToGenerator(runtime_default().mark(function _callee() {
            var jsToken, wsToken, user, redirectToLogin;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        jsToken = "";
                        wsToken = "";
                        if (!window) {
                            _ctx.next = 8;
                            break;
                        }
                        jsToken = decodeURIComponent((0,cookies/* getCookie */.ej)("VNW128450527232960") || "");
                        wsToken = decodeURIComponent((0,cookies/* getCookie */.ej)("VNWWS128450527232960") || "");
                        if (!(jsToken === "" || wsToken === "")) {
                            _ctx.next = 8;
                            break;
                        }
                        window.location.href = "".concat(loginUrl, "?type=login&redirectURL=").concat(encodeURIComponent(window.location.href));
                        return _ctx.abrupt("return");
                    case 8:
                        _ctx.next = 10;
                        return userService/* default.authenticate */.Z.authenticate(jsToken, wsToken);
                    case 10:
                        user = _ctx.sent;
                        if (user) {
                            updateUserState(user);
                        } else {
                            redirectToLogin = function() {
                                if (true) {
                                    window.location.href = "".concat(loginUrl, "?type=login&redirectURL=").concat(encodeURIComponent(window.location.href));
                                    return;
                                }
                            };
                            redirectToLogin();
                        }
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getTokenAndDispatchUser() {
            return _ref.apply(this, arguments);
        };
    }();
    var initSelectData = function() {
        var _ref = MainLayout_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return index_modern/* initialDataProvider.initSelectData */.Bz.initSelectData({
                            selectDataKey: [
                                "industry",
                                "jobFunction",
                                "level"
                            ],
                            mode: "production",
                            langCode: langCode
                        });
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function initSelectData() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleShowMenu = function(isShow) {
        setShowMenu(isShow);
        localStorage.setItem(constant/* CAREER_CENTER_SHOW_MENU */.Cx, JSON.stringify(isShow));
    };
    var getToastMessageFromCookie = function() {
        var showToastMessage = cookie/* getCookie */.e("VNW_SHOW_TOAST");
        // reset cookie
        cookie/* setCookie */.d("VNW_SHOW_TOAST", "", -1);
        if (!showToastMessage) {
            return;
        }
        Toast/* showToast */.CF(t("Success"), showToastMessage);
    };
    var getSeoKeyword = function() {
        var _ref = MainLayout_asyncToGenerator(runtime_default().mark(function _callee() {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,index_modern/* getSeoKeywordAPI */.md)("https://ms.vietnamworks.com" || 0);
                    case 2:
                        data = _ctx.sent;
                        if (data && data.length > 0) {
                            setSeoKeywords(data);
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getSeoKeyword() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (true) {
            var initShow = JSON.parse(localStorage.getItem(constant/* CAREER_CENTER_SHOW_MENU */.Cx) || "true");
            setShowMenu(initShow);
        }
        // Authenticate
        getTokenAndDispatchUser();
        // Set current state to mobile/tablet
        dispatch({
            type: actions/* ACTION_SET_IS_MOBILE */.vQ,
            payload: responsiveHelper/* isPhone */.Mn() || responsiveHelper/* isTablet */.Em()
        });
        setReRenderHeader(true);
        // get profile strength
        getLevel();
        // get seo keyword
        getSeoKeyword();
        // handle device change
        var handleDeviceChange = function() {
            if (window.innerWidth <= 768) {
                dispatch({
                    type: actions/* ACTION_SET_DEVICE */.NL,
                    payload: store/* EDevice.MOBILE */.a2.MOBILE
                });
            } else if (window.innerWidth > 768 && window.innerWidth <= 1024) {
                dispatch({
                    type: actions/* ACTION_SET_DEVICE */.NL,
                    payload: store/* EDevice.TABLET */.a2.TABLET
                });
            } else if (window.innerWidth > 1024 && window.innerWidth <= 1440) {
                dispatch({
                    type: actions/* ACTION_SET_DEVICE */.NL,
                    payload: store/* EDevice.LAPTOP */.a2.LAPTOP
                });
            } else {
                dispatch({
                    type: actions/* ACTION_SET_DEVICE */.NL,
                    payload: store/* EDevice.DESKTOP */.a2.DESKTOP
                });
            }
        };
        handleDeviceChange();
        initSelectData();
        getToastMessageFromCookie();
        window.addEventListener("resize", handleDeviceChange);
        window.addEventListener("UPDATE_USER", function() {
            return location.reload();
        });
        return function() {
            window.removeEventListener("resize", handleDeviceChange);
            window.removeEventListener("UPDATE_USER", function() {
                return location.reload();
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        dispatch({
            type: actions/* ACTION_SET_BREAKPOINT */.NH,
            payload: breakpoint
        });
    }, [
        dispatch,
        breakpoint
    ]);
    var ref5;
    var userInfo = _objectSpread({}, user1, {
        jobLevelId: user1 === null || user1 === void 0 ? void 0 : user1.jobLevelId[0],
        id: (ref5 = user1 === null || user1 === void 0 ? void 0 : user1.id) !== null && ref5 !== void 0 ? ref5 : 0
    });
    var param = router.query.section || "";
    var section = pageName === index_modern/* EPages.MY_JOBS */.QS.MY_JOBS && param === "" ? "applied" : param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* default */.ZP, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* Header */.h4, {
                mode: "production",
                langCode: langCode,
                user: user1,
                pageName: pageName,
                isHaveBottomTab: false,
                subMenuSection: constant/* tabSection */.EC[section],
                responsive: {
                    type: "sub-page",
                    pageTitle: t("Career center"),
                    cornerColor: responsiveCornerColor,
                    backLink: t("/account-center")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Body, {
                device: device,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftContainer, {
                        device: device,
                        isShowMenu: isShowMenu,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SideNavigation, {
                            langCode: langCode,
                            device: device,
                            user: user1,
                            percentProfile: percentage,
                            isShow: isShowMenu,
                            onShowChange: function(e) {
                                return handleShowMenu(e);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildrenContainer, {
                        device: device,
                        isShowMenu: isShowMenu,
                        isHaveRightContainer: isHaveRightContainer(),
                        children: children
                    }),
                    isHaveRightContainer() && /*#__PURE__*/ (0,jsx_runtime.jsxs)(RightContainer, {
                        device: device,
                        isShowMenu: isShowMenu,
                        children: [
                            user1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(JobYouWillLove/* default */.Z, {
                                isMobile: device === store/* EDevice.MOBILE */.a2.MOBILE,
                                api: {
                                    baseUrl: "https://ms.vietnamworks.com" || 0,
                                    accessToken: user1 === null || user1 === void 0 ? void 0 : user1.accessToken,
                                    query: {
                                        limit: "10",
                                        user: String(user1 === null || user1 === void 0 ? void 0 : user1.userId)
                                    },
                                    appId: "5_5s8na3qyquckws4ogkgk88g44oosccwwsc8ckcg4s0ogws8s8o" || 0,
                                    source: "Career Center - Jobs You Will Love"
                                },
                                utmType: "my-profile",
                                langCode: langCode,
                                previewJob: {
                                    enable: device !== store/* EDevice.MOBILE */.a2.MOBILE,
                                    baseUrl: "https://www.vietnamworks.com" || 0
                                },
                                classSelector: "myjobs_recommend view_job_item",
                                userInfo: userInfo,
                                initData: {
                                    locations: index_modern/* initialDataProvider.getLocations */.Bz.getLocations(),
                                    jobFunctions: index_modern/* initialDataProvider.getJobFunction */.Bz.getJobFunction(),
                                    companyIndustries: index_modern/* initialDataProvider.getIndustries */.Bz.getIndustries(),
                                    jobLevels: index_modern/* initialDataProvider.getLevels */.Bz.getLevels(),
                                    educations: index_modern/* initialDataProvider.getHighestDegrees */.Bz.getHighestDegrees(),
                                    countries: index_modern/* initialDataProvider.getCountries */.Bz.getCountries(),
                                    cities: index_modern/* initialDataProvider.getLocations */.Bz.getLocations(),
                                    districts: index_modern/* initialDataProvider.getDistricts */.Bz.getDistricts(),
                                    benefits: index_modern/* initialDataProvider.getBenefits */.Bz.getBenefits()
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    marginTop: 8
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompaniesYouWillLove/* default */.Z, {
                                    langCode: langCode,
                                    accessToken: (user1 === null || user1 === void 0 ? void 0 : user1.accessToken) || "",
                                    msUrl: BASE_PATH || "",
                                    userId: (user1 === null || user1 === void 0 ? void 0 : user1.userId) || 0,
                                    options: {
                                        isSideView: true,
                                        maxItemOnRow: 1
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PodcastAudio, {
                                language: langCode
                            })
                        ]
                    })
                ]
            }),
            isShowNotification && user1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Notifications/* default */.Z, {
                config: notificationProps,
                user: user1,
                langCode: langCode
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* Footer */.$_, {
                mode: "production",
                langCode: langCode,
                user: user1,
                seoKeywordData: seoKeywords
            })
        ]
    });
};
/* harmony default export */ var Global_MainLayout = (MainLayout);


/***/ }),

/***/ 36962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MetaTags; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43634);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33089);
/* provided dependency */ var process = __webpack_require__(83454);







function MetaTags() {
    var t = (0,_store__WEBPACK_IMPORTED_MODULE_4__/* .useStore */ .oR)().state.t;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var url = "".concat("https://www.vietnamworks.com").concat(router.asPath);
    var favicon = "".concat("https://www.vietnamworks.com", "/favicon.ico?v=").concat(process.env.BUILD_ID);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(next_head__WEBPACK_IMPORTED_MODULE_1__["default"], {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                        children: [
                            t("meta_title"),
                            " | VietnamWorks"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1.0 maximum-scale=1.0, user-scalable=no"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        httpEquiv: "X-UA-Compatible",
                        content: "IE=edge"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "shortcut icon",
                        href: favicon,
                        type: "image/x-icon"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: t("meta_description")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "theme-color",
                        content: _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_6__/* .colors.primary[20] */ .O9.primary[20]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "noindex, nofollow"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: url
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_5___default()), {
                id: "ga",
                dangerouslySetInnerHTML: {
                    __html: "\n                    var _gaq = _gaq || [];\n                    var pluginUrl = '//www.google-analytics.com/plugins/ga/inpage_linkid.js';\n                    _gaq.push(['_require', 'inpage_linkid', pluginUrl]);\n                    _gaq.push(['_setAccount', '".concat("UA-103236-1", "']);\n                    _gaq.push(['_setDomainName', '").concat("vietnamworks.com", "']);\n                    _gaq.push(['_trackPageview']);\n\n                    (function() {\n                        var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true;\n                        ga.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'stats.g.doubleclick.net/dc.js';\n                        var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s);\n                    })();\n                    function customEvent (uniqueName, action, label, value) {\n                        if (_gaq) {\n                            _gaq.push(['_trackEvent', uniqueName, action, label], value || 1); // 'Videos', 'Play', 'First Birthday'\n                        }\n                    }")
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_5___default()), {
                id: "gtm",
                dangerouslySetInnerHTML: {
                    __html: "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','".concat("GTM-TKNN69", "');")
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_5___default()), {
                async: true,
                src: "".concat("https://www.vietnamworks.com", "/assets-page-container/js/jquery.min.js")
            })
        ]
    });
};


/***/ }),

/***/ 49279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$0": function() { return /* binding */ Section; },
/* harmony export */   "FD": function() { return /* binding */ RightButtonWrapper; },
/* harmony export */   "Jg": function() { return /* binding */ ResumeDesc; },
/* harmony export */   "dd": function() { return /* binding */ WarningSearchableModal; },
/* harmony export */   "q5": function() { return /* binding */ AttachmentFileNameWrapper; }
/* harmony export */ });
/* unused harmony exports SectionContent, SwitcherBox, TitleBox, StyledSwitcher, SearchableBox, SearchableItem, Left, Right, OnboardingBox, StyledDialog, VisibleOnLargeScreen, HiddenOnLargeScreen, WrapSwitcherMobile, AttachmentMobileWrapper, SearchableContainer, SearchableText, RefreshStatus, WrapSwitcher, Description */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33089);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12866);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73851);
/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65585);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43634);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0;\n    margin: 16px 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    width: 75%;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 20px;\n    color: #333;\n    padding-right: 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    width: 25%;\n    display: inline-flex;\n    justify-content: flex-end;\n    padding-left: 0;\n    height: 28px;\n\n    label {\n        margin-left: 0;\n    }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    margin-top: 16px;\n    background-color: ",
        ";\n    padding: 16px 12px;\n    border-radius: 12px;\n    display: flex;\n    flex-flow: column;\n    gap: 16px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n                background: ",
        ";\n                border: 1px solid ",
        ";\n            "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    cursor: ",
        ";\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    border-radius: 6px;\n    display: flex;\n    margin: 0 0 8px 0;\n    font-weight: 400;\n    padding: 8px 12px;\n    :hover {\n        ",
        "\n    }\n    &.active {\n        border: 1px solid ",
        ";\n    }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n    display: inline-flex;\n    padding-right: 10px;\n    label {\n        flex-direction: column;\n        margin-top: 2px;\n    }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n    display: block;\n    width: 100%;\n    label {\n        font-size: 14px;\n        line-height: 20px;\n        margin-bottom: 0;\n        color: ",
        ";\n        :hover {\n            cursor: pointer;\n        }\n    }\n    .btn-link {\n        display: inline-flex;\n        margin-top: 16px;\n        font-size: 14px;\n        line-height: 14px;\n        color: ",
        ";\n        align-content: center;\n        align-items: center;\n    }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n                        max-width: 100px;\n                    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n    margin-top: 8px;\n    font-size: 14px;\n    line-height: 20px;\n    font-weight: 400;\n    & > div {\n        display: flex;\n        align-items: center;\n        span {\n            display: flex;\n            color: ",
        ";\n            margin-left: 5px;\n            p {\n                max-width: 200px;\n                text-overflow: ellipsis;\n                white-space: nowrap;\n                overflow: hidden;\n                margin: 0;\n                ",
        "\n            }\n        }\n    }\n    span {\n        cursor: pointer;\n    }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n    a:first-child {\n        margin-right: 20px;\n    }\n    .btn-link {\n        margin-top: 16px;\n        font-size: 14px;\n        line-height: 14px;\n        color: #005aff;\n        align-content: center;\n        align-items: center;\n    }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n    z-index: 1009;\n    div[class^='Dialog-module_body_'] {\n        background-color: #fbfbfb;\n        padding-left: 0px;\n        padding-right: 0px;\n    }\n    .text-h2 {\n        width: 100%;\n        text-align: center;\n    }\n    span[class^='Dialog-module_icon__'] {\n        position: absolute;\n        left: 16px;\n    }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n    display: none;\n    @media screen and (min-width: 1200px) {\n        display: block;\n    }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n    display: block;\n    @media screen and (min-width: 1200px) {\n        display: none;\n    }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    width: calc(\n        100% -\n            ",
        "px\n    );\n    span:first-child {\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n    }\n    span:last-child {\n        flex: 1 0 auto;\n    }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n            pointer-events: none;\n        "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n    background: #fff;\n    border-radius: 6px;\n    margin-bottom: 8px;\n    label {\n        margin-bottom: 0;\n    }\n    ",
        "\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n    min-height: 700px;\n    overflow: auto;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n            color: #969696;\n            max-width: unset;\n        "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n            margin-bottom: 0;\n        "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n    ",
        "\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n    flex: 1;\n    color: rgb(51 51 51 / 70%);\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n            margin-top: 12px;\n            gap: unset;\n            button.disable {\n                color: #e5e5e5;\n                border-color: #e5e5e5;\n                pointer-events: none;\n            }\n        "
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 8px;\n    gap: 16px;\n\n    ",
        "\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _taggedTemplateLiteral([
        "\n    font-size: 15px;\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _taggedTemplateLiteral([
        "\n    margin-top: 16px;\n    font-size: 14px;\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _taggedTemplateLiteral([
        "\n    position: absolute;\n    top: 12px;\n    right: 12px;\n    display: ",
        ";\n    align-items: center;\n    gap: 10px;\n\n    ",
        ":hover & {\n        display: flex;\n    }\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}



var Section = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fa0e4fba-0"
})(_templateObject());
var SectionContent = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fa0e4fba-1"
})(_templateObject1());
var SwitcherBox = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fa0e4fba-2"
})(_templateObject2());
var TitleBox = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fa0e4fba-3"
})(_templateObject3());
var StyledSwitcher = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fa0e4fba-4"
})(_templateObject4());
var SearchableBox = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fa0e4fba-5"
})(_templateObject5(), function(props) {
    return props.isMobile ? _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__/* .colors.neutral[95] */ .O9.neutral[95] : _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__/* .colors.primary[99] */ .O9.primary[99];
});
var SearchableItem = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fa0e4fba-6"
})(_templateObject7(), function(param) {
    var isEnable = param.isEnable;
    return isEnable ? "pointer" : "normal";
}, _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__/* .colors.grey[99] */ .O9.grey[99], _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__/* .colors.grey[90] */ .O9.grey[90], function(param) {
    var isEnable = param.isEnable;
    return isEnable && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject6(), _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__/* .colors.primary[95] */ .O9.primary[95], _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__/* .colors.primary[80] */ .O9.primary[80]);
}, _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__/* .colors.primary[80] */ .O9.primary[80]);
var Left = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fa0e4fba-7"
})(_templateObject8());
var Right = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fa0e4fba-8"
})(_templateObject9(), _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__/* .colors.grey[20] */ .O9.grey[20], _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__/* .colors.primary[40] */ .O9.primary[40]);
var ResumeDesc = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fa0e4fba-9"
})(_templateObject11(), _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_2__/* .colors.grey[30] */ .O9.grey[30], function(param) {
    var isMobile = param.isMobile;
    return isMobile && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject10());
});
var OnboardingBox = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fa0e4fba-10"
})(_templateObject12());
var StyledDialog = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-fa0e4fba-11"
})(_templateObject13());
var VisibleOnLargeScreen = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fa0e4fba-12"
})(_templateObject14());
var HiddenOnLargeScreen = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fa0e4fba-13"
})(_templateObject15());
var AttachmentFileNameWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fa0e4fba-14"
})(_templateObject16(), function(param) {
    var device = param.device, fullWidth = param.fullWidth;
    var _obj;
    return fullWidth ? 0 : (_obj = {}, _defineProperty(_obj, _store__WEBPACK_IMPORTED_MODULE_0__/* .EDevice.DESKTOP */ .a2.DESKTOP, 280), _defineProperty(_obj, _store__WEBPACK_IMPORTED_MODULE_0__/* .EDevice.LAPTOP */ .a2.LAPTOP, 280), _defineProperty(_obj, _store__WEBPACK_IMPORTED_MODULE_0__/* .EDevice.TABLET */ .a2.TABLET, 50), _defineProperty(_obj, _store__WEBPACK_IMPORTED_MODULE_0__/* .EDevice.MOBILE */ .a2.MOBILE, 50), _obj)[device];
});
var WrapSwitcherMobile = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fa0e4fba-15"
})(_templateObject18(), function(param) {
    var notHaveCV = param.notHaveCV;
    return notHaveCV && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject17());
});
var AttachmentMobileWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(WrapSwitcherMobile).withConfig({
    componentId: "sc-fa0e4fba-16"
})(_templateObject19());
var SearchableContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fa0e4fba-17"
})(_templateObject20());
var SearchableText = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fa0e4fba-18"
})(_templateObject23(), function(param) {
    var isSearchable = param.isSearchable;
    return !isSearchable && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject21());
}, function(param) {
    var isMobile = param.isMobile;
    return isMobile && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject22());
});
var RefreshStatus = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fa0e4fba-19"
})(_templateObject24());
var WrapSwitcher = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fa0e4fba-20"
})(_templateObject26(), function(param) {
    var isMobile = param.isMobile;
    return isMobile && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject25());
});
var WarningSearchableModal = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fa0e4fba-21"
})(_templateObject27());
var Description = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_microfrontends_react_components__WEBPACK_IMPORTED_MODULE_4__/* .Paragraph */ .nv).withConfig({
    componentId: "sc-fa0e4fba-22"
})(_templateObject28());
var RightButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-fa0e4fba-23"
})(_templateObject29(), function(props) {
    return props.active ? "flex" : "none";
}, _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_5__/* .OptionGroupStyled.Wrapper */ .d.Wrapper);


/***/ }),

/***/ 72072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$5": function() { return /* binding */ API_UPDATE_RESUME_SETTING_OPTION; },
/* harmony export */   "$P": function() { return /* binding */ ResumeType; },
/* harmony export */   "AT": function() { return /* binding */ API_GET_RESUME_INFO; },
/* harmony export */   "Ah": function() { return /* binding */ nationalityList; },
/* harmony export */   "C_": function() { return /* binding */ API_GET_NAME_UNHIDDEN; },
/* harmony export */   "DC": function() { return /* binding */ API_LEVEL_PROFILE; },
/* harmony export */   "H9": function() { return /* binding */ API_GET_OPEN_TO_WORK; },
/* harmony export */   "Io": function() { return /* binding */ vnwBasePath; },
/* harmony export */   "Kw": function() { return /* binding */ API_GET_RESUME_ATTACHMENT_LIST; },
/* harmony export */   "LJ": function() { return /* binding */ HIDE_MY_PROFILE_MAX; },
/* harmony export */   "N$": function() { return /* binding */ WAIT_TYPING_MILISECONDS; },
/* harmony export */   "RE": function() { return /* binding */ MAX_COMPANY_NAME; },
/* harmony export */   "T_": function() { return /* binding */ API_UPDATE_DOMAIN; },
/* harmony export */   "Ye": function() { return /* binding */ API_CHANGE_SEARCHABLE; },
/* harmony export */   "aY": function() { return /* binding */ API_GET_NAME; },
/* harmony export */   "eu": function() { return /* binding */ SEARCHABLE_ON; },
/* harmony export */   "jA": function() { return /* binding */ API_UPDATE_NAME; },
/* harmony export */   "nk": function() { return /* binding */ API_REFRESH_PROFILE; },
/* harmony export */   "se": function() { return /* binding */ DEFAULT_SUCCESS_CODE; },
/* harmony export */   "vi": function() { return /* binding */ UPDATE_TYPE; },
/* harmony export */   "xv": function() { return /* binding */ API_GET_DOMAIN; }
/* harmony export */ });
/* unused harmony exports ChangeSearchableResponseStatus, PROFILE_SETTING_OPTIONS, REFRESH_WEEKLY, REFRESH_DAILY, REFRESH_ON, REFRESH_OFF, SEARCHABLE_OFF, ONLINE_CV, ATTACH_CV, UN_CONTACTABLE_ON */
var HIDE_MY_PROFILE_MAX = 30 // Company domain
;
var MAX_COMPANY_NAME = 30 // Company name
;
var WAIT_TYPING_MILISECONDS = 1000;
var DEFAULT_SUCCESS_CODE = 200;
var UPDATE_TYPE = {
    ADD: "add",
    REMOVE: "remove"
};
var ResumeType = {
    AttachCV: "attach-cv",
    Profile: "profile"
};
var ChangeSearchableResponseStatus;
(function(ChangeSearchableResponseStatus) {
    ChangeSearchableResponseStatus[ChangeSearchableResponseStatus["SUCCESS"] = 0] = "SUCCESS";
    ChangeSearchableResponseStatus[ChangeSearchableResponseStatus["ERROR"] = 1] = "ERROR";
    ChangeSearchableResponseStatus[ChangeSearchableResponseStatus["UNCONTACTABLE"] = 2] = "UNCONTACTABLE";
})(ChangeSearchableResponseStatus || (ChangeSearchableResponseStatus = {}));
var nationalityList = function() {
    var langCode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "vi";
    var nationalityList1 = {
        en: [
            {
                id: 1,
                name: "Local Vietnamese"
            },
            {
                id: 2,
                name: "Foreigner"
            }
        ],
        vi: [
            {
                id: 1,
                name: "Ng\u01B0\u1EDDi Vi\u1EC7t Nam"
            },
            {
                id: 2,
                name: "Ng\u01B0\u1EDDi n\u01B0\u1EDBc ngo\xe0i"
            }
        ]
    };
    return nationalityList1[langCode];
};
var PROFILE_SETTING_OPTIONS = "VNW_PROFILE_SETTING_OPTIONS";
var REFRESH_WEEKLY = 2;
var REFRESH_DAILY = 1;
var REFRESH_ON = 1;
var REFRESH_OFF = 0;
var SEARCHABLE_ON = 1;
var SEARCHABLE_OFF = 0;
var ONLINE_CV = 0;
var ATTACH_CV = 1;
var UN_CONTACTABLE_ON = 1;
var API_GET_DOMAIN = "/api-gateway/v1.0/profile/get-user-hidden-domains";
var API_UPDATE_DOMAIN = "/api-gateway/v1.0/profile/update-user-hidden-domains";
var API_GET_NAME = "/api-gateway/v1.0/profile/get-user-hidden-companies";
var API_UPDATE_NAME = "/api-gateway/v1.0/profile/update-user-hidden-companies";
var API_GET_NAME_UNHIDDEN = "/api-gateway/v1.0/profile/get-user-unhidden-companies";
var API_CHANGE_SEARCHABLE = "/api-gateway/v1.0/profile/resume-change-searchable";
var API_GET_RESUME_INFO = "/api-gateway/v2.0/profile/resume-setting-info";
var API_REFRESH_PROFILE = "/api-gateway/v1.0/profile/refresh-profile";
var API_LEVEL_PROFILE = "/api-gateway/v1.0/profile/level";
var API_UPDATE_RESUME_SETTING_OPTION = "/api-gateway/v1.0/profile/cookie";
var API_GET_RESUME_ATTACHMENT_LIST = "/api-gateway/v1.0/profile/resume-attached";
var API_GET_OPEN_TO_WORK = "/api-gateway/v1.0/profile/open-to-work";
var _NEXT_PUBLIC_VNW_BASE_URL;
var vnwBasePath = (_NEXT_PUBLIC_VNW_BASE_URL = "https://www.vietnamworks.com") !== null && _NEXT_PUBLIC_VNW_BASE_URL !== void 0 ? _NEXT_PUBLIC_VNW_BASE_URL : "";


/***/ }),

/***/ 14325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProfileSettings; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Page/ProfileSettings/translations.ts
var translations = __webpack_require__(22825);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Typography/index.js + 2 modules
var Typography = __webpack_require__(17739);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Colors/index.js
var Colors = __webpack_require__(33089);
// EXTERNAL MODULE: ./components/Page/ProfileSettings/constants.tsx
var constants = __webpack_require__(72072);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/PostHog/hooks/useHog/index.js + 1 modules
var useHog = __webpack_require__(89083);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Tag/index.js + 2 modules
var Tag = __webpack_require__(149);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Input/index.js + 3 modules
var Input = __webpack_require__(27386);
// EXTERNAL MODULE: ./components/Page/ProfileSettings/services.ts
var services = __webpack_require__(80117);
// EXTERNAL MODULE: ./node_modules/debounce-promise/dist/index.js
var dist = __webpack_require__(69496);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Button/index.js + 1 modules
var Button = __webpack_require__(1189);
;// CONCATENATED MODULE: ./components/Page/ProfileSettings/InputGroup/inputGroup.ccs.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    width: auto;\n    display: inline-flex;\n    align-content: center;\n    justify-content: center;\n    align-items: center;\n    padding-left: 10px;\n    min-width: 22px;\n    height: 36px;\n    color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n                border-radius: 0;\n            "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    width: 100%;\n    border: 1px solid ",
        ";\n    border-radius: 6px;\n    height: 40px;\n    background-color: #fff;\n    :hover {\n        border: 1px solid #80adff;\n    }\n    :focus {\n        border: 1px solid #0066ff;\n    }\n    &.focus {\n        border: 1px solid #0066ff;\n        button {\n            border-left: 1px solid #0066ff;\n        }\n    }\n    input {\n        width: 100%;\n        height: 36px;\n        padding-left: 4px;\n        border: none !important;\n        &::placeholder {\n            color: ",
        ";\n        }\n        ",
        "\n        :hover {\n            border: none;\n        }\n        :focus {\n            border: none;\n        }\n    }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n            width: 100%;\n            input {\n                padding-left: 10px;\n            }\n        "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    width: 90.5%;\n    > div > div {\n        top: 1px;\n    }\n    svg.remove-icon {\n        top: 6px;\n    }\n    ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    align-content: center;\n    align-items: center;\n    justify-content: flex-start;\n    img {\n        width: 32px;\n        height: 32px;\n        margin-right: 8px;\n    }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    margin-top: 12px;\n    display: flex;\n    flex-wrap: wrap;\n    margin-bottom: -4px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    margin-right: 4px;\n    margin-bottom: 4px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n            display: none;\n        "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n    span {\n        display: block;\n    }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n            width: 16%;\n        "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n    width: 9.5%;\n    min-width: 60px;\n    border-left: 1px solid #a2a6ac;\n    opacity: 1;\n    height: 38px;\n    border-right: none;\n    border-top: none;\n    border-bottom: none;\n    border-radius: 0 6px 6px 0;\n    color: ",
        " !important;\n\n    ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}


var PrefixText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4aaefa8d-0"
})(_templateObject(), Colors/* colors.grey.50 */.O9.grey[50]);
var InputDomain = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4aaefa8d-1"
})(_templateObject2(), Colors/* colors.neutral.80 */.O9.neutral[80], Colors/* colors.grey.50 */.O9.grey[50], function(param) {
    var isInputDomain = param.isInputDomain;
    if (!isInputDomain) {
        return;
    }
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject1());
});
var InputArea = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4aaefa8d-2"
})(_templateObject4(), function(param) {
    var nonePrefix = param.nonePrefix;
    return nonePrefix && (0,styled_components_browser_esm/* css */.iv)(_templateObject3());
});
var SuggestItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4aaefa8d-3"
})(_templateObject5());
var TagList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4aaefa8d-4"
})(_templateObject6());
var TagItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4aaefa8d-5"
})(_templateObject7());
var MessageAlert = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4aaefa8d-6"
})(_templateObject9(), function(param) {
    var isDisplay = param.isDisplay;
    return !isDisplay && (0,styled_components_browser_esm/* css */.iv)(_templateObject8());
});
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-4aaefa8d-7"
})(_templateObject11(), Colors/* colors.grey.20 */.O9.grey[20], function(param) {
    var isMobile = param.isMobile;
    return isMobile && (0,styled_components_browser_esm/* css */.iv)(_templateObject10());
});

// EXTERNAL MODULE: ./store/index.tsx + 5 modules
var store_0 = __webpack_require__(43634);
;// CONCATENATED MODULE: ./components/Page/ProfileSettings/InputGroup/index.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}









var companyDefaultLogo = "https://images.vietnamworks.com/img/company-default-logo.svg";
function InputGroup(props) {
    var isMobile = props.isMobile, isInputCompanyName = props.isInputCompanyName, placeholder = props.placeholder, max = props.max, trans = props.trans, prefixText = props.prefixText, userToken = props.userToken;
    var ref4 = (0,react.useState)(""), value1 = ref4[0], setValue = ref4[1];
    var ref1 = (0,react.useState)(false), isFocus = ref1[0], setIsFocus = ref1[1];
    var ref2 = (0,react.useState)([]), tagList = ref2[0], setTagList = ref2[1];
    var ref3 = (0,react.useState)([]), listRecommend = ref3[0], setListRecommend = ref3[1];
    var langCode = (0,store_0/* useStore */.oR)().state.langCode;
    var tracking = (0,useHog/* default */.Z)().tracking;
    var debouncedLoadOptions = dist_default()(function(inputValue) {
        return loadOptions(inputValue);
    }, constants/* WAIT_TYPING_MILISECONDS */.N$, {
        leading: true
    });
    var getUserHiddenCompanyName = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, userHiddenCompanyNameResponse, listHiddenCompany;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (userToken) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        _ctx.next = 5;
                        return (0,services/* apiGetUserHiddenCompanyName */.U4)(userToken);
                    case 5:
                        userHiddenCompanyNameResponse = _ctx.sent;
                        if (!((userHiddenCompanyNameResponse === null || userHiddenCompanyNameResponse === void 0 ? void 0 : (ref = userHiddenCompanyNameResponse.status) === null || ref === void 0 ? void 0 : ref.code) !== constants/* DEFAULT_SUCCESS_CODE */.se)) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 8:
                        if ((userHiddenCompanyNameResponse === null || userHiddenCompanyNameResponse === void 0 ? void 0 : userHiddenCompanyNameResponse.data) !== undefined && userHiddenCompanyNameResponse.data.length > 0) {
                            listHiddenCompany = [];
                            userHiddenCompanyNameResponse.data.map(function(item, index) {
                                listHiddenCompany.push({
                                    id: index,
                                    name: item.main_name,
                                    taxCode: item.tax_code
                                });
                            });
                            setTagList(listHiddenCompany);
                        }
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getUserHiddenCompanyName() {
            return _ref.apply(this, arguments);
        };
    }();
    var getUserHiddenDomains = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, userHiddenDomainsResponse, listHiddenDomain;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (userToken) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        _ctx.next = 5;
                        return (0,services/* apiGetUserHiddenDomains */.mS)(userToken);
                    case 5:
                        userHiddenDomainsResponse = _ctx.sent;
                        if (!((userHiddenDomainsResponse === null || userHiddenDomainsResponse === void 0 ? void 0 : (ref = userHiddenDomainsResponse.status) === null || ref === void 0 ? void 0 : ref.code) !== constants/* DEFAULT_SUCCESS_CODE */.se)) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 8:
                        if (userHiddenDomainsResponse.data !== undefined && userHiddenDomainsResponse.data.length > 0) {
                            listHiddenDomain = [];
                            userHiddenDomainsResponse.data.map(function(item, index) {
                                listHiddenDomain.push({
                                    id: index,
                                    name: item
                                });
                            });
                            setTagList(listHiddenDomain);
                        }
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getUserHiddenDomains() {
            return _ref.apply(this, arguments);
        };
    }();
    var doUpdateItem = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(domain, taxCode) {
            var type, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        type = _args.length > 2 && _args[2] !== void 0 ? _args[2] : constants/* UPDATE_TYPE.ADD */.vi.ADD;
                        if (!isInputCompanyName) {
                            _ctx.next = 6;
                            break;
                        }
                        _ctx.next = 4;
                        return (0,services/* apiUpdateUserHiddenCompanyName */.Oy)(userToken, langCode, {
                            type: type,
                            taxCode: taxCode
                        });
                    case 4:
                        tracking({
                            eventName: "js_profile_management:hide_company_by_name",
                            properties: {
                                isAdd: type === constants/* UPDATE_TYPE.ADD */.vi.ADD
                            }
                        });
                        return _ctx.abrupt("return");
                    case 6:
                        _ctx.next = 8;
                        return (0,services/* apiUpdateUserHiddenDomain */.U3)(userToken, langCode, {
                            type: type,
                            domain: domain
                        });
                    case 8:
                        tracking({
                            eventName: "js_profile_management:hide_company_by_domain",
                            properties: {
                                isAdd: type === constants/* UPDATE_TYPE.ADD */.vi.ADD
                            }
                        });
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function doUpdateItem(domain, taxCode) {
            return _ref.apply(this, arguments);
        };
    }();
    var getListRecommend = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(value) {
            var companyResponse, listRecommendMapped;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,services/* apiGetUnHiddenCompany */.Do)(userToken, langCode, value);
                    case 2:
                        companyResponse = _ctx.sent;
                        if (!(companyResponse.status.code !== constants/* DEFAULT_SUCCESS_CODE */.se)) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 5:
                        if (!(companyResponse.data !== undefined && companyResponse.data.length > 0)) {
                            _ctx.next = 10;
                            break;
                        }
                        listRecommendMapped = [];
                        companyResponse.data.map(function(item) {
                            listRecommendMapped.push({
                                id: item.tax_code,
                                taxCode: item.tax_code,
                                label: item.main_name,
                                name: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuggestItem, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: item.main_logo !== "" ? item.main_logo : companyDefaultLogo
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: item.main_name
                                        })
                                    ]
                                })
                            });
                        });
                        setListRecommend(listRecommendMapped);
                        return _ctx.abrupt("return");
                    case 10:
                        // No result
                        setListRecommend([
                            {
                                id: -1,
                                name: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "suggest-item loading",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: trans("No result found...")
                                    })
                                })
                            }
                        ]);
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getListRecommend(value) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOnClickSuggestionItem = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(id) {
            var isMax, tagListFiltered, filteredList;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        isMax = max !== undefined && tagList.length === max;
                        if (!isMax) {
                            _ctx.next = 4;
                            break;
                        }
                        setValue("");
                        return _ctx.abrupt("return");
                    case 4:
                        if (!(id === -1)) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 6:
                        tagListFiltered = tagList.filter(function(item) {
                            return item.id === id;
                        });
                        if (!(tagListFiltered.length > 0)) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 9:
                        filteredList = listRecommend.filter(function(item) {
                            return (item === null || item === void 0 ? void 0 : item.id) === id;
                        });
                        if (!(filteredList.length <= 0)) {
                            _ctx.next = 12;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 12:
                        tagList.push({
                            id: id,
                            name: filteredList[0].label,
                            taxCode: filteredList[0].taxCode
                        });
                        setTagList(tagList);
                        setValue("");
                        _ctx.next = 17;
                        return doUpdateItem("", filteredList[0].taxCode, constants/* UPDATE_TYPE.ADD */.vi.ADD);
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleOnClickSuggestionItem(id) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOnInputEnterPress = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var isMax, filteredTagList;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        isMax = max !== undefined && tagList.length === max;
                        if (!isInputCompanyName) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        filteredTagList = tagList.filter(function(item) {
                            return item.name === value1;
                        });
                        if (!(filteredTagList.length > 0)) {
                            _ctx.next = 7;
                            break;
                        }
                        setValue("");
                        return _ctx.abrupt("return");
                    case 7:
                        if (!isMax) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 9:
                        if (!(value1.trim() === "")) {
                            _ctx.next = 11;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 11:
                        tagList.push({
                            id: tagList.length,
                            name: value1
                        });
                        setTagList(tagList);
                        setValue("");
                        _ctx.next = 16;
                        return doUpdateItem(value1, "", constants/* UPDATE_TYPE.ADD */.vi.ADD);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleOnInputEnterPress() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOnInputChange = function(value) {
        setValue(prefixText ? value.replaceAll(prefixText, "") : value);
        if (isInputCompanyName) {
            // Set loading text before get list recommend
            setListRecommend([
                {
                    id: -1,
                    name: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "suggest-item loading",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: trans("Loading...")
                        })
                    })
                }
            ]);
            debouncedLoadOptions(value);
        }
    };
    var handleOnInputFocusOrBlur = function() {
        var isBlur = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        setIsFocus(!isBlur);
    };
    var loadOptions = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(inputValue) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(inputValue.length < 3)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", false);
                    case 2:
                        _ctx.next = 4;
                        return getListRecommend(inputValue);
                    case 4:
                        return _ctx.abrupt("return", true);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function loadOptions(inputValue) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (isInputCompanyName) {
            getUserHiddenCompanyName();
        } else {
            getUserHiddenDomains();
        }
    }, [
        isInputCompanyName,
        userToken
    ]);
    var renderTagList = function() {
        if (!tagList || tagList.length === 0) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        var renderTag = tagList.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TagItem, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* default */.Z, {
                    label: item === null || item === void 0 ? void 0 : item.name,
                    iconType: "remove",
                    size: "medium",
                    onClick: function() {
                        return removeTag(item);
                    },
                    isMobile: isMobile,
                    isShowIcon: true
                })
            }, index);
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TagList, {
            children: renderTag
        });
    };
    var renderMessageAlert = function() {
        var isShowMaxAlert = max !== undefined && tagList.length === max;
        if (isInputCompanyName) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MessageAlert, {
                isDisplay: isShowMaxAlert,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: trans("Max number of {0} companies reached").replace("{0}", max.toString())
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: trans("Please delete first before add other companies")
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageAlert, {
            isDisplay: isShowMaxAlert,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                children: [
                    trans("You can add a maximum of"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: max
                    }),
                    " ",
                    trans("email domains")
                ]
            })
        });
    };
    var removeTag = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(item) {
            var tagListFiltered;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        tagListFiltered = tagList.filter(function(tag) {
                            return (tag === null || tag === void 0 ? void 0 : tag.id) !== item.id;
                        });
                        setTagList(tagListFiltered);
                        if (!(tagList.length !== tagListFiltered.length)) {
                            _ctx.next = 10;
                            break;
                        }
                        if (!isInputCompanyName) {
                            _ctx.next = 8;
                            break;
                        }
                        _ctx.next = 6;
                        return doUpdateItem("", item.taxCode, constants/* UPDATE_TYPE.REMOVE */.vi.REMOVE);
                    case 6:
                        _ctx.next = 10;
                        break;
                    case 8:
                        _ctx.next = 10;
                        return doUpdateItem(item.name, "", constants/* UPDATE_TYPE.REMOVE */.vi.REMOVE);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function removeTag(item) {
            return _ref.apply(this, arguments);
        };
    }();
    var isShowMaxAlert1 = max !== undefined && tagList.length === max;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputDomain, {
                className: isFocus ? "focus" : "",
                isInputDomain: !isInputCompanyName,
                children: [
                    !isInputCompanyName && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrefixText, {
                        children: prefixText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputArea, {
                        nonePrefix: isInputCompanyName,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, _objectSpread({
                            placeholder: placeholder,
                            value: value1,
                            onPressEnter: function() {
                                return handleOnInputEnterPress();
                            }
                        }, isInputCompanyName && !isShowMaxAlert1 ? {
                            listRecommend: listRecommend
                        } : {}, {
                            onClickSuggestionItem: function(item) {
                                return handleOnClickSuggestionItem(item.id);
                            },
                            onChange: handleOnInputChange,
                            onFocus: function() {
                                return handleOnInputFocusOrBlur(false);
                            },
                            onBlur: function() {
                                return handleOnInputFocusOrBlur(true);
                            }
                        }))
                    }),
                    !isInputCompanyName && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                        isMobile: isMobile,
                        onClick: handleOnInputEnterPress,
                        disabled: value1 === "",
                        children: trans("Add")
                    })
                ]
            }),
            renderMessageAlert(),
            renderTagList()
        ]
    });
};

;// CONCATENATED MODULE: ./components/Page/ProfileSettings/HideMyProfile/HideMyProfile.css.tsx
function HideMyProfile_css_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function HideMyProfile_css_templateObject() {
    var data = HideMyProfile_css_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n"
    ]);
    HideMyProfile_css_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HideMyProfile_css_templateObject1() {
    var data = HideMyProfile_css_taggedTemplateLiteral([
        "\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 28px;\n"
    ]);
    HideMyProfile_css_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HideMyProfile_css_templateObject2() {
    var data = HideMyProfile_css_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n"
    ]);
    HideMyProfile_css_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HideMyProfile_css_templateObject3() {
    var data = HideMyProfile_css_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n"
    ]);
    HideMyProfile_css_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function HideMyProfile_css_templateObject4() {
    var data = HideMyProfile_css_taggedTemplateLiteral([
        "\n    font-size: 14px;\n    line-height: 20px;\n    color: #333;\n    margin-bottom: 1rem;\n    span {\n        background-color: #ff7d55;\n        font-size: 12px;\n        line-height: 11px;\n        color: #fff;\n        font-weight: 600;\n        border-radius: 12px;\n        padding: 5px 10px;\n    }\n"
    ]);
    HideMyProfile_css_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function HideMyProfile_css_templateObject5() {
    var data = HideMyProfile_css_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: row-reverse;\n    justify-content: space-between;\n    margin-top: 8px;\n"
    ]);
    HideMyProfile_css_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function HideMyProfile_css_templateObject6() {
    var data = HideMyProfile_css_taggedTemplateLiteral([
        "\n    padding: 16px;\n    background: #fff;\n    border-radius: 6px;\n    border: 1px solid #ebebeb;\n    margin-bottom: 8px;\n"
    ]);
    HideMyProfile_css_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}

var Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-934e3eeb-0"
})(HideMyProfile_css_templateObject());
var SectionTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-934e3eeb-1"
})(HideMyProfile_css_templateObject1());
var SectionContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-934e3eeb-2"
})(HideMyProfile_css_templateObject2());
var CompanyBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-934e3eeb-3"
})(HideMyProfile_css_templateObject3());
var SubTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-934e3eeb-4"
})(HideMyProfile_css_templateObject4());
var WrapSwitcher = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-934e3eeb-5"
})(HideMyProfile_css_templateObject5());
var WrapSwitcherMobile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-934e3eeb-6"
})(HideMyProfile_css_templateObject6());

;// CONCATENATED MODULE: ./components/Page/ProfileSettings/HideMyProfile/index.tsx







function HideMyProfile(props) {
    var trans = props.trans;
    var user = (0,store_0/* useStore */.oR)().state.user;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                name: "title",
                size: "medium",
                color: Colors/* colors.grey.20 */.O9.grey[20],
                children: trans("Hide My profile from Company")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyBox, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                name: "body",
                                size: "medium",
                                color: Colors/* colors.grey.20 */.O9.grey[20],
                                children: [
                                    trans("Enter company's email domain"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: trans("Recommended")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputGroup, {
                                max: constants/* HIDE_MY_PROFILE_MAX */.LJ,
                                prefixText: "@",
                                placeholder: "navigosgroup.com",
                                isInputCompanyName: false,
                                isMobile: false,
                                trans: trans,
                                userToken: (user === null || user === void 0 ? void 0 : user.accessToken) || ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyBox, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                name: "body",
                                size: "medium",
                                color: Colors/* colors.grey.20 */.O9.grey[20],
                                children: trans("Or enter a company name")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputGroup, {
                                max: constants/* MAX_COMPANY_NAME */.RE,
                                prefixText: "",
                                placeholder: "Navigos Group VN",
                                isInputCompanyName: true,
                                isMobile: false,
                                trans: trans,
                                userToken: (user === null || user === void 0 ? void 0 : user.accessToken) || ""
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/LayoutSystem/Row.js
var Row = __webpack_require__(39724);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/LayoutSystem/Col.js
var Col = __webpack_require__(18978);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/SingleRadio/index.js
var SingleRadio = __webpack_require__(12056);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Dialog/index.js + 1 modules
var Dialog = __webpack_require__(12866);
;// CONCATENATED MODULE: ./components/Page/ProfileSettings/RefreshMyProfile/RefreshMyProfile.css.tsx
function RefreshMyProfile_css_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function RefreshMyProfile_css_templateObject() {
    var data = RefreshMyProfile_css_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n"
    ]);
    RefreshMyProfile_css_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RefreshMyProfile_css_templateObject1() {
    var data = RefreshMyProfile_css_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n"
    ]);
    RefreshMyProfile_css_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RefreshMyProfile_css_templateObject2() {
    var data = RefreshMyProfile_css_taggedTemplateLiteral([
        "\n            margin-top: 0;\n            gap: unset;\n            button.disable {\n                color: #e5e5e5;\n                border-color: #e5e5e5;\n                pointer-events: none;\n            }\n        "
    ]);
    RefreshMyProfile_css_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function RefreshMyProfile_css_templateObject3() {
    var data = RefreshMyProfile_css_taggedTemplateLiteral([
        "\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 8px;\n    gap: 16px;\n\n    ",
        "\n"
    ]);
    RefreshMyProfile_css_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function RefreshMyProfile_css_templateObject4() {
    var data = RefreshMyProfile_css_taggedTemplateLiteral([
        "\n            margin-left: 0;\n        "
    ]);
    RefreshMyProfile_css_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function RefreshMyProfile_css_templateObject5() {
    var data = RefreshMyProfile_css_taggedTemplateLiteral([
        "\n    margin-left: 100px;\n    ",
        "\n    &.disable > div {\n        pointer-events: none;\n    }\n    label {\n        margin: 0 10px;\n        user-select: none;\n        font-weight: 400;\n        cursor: pointer;\n    }\n"
    ]);
    RefreshMyProfile_css_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function RefreshMyProfile_css_templateObject6() {
    var data = RefreshMyProfile_css_taggedTemplateLiteral([
        "\n    min-width: 25%;\n    width: auto;\n    display: inline-flex;\n    justify-content: flex-end;\n    padding-left: 0;\n    height: 28px;\n\n    label {\n        margin-bottom: 0;\n    }\n"
    ]);
    RefreshMyProfile_css_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function RefreshMyProfile_css_templateObject7() {
    var data = RefreshMyProfile_css_taggedTemplateLiteral([
        "\n                display: unset;\n            "
    ]);
    RefreshMyProfile_css_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function RefreshMyProfile_css_templateObject8() {
    var data = RefreshMyProfile_css_taggedTemplateLiteral([
        "\n    display: flex;\n    width: 100%;\n    transition: all 0.5s;\n    margin-top: 20px;\n    ",
        "\n"
    ]);
    RefreshMyProfile_css_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function RefreshMyProfile_css_templateObject9() {
    var data = RefreshMyProfile_css_taggedTemplateLiteral([
        "\n    border-radius: 12px;\n    background: ",
        ";\n    border: 1px solid ",
        ";\n    &:hover {\n        background: #f0f7ff;\n        border: 1px solid #b3ceff;\n    }\n    & > label {\n        padding: 12px;\n        height: 48px;\n        gap: 12px;\n        & input {\n            border-width: ",
        "!important;\n        }\n    }\n"
    ]);
    RefreshMyProfile_css_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function RefreshMyProfile_css_templateObject10() {
    var data = RefreshMyProfile_css_taggedTemplateLiteral([
        "\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n"
    ]);
    RefreshMyProfile_css_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function RefreshMyProfile_css_templateObject11() {
    var data = RefreshMyProfile_css_taggedTemplateLiteral([
        "\n    flex: 1;\n    color: rgb(51 51 51 / 70%);\n"
    ]);
    RefreshMyProfile_css_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = RefreshMyProfile_css_taggedTemplateLiteral([
        "\n    div[class^='Dialog-module_body_'] {\n        background-color: #fbfbfb;\n        padding-left: 0px;\n        padding-right: 0px;\n    }\n    .text-h2 {\n        width: 100%;\n        text-align: center;\n    }\n    span[class^='Dialog-module_icon__'] {\n        position: absolute;\n        left: 16px;\n    }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = RefreshMyProfile_css_taggedTemplateLiteral([
        "\n    padding: 16px 12px;\n    background: #fff;\n    border-radius: 6px;\n    border: 1px solid #ebebeb;\n    margin-bottom: 8px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var RefreshMyProfile_css_Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-31034269-0"
})(RefreshMyProfile_css_templateObject());
var RefreshMyProfile_css_SectionContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-31034269-1"
})(RefreshMyProfile_css_templateObject1());
var RefreshMyProfile_css_WrapSwitcher = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-31034269-2"
})(RefreshMyProfile_css_templateObject3(), function(param) {
    var isMobile = param.isMobile;
    return isMobile && (0,styled_components_browser_esm/* css */.iv)(RefreshMyProfile_css_templateObject2());
});
var SwitcherBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-31034269-3"
})(RefreshMyProfile_css_templateObject5(), function(param) {
    var isMobile = param.isMobile;
    return isMobile && (0,styled_components_browser_esm/* css */.iv)(RefreshMyProfile_css_templateObject4());
});
var StyledSwitcher = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-31034269-4"
})(RefreshMyProfile_css_templateObject6());
var WrapRadio = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-31034269-5"
})(RefreshMyProfile_css_templateObject8(), function(param) {
    var isMobile = param.isMobile;
    return isMobile && (0,styled_components_browser_esm/* css */.iv)(RefreshMyProfile_css_templateObject7());
});
var RefreshRadio = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-31034269-6"
})(RefreshMyProfile_css_templateObject9(), function(param) {
    var checked = param.checked;
    return checked ? "#f0f7ff" : Colors/* colors.grey.99 */.O9.grey[99];
}, function(param) {
    var checked = param.checked;
    return checked ? "#b3ceff" : "#efefef";
}, function(param) {
    var checked = param.checked;
    return checked ? "2px " : "1px ";
});
var AlertBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-31034269-7"
})(RefreshMyProfile_css_templateObject10());
var RefreshStatus = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-31034269-8"
})(RefreshMyProfile_css_templateObject11());
var StyledDialog = (0,styled_components_browser_esm/* default */.ZP)(Dialog/* default */.Z).withConfig({
    componentId: "sc-31034269-9"
})(_templateObject12());
var RefreshMyProfile_css_WrapSwitcherMobile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-31034269-10"
})(_templateObject13());

// EXTERNAL MODULE: ./store/ProfileSetting/index.tsx
var ProfileSetting = __webpack_require__(50209);
;// CONCATENATED MODULE: ./components/Page/ProfileSettings/RefreshMyProfile/index.tsx
function RefreshMyProfile_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function RefreshMyProfile_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            RefreshMyProfile_defineProperty(target, key, source[key]);
        });
    }
    return target;
}






function RefreshMyProfile(param) {
    var trans = param.trans;
    var ref = (0,ProfileSetting/* useProfileSettingStore */.n2)(), state = ref.state, dispatchSettingState = ref.setState;
    var isTurnOnRefresh = state.isTurnOnRefresh, statusRefresh = state.statusRefresh, expiredDate = state.expiredDate;
    var handleChangeStatus = function(value) {
        dispatchSettingState(RefreshMyProfile_objectSpread({}, state, {
            statusRefresh: Number(value),
            isTurnOnRefresh: Number(value) !== 0
        }));
    };
    var renderContentDate = function() {
        var refreshText = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
            name: "body",
            size: "medium",
            color: Colors/* colors.grey.20 */.O9.grey[20],
            children: [
                trans("The profile will be automatically refreshed and will be on the top of the Employer's candidate search page until"),
                " ",
                expiredDate,
                "."
            ]
        });
        var notRefreshText = /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            name: "body",
            size: "medium",
            color: Colors/* colors.grey.20 */.O9.grey[20],
            children: trans("The profile will be automatically refreshed and on top of the Employer's candidate search page within 15 days from the date of enabling the feature.")
        });
        return statusRefresh !== store_0/* ERefreshProfile.Unset */.mI.Unset ? refreshText : notRefreshText;
    };
    var currentStatusRefresh = statusRefresh;
    if (!isTurnOnRefresh) {
        currentStatusRefresh = store_0/* ERefreshProfile.Unset */.mI.Unset;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RefreshMyProfile_css_Section, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                name: "title",
                size: "medium",
                color: Colors/* colors.grey.20 */.O9.grey[20],
                children: trans("Refresh My Profile")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RefreshMyProfile_css_SectionContent, {
                children: [
                    renderContentDate(),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        gutter: 10,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: 24,
                                sm: 8,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RefreshRadio, {
                                    checked: currentStatusRefresh === store_0/* ERefreshProfile.Unset */.mI.Unset,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleRadio/* default */.Z, {
                                        checked: currentStatusRefresh === store_0/* ERefreshProfile.Unset */.mI.Unset,
                                        onChange: handleChangeStatus,
                                        label: trans("Turn Off Refresh"),
                                        name: "refreshMyProfile",
                                        id: "0",
                                        isLeftRadio: true,
                                        hoverBgOff: true,
                                        noBg: true
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: 24,
                                sm: 8,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RefreshRadio, {
                                    checked: currentStatusRefresh === store_0/* ERefreshProfile.Weekly */.mI.Weekly,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleRadio/* default */.Z, {
                                        checked: currentStatusRefresh === store_0/* ERefreshProfile.Weekly */.mI.Weekly,
                                        onChange: handleChangeStatus,
                                        label: trans("Refresh Weekly"),
                                        name: "refreshMyProfile",
                                        id: "2",
                                        isLeftRadio: true,
                                        hoverBgOff: true,
                                        noBg: true
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: 24,
                                sm: 8,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RefreshRadio, {
                                    checked: currentStatusRefresh === store_0/* ERefreshProfile.Daily */.mI.Daily,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleRadio/* default */.Z, {
                                        checked: currentStatusRefresh === store_0/* ERefreshProfile.Daily */.mI.Daily,
                                        onChange: handleChangeStatus,
                                        label: trans("Refresh Daily"),
                                        name: "refreshMyProfile",
                                        id: "1",
                                        isLeftRadio: true,
                                        hoverBgOff: true,
                                        noBg: true
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useMakeSearchable/index.js + 2 modules
var useMakeSearchable = __webpack_require__(13325);
// EXTERNAL MODULE: ./components/Page/ProfileSettings/MakeProfileSearchable/makeProfileSearchable.css.tsx
var makeProfileSearchable_css = __webpack_require__(49279);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Typography/components/Variant.js + 1 modules
var Variant = __webpack_require__(73851);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/OptionGroup/index.js
var OptionGroup = __webpack_require__(71554);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/ButtonViewMore/index.js + 4 modules
var ButtonViewMore = __webpack_require__(19093);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/helpers.js + 1 modules
var helpers = __webpack_require__(75052);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/PDFIcon/index.js
var PDFIcon = __webpack_require__(32977);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/EmployerViewIcon/index.js
var EmployerViewIcon = __webpack_require__(80656);
// EXTERNAL MODULE: ./helpers/common.ts + 1 modules
var common = __webpack_require__(61105);
;// CONCATENATED MODULE: ./components/Page/ProfileSettings/MakeProfileSearchable/Attachments.tsx
function Attachments_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Attachments_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Attachments_defineProperty(target, key, source[key]);
        });
    }
    return target;
}








function Attachments(param) {
    var trans = param.trans, searchableResume = param.searchableResume;
    var state = (0,store_0/* useStore */.oR)().state;
    var profileSettingStore = (0,ProfileSetting/* useProfileSettingStore */.n2)();
    var settingState = profileSettingStore.state;
    var resumeId = settingState.resumeId;
    var disPatchSettingState = profileSettingStore.setState;
    var profileSettingInfo = state.profileSettingInfo, user = state.user, device = state.device;
    var isMobile = device === store_0/* EDevice.MOBILE */.a2.MOBILE;
    var resumeSetting = profileSettingInfo.resumeSetting;
    var attachment1 = resumeSetting.attachInfo;
    var profileOnline = resumeSetting.profileInfo;
    var allowSearchableAttachment = function() {
        return attachment1.every(function(attachment) {
            return attachment.allowSearchableDisplay !== 0;
        });
    };
    var gotoProfileSetting = function() {
        window.location.assign("".concat(trans("/my-profile"), "?tab=attached-cv"));
    };
    var handleOnClickAttachCV = function(e) {
        e.stopPropagation();
        var customEvent = new CustomEvent("CLOSE_PROFILE_SETTING_POPUP");
        window.dispatchEvent(customEvent);
    };
    var attachmentOptions = (0,common/* formatAttachmentList */.U8)(attachment1);
    var isSearchable = profileOnline.isSearchable === 1;
    var filteredSearchable = attachment1.filter(function(item) {
        return item.isSearchable === 1;
    });
    if (filteredSearchable.length > 0) {
        isSearchable = true;
    }
    var currentResumeId = resumeId;
    if (searchableResume !== null && searchableResume.id && !isSearchable) {
        currentResumeId = searchableResume.id;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        xs: "fill",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            name: "label",
                            size: "medium",
                            style: {
                                marginRight: "auto"
                            },
                            color: Colors/* colors.grey.20 */.O9.grey[20],
                            children: trans("By attached CVs")
                        })
                    }),
                    !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        xs: "auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Variant/* Span */.Dr, {
                            name: "body",
                            size: "small",
                            color: Colors/* colors.primary.40 */.O9.primary[40],
                            onClick: gotoProfileSetting,
                            style: {
                                marginRight: 0,
                                cursor: "pointer"
                            },
                            children: trans("Manage attached CVs")
                        })
                    }) : null
                ]
            }),
            attachment1 && attachment1.length > 0 && !allowSearchableAttachment() ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    outline: "outline",
                    size: "sm",
                    type: "info",
                    onClick: function(e) {
                        return handleOnClickAttachCV(e);
                    },
                    children: trans("Complete basic information")
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    attachment1 && attachment1.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: attachmentOptions.map(function(attachmentItem, index) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(OptionGroup/* OptionGroup */.Y, {
                                styles: {
                                    wrapperStyle: {
                                        // since ViewMoreButton popup is covered by other OptionGroup below,
                                        // current OptionGroup must have higher zIndex than the next one
                                        zIndex: attachmentOptions.length - index,
                                        marginBottom: index === attachmentOptions.length - 1 ? 0 : undefined
                                    }
                                },
                                checked: currentResumeId === attachmentItem.id,
                                onChange: function(id) {
                                    return disPatchSettingState(Attachments_objectSpread({}, settingState, {
                                        resumeId: Number(id)
                                    }));
                                },
                                contentDisable: false,
                                disabled: !allowSearchableAttachment(),
                                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(makeProfileSearchable_css/* AttachmentFileNameWrapper */.q5, {
                                    device: state.device,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Variant/* Span */.Dr, {
                                            size: "medium",
                                            name: "paragraph",
                                            children: attachmentItem.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Variant/* Span */.Dr, {
                                            size: "medium",
                                            name: "paragraph",
                                            children: [
                                                ".",
                                                attachmentItem.extension
                                            ]
                                        })
                                    ]
                                }),
                                value: attachmentItem.id,
                                name: attachmentItem.name,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        name: "label",
                                        size: "small",
                                        color: Colors/* colors.grey.60 */.O9.grey[60],
                                        children: [
                                            trans("Uploaded"),
                                            " ",
                                            attachmentItem.updatedDate
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(makeProfileSearchable_css/* RightButtonWrapper */.FD, {
                                        active: attachmentItem.id === resumeId || [
                                            store_0/* EDevice.MOBILE */.a2.MOBILE,
                                            store_0/* EDevice.TABLET */.a2.TABLET
                                        ].includes(state.device),
                                        children: [
                                            store_0/* EDevice.LAPTOP */.a2.LAPTOP,
                                            store_0/* EDevice.DESKTOP */.a2.DESKTOP
                                        ].includes(state.device) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    type: "info",
                                                    size: "sm",
                                                    outline: "outline",
                                                    onClick: function(e) {
                                                        e.stopPropagation();
                                                        var _NEXT_PUBLIC_MS_BASE_PATH, ref;
                                                        helpers/* downloadAttachFile */.jE({
                                                            resumeId: attachmentItem.id,
                                                            downloadRequest: "new-window",
                                                            msBaseUrl: (_NEXT_PUBLIC_MS_BASE_PATH = "https://ms.vietnamworks.com") !== null && _NEXT_PUBLIC_MS_BASE_PATH !== void 0 ? _NEXT_PUBLIC_MS_BASE_PATH : "",
                                                            accessToken: (ref = user === null || user === void 0 ? void 0 : user.accessToken) !== null && ref !== void 0 ? ref : "",
                                                            fileName: ""
                                                        });
                                                    },
                                                    children: trans("View CV")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    type: "info",
                                                    size: "sm",
                                                    outline: "outline",
                                                    onClick: function(e) {
                                                        e.stopPropagation();
                                                        window.open("".concat(constants/* vnwBasePath */.Io, "/").concat(trans("preview-resume"), "/").concat(attachmentItem === null || attachmentItem === void 0 ? void 0 : attachmentItem.id), "_blank");
                                                    },
                                                    children: trans("View as employer")
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonViewMore/* default */.Z, {
                                            onClick: function(e) {
                                                return e.stopPropagation();
                                            },
                                            textOptions: {
                                                closeText: trans("Close")
                                            },
                                            header: /*#__PURE__*/ (0,jsx_runtime.jsxs)(makeProfileSearchable_css/* AttachmentFileNameWrapper */.q5, {
                                                device: state.device,
                                                fullWidth: true,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Variant/* Span */.Dr, {
                                                        size: "medium",
                                                        name: "paragraph",
                                                        children: attachmentItem.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Variant/* Span */.Dr, {
                                                        size: "medium",
                                                        name: "paragraph",
                                                        children: [
                                                            ".",
                                                            attachmentItem.extension
                                                        ]
                                                    })
                                                ]
                                            }),
                                            options: [
                                                {
                                                    label: trans("View CV"),
                                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PDFIcon/* default */.Z, {
                                                        width: 16,
                                                        height: 21,
                                                        className: "pdf-icon",
                                                        color: Colors/* colors.grey.50 */.O9.grey[50]
                                                    }),
                                                    isCloseOnClick: true,
                                                    onClick: function() {
                                                        var _NEXT_PUBLIC_MS_BASE_PATH, ref;
                                                        helpers/* downloadAttachFile */.jE({
                                                            resumeId: attachmentItem.id,
                                                            downloadRequest: "new-window",
                                                            msBaseUrl: (_NEXT_PUBLIC_MS_BASE_PATH = "https://ms.vietnamworks.com") !== null && _NEXT_PUBLIC_MS_BASE_PATH !== void 0 ? _NEXT_PUBLIC_MS_BASE_PATH : "",
                                                            accessToken: (ref = user === null || user === void 0 ? void 0 : user.accessToken) !== null && ref !== void 0 ? ref : "",
                                                            fileName: ""
                                                        });
                                                    }
                                                },
                                                {
                                                    label: trans("View as employer"),
                                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmployerViewIcon/* default */.Z, {
                                                        width: 16,
                                                        height: 21,
                                                        color: Colors/* colors.grey.50 */.O9.grey[50]
                                                    }),
                                                    isCloseOnClick: true,
                                                    onClick: function() {
                                                        window.open("".concat(constants/* vnwBasePath */.Io, "/").concat(trans("preview-resume"), "/").concat(attachmentItem === null || attachmentItem === void 0 ? void 0 : attachmentItem.id), "_blank");
                                                    }
                                                }
                                            ]
                                        })
                                    })
                                ]
                            }, attachmentItem.id);
                        })
                    }) : null,
                    isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Variant/* Paragraph */.nv, {
                        name: "body",
                        size: "small",
                        color: Colors/* colors.primary.40 */.O9.primary[40],
                        onClick: gotoProfileSetting,
                        style: {
                            marginTop: 10,
                            cursor: "pointer"
                        },
                        children: trans("Manage attached CVs")
                    }) : null
                ]
            })
        ]
    });
}
/* harmony default export */ var MakeProfileSearchable_Attachments = (/*#__PURE__*/react.memo(Attachments));

;// CONCATENATED MODULE: ./components/Page/ProfileSettings/MakeProfileSearchable/OnlineProfile.tsx
function OnlineProfile_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function OnlineProfile_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            OnlineProfile_defineProperty(target, key, source[key]);
        });
    }
    return target;
}







function OnlineProfile(param) {
    var trans = param.trans, searchableResume = param.searchableResume;
    var state = (0,store_0/* useStore */.oR)().state;
    var ref = (0,ProfileSetting/* useProfileSettingStore */.n2)(), settingState = ref.state, resumeId = ref.state.resumeId, disPatchSettingState = ref.setState;
    var profileSettingInfo = state.profileSettingInfo, profileLevel = state.profileLevel;
    var resumeSetting = profileSettingInfo.resumeSetting;
    var profile = resumeSetting.profileInfo;
    var attachment = resumeSetting.attachInfo;
    var onUpdateProfileBtnClick = function() {
        window.location.assign(trans("/my-profile"));
    };
    var haveProfile = (profile === null || profile === void 0 ? void 0 : profile.allowSearchableDisplay) === constants/* SEARCHABLE_ON */.eu;
    var isSearchable = profile.isSearchable === 1;
    var filteredSearchable = attachment.filter(function(item) {
        return item.isSearchable === 1;
    });
    if (filteredSearchable.length > 0) {
        isSearchable = true;
    }
    var currentResumeId = resumeId;
    if (searchableResume !== null && searchableResume.id && !isSearchable) {
        currentResumeId = searchableResume.id;
    }
    var _profileStrength;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                name: "label",
                size: "medium",
                color: Colors/* colors.grey.20 */.O9.grey[20],
                children: trans("By VietnamWorks profile")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OptionGroup/* OptionGroup */.Y, {
                value: String(profile.id),
                label: trans("VietnamWorks profile"),
                align: "left",
                styles: {
                    wrapperStyle: {
                        marginBottom: 0
                    }
                },
                name: constants/* ResumeType.Profile */.$P.Profile,
                onChange: function(res) {
                    return disPatchSettingState(OnlineProfile_objectSpread({}, settingState, {
                        resumeId: Number(res)
                    }));
                },
                disabled: !haveProfile,
                contentDisable: false,
                checked: profile.id === currentResumeId,
                children: [
                    haveProfile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(makeProfileSearchable_css/* ResumeDesc */.Jg, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Variant/* Paragraph */.nv, {
                            name: "label",
                            size: "small",
                            color: Colors/* colors.grey.60 */.O9.grey[60],
                            children: [
                                (_profileStrength = profileLevel.profileStrength) !== null && _profileStrength !== void 0 ? _profileStrength : 0,
                                "% ",
                                trans("completed")
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Variant/* Paragraph */.nv, {
                                name: "body",
                                size: "medium",
                                color: Colors/* colors.grey.20 */.O9.grey[20],
                                children: [
                                    trans("VietnamWorks profile"),
                                    ": ",
                                    trans("Not Approved")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Variant/* Paragraph */.nv, {
                                name: "body",
                                size: "medium",
                                color: Colors/* colors.grey.20 */.O9.grey[20],
                                style: {
                                    marginTop: 8
                                },
                                children: trans("To enable VietnamWorks Profile, your VietnamWorks Profile needs to be completed and approved.")
                            })
                        ]
                    }),
                    [
                        store_0/* EDevice.MOBILE */.a2.MOBILE,
                        store_0/* EDevice.TABLET */.a2.TABLET
                    ].includes(state.device) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            marginTop: 10,
                            display: "flex",
                            gap: 10,
                            flexWrap: "wrap"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                type: "info",
                                size: "sm",
                                outline: "outline",
                                onClick: onUpdateProfileBtnClick,
                                children: trans("Update profile")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                type: "info",
                                size: "sm",
                                outline: "outline",
                                onClick: function(e) {
                                    e.stopPropagation();
                                    window.open("".concat(constants/* vnwBasePath */.Io, "/").concat(trans("preview-resume"), "/").concat(profile.id), "_blank");
                                },
                                children: trans("View as employer")
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(makeProfileSearchable_css/* RightButtonWrapper */.FD, {
                        active: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                type: "info",
                                size: "sm",
                                outline: "outline",
                                onClick: onUpdateProfileBtnClick,
                                children: trans("Update profile")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                type: "info",
                                size: "sm",
                                outline: "outline",
                                onClick: function(e) {
                                    e.stopPropagation();
                                    window.open("".concat(constants/* vnwBasePath */.Io, "/").concat(trans("preview-resume"), "/").concat(profile.id), "_blank");
                                },
                                children: trans("View as employer")
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var MakeProfileSearchable_OnlineProfile = (/*#__PURE__*/react.memo(OnlineProfile));

// EXTERNAL MODULE: ./helpers/date.ts
var helpers_date = __webpack_require__(41978);
;// CONCATENATED MODULE: ./components/Page/ProfileSettings/MakeProfileSearchable/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function MakeProfileSearchable_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function MakeProfileSearchable_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                MakeProfileSearchable_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                MakeProfileSearchable_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function MakeProfileSearchable_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function MakeProfileSearchable_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            MakeProfileSearchable_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}











var MakeProfileSearchable = function(props) {
    var trans = props.trans;
    var state = (0,store_0/* useStore */.oR)().state;
    var profileSettingStore = (0,ProfileSetting/* useProfileSettingStore */.n2)();
    var settingState = profileSettingStore.state;
    var disPatchSettingState = profileSettingStore.setState;
    var profileSettingInfo = state.profileSettingInfo, user = state.user;
    var resumeSetting = profileSettingInfo.resumeSetting, resumeSettingOption = profileSettingInfo.resumeSettingOption;
    var ref7, _NEXT_PUBLIC_MS_BASE_PATH;
    var initDataMakeSearchable = {
        data: {
            resumes: _toConsumableArray([
                resumeSetting.profileInfo
            ]).concat(_toConsumableArray(resumeSetting.attachInfo)),
            profileSetting: profileSettingInfo.resumeSettingOption,
            searchableStatus: profileSettingInfo.searchableStatus,
            unContactable: profileSettingInfo.unContactable
        },
        accessToken: (ref7 = user === null || user === void 0 ? void 0 : user.accessToken) !== null && ref7 !== void 0 ? ref7 : "",
        langCode: state.langCode,
        baseMsUrl: (_NEXT_PUBLIC_MS_BASE_PATH = "https://ms.vietnamworks.com") !== null && _NEXT_PUBLIC_MS_BASE_PATH !== void 0 ? _NEXT_PUBLIC_MS_BASE_PATH : ""
    };
    var getRefresh = function() {
        var _ref = MakeProfileSearchable_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, response, ref2, ref3, ref4, ref5, date, ref6;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (user === null || user === void 0 ? void 0 : user.accessToken) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        _ctx.next = 5;
                        return (0,services/* apiGetRefresh */.Vi)(user === null || user === void 0 ? void 0 : user.accessToken);
                    case 5:
                        response = _ctx.sent;
                        if (!(((ref = response.meta) === null || ref === void 0 ? void 0 : ref.status) === 200)) {
                            _ctx.next = 12;
                            break;
                        }
                        ;
                        date = new Date();
                        date.setDate(date.getDate() + 15);
                        ;
                        return _ctx.abrupt("return", {
                            expiredDate: (0,helpers_date/* convertDateTime */.jF)(((ref2 = response.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.attributes) === null || ref3 === void 0 ? void 0 : ref3.expiredDate) || date, 7),
                            statusRefresh: (ref6 = (ref4 = response.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.attributes) === null || ref5 === void 0 ? void 0 : ref5.type) !== null && ref6 !== void 0 ? ref6 : 0
                        });
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getRefresh() {
            return _ref.apply(this, arguments);
        };
    }();
    var getOpenToWork = function() {
        var _ref = MakeProfileSearchable_asyncToGenerator(runtime_default().mark(function _callee() {
            var response, ref, ref8, ref9, ref10, ref11;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (user === null || user === void 0 ? void 0 : user.accessToken) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", [
                            false,
                            null
                        ]);
                    case 2:
                        _ctx.next = 4;
                        return (0,services/* apiGetOpenToWork */.oi)(user === null || user === void 0 ? void 0 : user.accessToken);
                    case 4:
                        response = _ctx.sent;
                        if (!(response.data && response.data.attributes)) {
                            _ctx.next = 9;
                            break;
                        }
                        ;
                        ;
                        return _ctx.abrupt("return", [
                            true,
                            {
                                isOpenToWork: ((ref = response.data) === null || ref === void 0 ? void 0 : (ref8 = ref.attributes) === null || ref8 === void 0 ? void 0 : ref8.isOpenToWork) === 1,
                                expiredOn: (ref11 = (ref9 = response.data) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.attributes) === null || ref10 === void 0 ? void 0 : ref10.openToWorkExpiredOn) !== null && ref11 !== void 0 ? ref11 : ""
                            }
                        ]);
                    case 9:
                        return _ctx.abrupt("return", [
                            false,
                            null
                        ]);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getOpenToWork() {
            return _ref.apply(this, arguments);
        };
    }();
    // TODO: Refactor Hooks.useMakeSearchable
    // to return an object instead of an array for improved usability.
    var ref1 = _slicedToArray(useMakeSearchable/* default */.ZP(initDataMakeSearchable), 4), _ = ref1[0], _1 = ref1[1], priorityResume = ref1[2], searchableResume = ref1[3];
    (0,react.useEffect)(function() {
        var _resumeSetting = profileSettingInfo.resumeSetting, attachInfo = _resumeSetting.attachInfo, profileInfo = _resumeSetting.profileInfo;
        var ref12;
        var currentSearchableResumeId = profileInfo.isSearchable === 1 ? profileInfo.id : (ref12 = priorityResume === null || priorityResume === void 0 ? void 0 : priorityResume.id) !== null && ref12 !== void 0 ? ref12 : 0;
        // Profile online is not searchable then maybe attach is searchable
        if (profileInfo.isSearchable === 0) {
            var filteredAttach = attachInfo.filter(function(item) {
                return item.isSearchable === 1;
            });
            if (filteredAttach.length > 0) {
                currentSearchableResumeId = filteredAttach[0].id;
            }
        }
        if (currentSearchableResumeId === 0 && (priorityResume === null || priorityResume === void 0 ? void 0 : priorityResume.id)) {
            currentSearchableResumeId = priorityResume === null || priorityResume === void 0 ? void 0 : priorityResume.id;
        }
        MakeProfileSearchable_asyncToGenerator(runtime_default().mark(function _callee() {
            var responseGetRefresh, ref, isOpenToWorkSuccess, responseOpenToWork, newProfileSettingState;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return getRefresh();
                    case 2:
                        responseGetRefresh = _ctx.sent;
                        _ctx.t0 = _slicedToArray;
                        _ctx.next = 6;
                        return getOpenToWork();
                    case 6:
                        _ctx.t1 = _ctx.sent;
                        ref = (0, _ctx.t0)(_ctx.t1, 2);
                        isOpenToWorkSuccess = ref[0];
                        responseOpenToWork = ref[1];
                        newProfileSettingState = MakeProfileSearchable_objectSpread({}, settingState, {
                            resumeId: currentSearchableResumeId
                        }, responseGetRefresh);
                        if (isOpenToWorkSuccess && responseOpenToWork !== null) {
                            newProfileSettingState.isOpenToWork = responseOpenToWork.isOpenToWork;
                        }
                        disPatchSettingState(newProfileSettingState);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    }, [
        profileSettingInfo,
        priorityResume
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(makeProfileSearchable_css/* Section */.$0, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                name: "title",
                size: "medium",
                color: Colors/* colors.grey.20 */.O9.grey[20],
                children: trans("Default searchable CV")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MakeProfileSearchable_OnlineProfile, {
                trans: trans,
                searchableResume: searchableResume
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MakeProfileSearchable_Attachments, {
                trans: trans,
                searchableResume: searchableResume
            })
        ]
    });
};
/* harmony default export */ var ProfileSettings_MakeProfileSearchable = (/*#__PURE__*/(0,react.memo)(MakeProfileSearchable));

;// CONCATENATED MODULE: ./components/Page/ProfileSettings/style.css.tsx
function style_css_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function style_css_templateObject() {
    var data = style_css_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    gap: ",
        ";\n"
    ]);
    style_css_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function style_css_templateObject1() {
    var data = style_css_taggedTemplateLiteral([
        "\n            background-color: white;\n            border-radius: 6px;\n            padding: 24px;\n        "
    ]);
    style_css_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function style_css_templateObject2() {
    var data = style_css_taggedTemplateLiteral([
        "\n            background-color: #f0f0f0;\n        "
    ]);
    style_css_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function style_css_templateObject3() {
    var data = style_css_taggedTemplateLiteral([
        "\n    ",
        "\n    ",
        "\n"
    ]);
    style_css_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function style_css_templateObject4() {
    var data = style_css_taggedTemplateLiteral([
        "\n    font-weight: 600;\n    font-size: 16px;\n"
    ]);
    style_css_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function style_css_templateObject5() {
    var data = style_css_taggedTemplateLiteral([
        "\n    display: flex;\n    align-items: center;\n"
    ]);
    style_css_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function style_css_templateObject6() {
    var data = style_css_taggedTemplateLiteral([
        "\n    background-color: #EBF2FF;\n    display: inline-block;\n    padding: 2px 4px;\n    border-radius: 4px;\n    margin-left: 4px;\n    color: ",
        ";\n"
    ]);
    style_css_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-146d20ab-0"
})(style_css_templateObject(), function(param) {
    var gap = param.gap;
    return gap ? "".concat(gap, "px") : "16px";
});
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-146d20ab-1"
})(style_css_templateObject3(), function(param) {
    var isMobile = param.isMobile;
    return !isMobile && (0,styled_components_browser_esm/* css */.iv)(style_css_templateObject1());
}, function(param) {
    var notHaveCV = param.notHaveCV;
    return notHaveCV && (0,styled_components_browser_esm/* css */.iv)(style_css_templateObject2());
});
var Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-146d20ab-2"
})(style_css_templateObject4());
var TitleWrapper = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).withConfig({
    componentId: "sc-146d20ab-3"
})(style_css_templateObject5());
var TagNew = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).withConfig({
    componentId: "sc-146d20ab-4"
})(style_css_templateObject6(), Colors/* colors.primary.40 */.O9.primary[40]);

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var Utils_constants = __webpack_require__(96306);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/CheckBox/index.js + 1 modules
var CheckBox = __webpack_require__(95140);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useFloating/index.js + 17 modules
var useFloating = __webpack_require__(80200);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useDropdownAnimation.js
var useDropdownAnimation = __webpack_require__(91623);
;// CONCATENATED MODULE: ./components/Page/ProfileSettings/images/InfoIcon/index.tsx

var InfoIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 17",
        fill: "none",
        style: props.style,
        onClick: function() {
            return props.onClick && props.onClick();
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M8.00001 2.49219C4.46561 2.49219 1.60001 5.35779 1.60001 8.89219C1.60001 12.4266 4.46561 15.2922 8.00001 15.2922C11.5344 15.2922 14.4 12.4266 14.4 8.89219C14.4 5.35779 11.5344 2.49219 8.00001 2.49219ZM8.53334 12.0922H7.46667V8.35885H8.53334V12.0922ZM8.00001 7.02552C7.55841 7.02552 7.20001 6.66712 7.20001 6.22552C7.20001 5.78392 7.55841 5.42552 8.00001 5.42552C8.44161 5.42552 8.80001 5.78392 8.80001 6.22552C8.80001 6.66712 8.44161 7.02552 8.00001 7.02552Z",
            fill: "#AEAEAE"
        })
    });
};
/* harmony default export */ var images_InfoIcon = (InfoIcon);

;// CONCATENATED MODULE: ./components/PreviewJobStatus/PreviewJobStatus.css.tsx
function PreviewJobStatus_css_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function PreviewJobStatus_css_templateObject() {
    var data = PreviewJobStatus_css_taggedTemplateLiteral([
        "\n    z-index: 100;\n"
    ]);
    PreviewJobStatus_css_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PreviewJobStatus_css_templateObject1() {
    var data = PreviewJobStatus_css_taggedTemplateLiteral([
        "\n    background: #fff;\n    border-radius: 12px;\n    padding: 16px;\n    margin-bottom: 8px;\n    filter: drop-shadow(0px 2px 8px rgba(51, 51, 51, 0.15));\n    min-width: 560px;\n    @media screen and (max-width: 768px) {\n        min-width: 100%;\n    }\n    &::before {\n        content: '';\n        width: 0;\n        height: 0;\n        border-left: 12px solid transparent;\n        border-right: 12px solid transparent;\n        border-top: 12px solid #fff;\n        position: absolute;\n        bottom: -10px;\n        left: 0;\n        right: 0;\n        margin: auto;\n        filter: drop-shadow(0px 2px 8px rgba(51, 51, 51, 0.15));\n    }\n"
    ]);
    PreviewJobStatus_css_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PreviewJobStatus_css_templateObject2() {
    var data = PreviewJobStatus_css_taggedTemplateLiteral([
        "\n    margin-top: 8px;\n    padding: 8px 16px;\n    border-radius: 12px;\n    border: 1px solid ",
        ";\n    display: flex;\n"
    ]);
    PreviewJobStatus_css_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PreviewJobStatus_css_templateObject3() {
    var data = PreviewJobStatus_css_taggedTemplateLiteral([
        "\n    width: 60px;\n    height: 60px;\n    border-radius: 100%;\n"
    ]);
    PreviewJobStatus_css_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PreviewJobStatus_css_templateObject4() {
    var data = PreviewJobStatus_css_taggedTemplateLiteral([
        "\n    margin-left: 16px;\n"
    ]);
    PreviewJobStatus_css_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function PreviewJobStatus_css_templateObject5() {
    var data = PreviewJobStatus_css_taggedTemplateLiteral([
        "\n    display: flex;\n    height: 32px;\n    align-items: center;\n    justify-content: space-between;\n    p {\n        width: calc(100% - 36px);\n    }\n"
    ]);
    PreviewJobStatus_css_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function PreviewJobStatus_css_templateObject6() {
    var data = PreviewJobStatus_css_taggedTemplateLiteral([
        "\n    margin-left: 4px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    > svg {\n        vertical-align: top;\n    }\n    &:hover {\n        svg path {\n            fill: #333;\n        }\n    }\n"
    ]);
    PreviewJobStatus_css_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var PreviewJobStatusWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-df77f030-0"
})(PreviewJobStatus_css_templateObject());
var PreviewJobSeekingStatus = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-df77f030-1"
})(PreviewJobStatus_css_templateObject1());
var PreviewUserInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-df77f030-2"
})(PreviewJobStatus_css_templateObject2(), Colors/* colors.grey.90 */.O9.grey[90]);
var UserAvatar = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-df77f030-3"
})(PreviewJobStatus_css_templateObject3());
var UserInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-df77f030-4"
})(PreviewJobStatus_css_templateObject4());
var PreviewTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-df77f030-5"
})(PreviewJobStatus_css_templateObject5());
var IconButton = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-df77f030-6"
})(PreviewJobStatus_css_templateObject6());

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Images/CloseIcon/index.js
var CloseIcon = __webpack_require__(54033);
// EXTERNAL MODULE: ./components/Global/MainLayout/SideNavigation/images/DefaultAvatarIcon.tsx
var DefaultAvatarIcon = __webpack_require__(68321);
// EXTERNAL MODULE: ./helpers/util.ts
var util = __webpack_require__(5672);
;// CONCATENATED MODULE: ./components/PreviewJobStatus/index.tsx











var PreviewJobStatus = function() {
    var state = (0,store_0/* useStore */.oR)().state;
    var user = state.user, t = state.t;
    var ref3 = (0,react.useState)(false), isShow = ref3[0], setIsShow = ref3[1];
    var ref1 = (0,useFloating/* default */.Z)({
        placement: "top",
        position: "fixed",
        config: {
            useWindowAsFlippingContainer: false,
            isFlip: false,
            detectHidden: false
        }
    }), refs = ref1.refs, context = ref1.context, FloatingPortal = ref1.FloatingPortal;
    (0,react.useEffect)(function() {
        var onClick = function(event) {
            var ref;
            var el = (ref = refs.popup) === null || ref === void 0 ? void 0 : ref.current;
            if (!el || el.contains(event.target)) {
                return;
            }
            if (!isShow) {
                return;
            }
            setIsShow(false);
        };
        window.addEventListener("mouseup", onClick);
        return function() {
            window.removeEventListener("mouseup", onClick);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isShow
    ]);
    var dropdownStyle = {
        position: context.position,
        top: context.y,
        left: context.x,
        display: context.isReferenceHidden ? "none" : "block"
    };
    var ref2 = (0,useDropdownAnimation/* default */.Z)(isShow, context.placement), isMounted = ref2.isMounted, styles = ref2.styles;
    var fullName = state.langCode === Utils_constants/* ELanguage.VI */.Df.VI ? "".concat(user === null || user === void 0 ? void 0 : user.lastName, " ").concat(user === null || user === void 0 ? void 0 : user.firstName) : "".concat(user === null || user === void 0 ? void 0 : user.firstName, " ").concat(user === null || user === void 0 ? void 0 : user.lastName);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton, {
                ref: refs.setReference,
                onMouseOver: function() {
                    return setIsShow(true);
                },
                onMouseOut: function() {
                    return setIsShow(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(images_InfoIcon, {
                    onClick: function() {
                        return setIsShow(!isShow);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingPortal, {
                children: isMounted ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewJobStatusWrapper, {
                    ref: refs.setPopup,
                    style: dropdownStyle,
                    "data-floating-placement": context.placement,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PreviewJobSeekingStatus, {
                        style: styles,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PreviewTitle, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        name: "body",
                                        size: "medium",
                                        color: Colors/* colors.grey.20 */.O9.grey[20],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            dangerouslySetInnerHTML: {
                                                __html: t('Your searchable profile will be more outstanding with <strong>"Open to work"</strong> tag')
                                            }
                                        })
                                    }),
                                    (0,util/* isMobile */.tq)() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton, {
                                        onClick: function() {
                                            return setIsShow(false);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon/* default */.Z, {})
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PreviewUserInfo, {
                                children: [
                                    (user === null || user === void 0 ? void 0 : user.profilePicture) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAvatar, {
                                        src: user === null || user === void 0 ? void 0 : user.profilePicture
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultAvatarIcon/* default */.Z, {
                                        width: 60
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserInfo, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                name: "title",
                                                size: "extraLarge",
                                                style: {
                                                    display: "flex",
                                                    alignItems: "center"
                                                },
                                                children: [
                                                    fullName,
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TagNew, {
                                                        name: "label",
                                                        size: "small",
                                                        style: {
                                                            marginTop: 1
                                                        },
                                                        children: t("Open to work")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                style: {
                                                    marginTop: 8
                                                },
                                                children: user === null || user === void 0 ? void 0 : user.jobTitle
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
            })
        ]
    });
};
/* harmony default export */ var components_PreviewJobStatus = (PreviewJobStatus);

;// CONCATENATED MODULE: ./components/Page/ProfileSettings/ProfileStatus/index.tsx
function ProfileStatus_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ProfileStatus_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ProfileStatus_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ProfileStatus_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ProfileStatus_templateObject() {
    var data = ProfileStatus_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n"
    ]);
    ProfileStatus_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var Box = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-619aeeae-0"
})(ProfileStatus_templateObject());
function ProfileStatus(param) {
    var trans = param.trans;
    var ref7 = (0,ProfileSetting/* useProfileSettingStore */.n2)(), state = ref7.state, setState = ref7.setState;
    var store = (0,store_0/* useStore */.oR)().state;
    var resumeDetail = store.resumeDetail;
    var renderContentDate = function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        if (!state.isOpenToWork) return "";
        var date = new Date();
        date.setDate(date.getDate() + 30);
        // Current state when user not save yet
        var isSaved = (resumeDetail === null || resumeDetail === void 0 ? void 0 : (ref = resumeDetail.basicInfo) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.attributes) === null || ref2 === void 0 ? void 0 : ref2.isOpenToWork) === 1 === state.isOpenToWork;
        var ref6;
        var openToWorkExpiredOn = (ref6 = resumeDetail === null || resumeDetail === void 0 ? void 0 : (ref3 = resumeDetail.basicInfo) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.attributes) === null || ref5 === void 0 ? void 0 : ref5.openToWorkExpiredOn) !== null && ref6 !== void 0 ? ref6 : "";
        var expiredDate = (0,helpers_date/* convertDateTime */.jF)(isSaved ? openToWorkExpiredOn : date, 7);
        return "".concat(trans("The status is set until"), " ").concat(expiredDate);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleWrapper, {
                name: "title",
                size: "medium",
                color: Colors/* colors.grey.20 */.O9.grey[20],
                children: [
                    trans("Job-seeking status"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TagNew, {
                        name: "label",
                        size: "small",
                        color: Colors/* colors.primary.40 */.O9.primary[40],
                        children: trans("New")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PreviewJobStatus, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                name: "body",
                size: "medium",
                children: [
                    trans("Select Open to work to attract more employers"),
                    ". ",
                    renderContentDate()
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBox/* default */.Z, {
                label: trans("I am open to work"),
                style: {
                    padding: 0
                },
                state: state.isOpenToWork ? "checked" : "none",
                onCheckChange: function(value) {
                    setState(ProfileStatus_objectSpread({}, state, {
                        isOpenToWork: value === "checked"
                    }));
                }
            })
        ]
    });
}
/* harmony default export */ var ProfileSettings_ProfileStatus = (/*#__PURE__*/(0,react.memo)(ProfileStatus));

// EXTERNAL MODULE: ./components/Page/ProfileSettings/type.ts
var type = __webpack_require__(97282);
;// CONCATENATED MODULE: ./components/Page/ProfileSettings/index.tsx
function ProfileSettings_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ProfileSettings_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ProfileSettings_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return ProfileSettings_arrayLikeToArray(arr);
}
function ProfileSettings_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function ProfileSettings_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ProfileSettings_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ProfileSettings_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ProfileSettings_slicedToArray(arr, i) {
    return ProfileSettings_arrayWithHoles(arr) || ProfileSettings_iterableToArrayLimit(arr, i) || ProfileSettings_unsupportedIterableToArray(arr, i) || ProfileSettings_nonIterableRest();
}
function ProfileSettings_toConsumableArray(arr) {
    return ProfileSettings_arrayWithoutHoles(arr) || ProfileSettings_iterableToArray(arr) || ProfileSettings_unsupportedIterableToArray(arr) || ProfileSettings_nonIterableSpread();
}
function ProfileSettings_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ProfileSettings_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ProfileSettings_arrayLikeToArray(o, minLen);
}













var BASE_PATH = "https://ms.vietnamworks.com";
var REFRESH_PROFILE_API = "".concat(BASE_PATH).concat(constants/* API_REFRESH_PROFILE */.nk);
function ProfileSettings() {
    var ref = (0,react.useState)(true), loadingSearchable = ref[0], setLoadingSearchable = ref[1];
    var _state = (0,store_0/* useStore */.oR)().state, langCode = _state.langCode, profileSettingInfo = _state.profileSettingInfo, user = _state.user, isShowPopupSetting = _state.isShowPopupSetting;
    var _state1 = (0,ProfileSetting/* useProfileSettingStore */.n2)().state, isOpenToWork = _state1.isOpenToWork, statusRefresh = _state1.statusRefresh;
    var tracking = (0,useHog/* default */.Z)().tracking;
    var isSentViewProfileSettingRef = (0,react.useRef)(false);
    var trans = helpers/* createTranslator */.eX({
        translations: translations/* default */.Z,
        currentLanguage: langCode,
        defaultLanguage: Utils_constants/* ELanguage.EN */.Df.EN
    });
    var resumeSetting = profileSettingInfo.resumeSetting, resumeSettingOption = profileSettingInfo.resumeSettingOption;
    var ref1, _NEXT_PUBLIC_MS_BASE_PATH;
    var initDataMakeSearchable = {
        data: {
            resumes: ProfileSettings_toConsumableArray([
                resumeSetting.profileInfo
            ]).concat(ProfileSettings_toConsumableArray(resumeSetting.attachInfo)),
            profileSetting: resumeSettingOption,
            searchableStatus: profileSettingInfo.searchableStatus,
            unContactable: profileSettingInfo.unContactable
        },
        accessToken: (ref1 = user === null || user === void 0 ? void 0 : user.accessToken) !== null && ref1 !== void 0 ? ref1 : "",
        langCode: langCode,
        baseMsUrl: (_NEXT_PUBLIC_MS_BASE_PATH = "https://ms.vietnamworks.com") !== null && _NEXT_PUBLIC_MS_BASE_PATH !== void 0 ? _NEXT_PUBLIC_MS_BASE_PATH : ""
    };
    var ref2 = ProfileSettings_slicedToArray(useMakeSearchable/* default */.ZP(initDataMakeSearchable), 1), resumeStatusDetail = ref2[0];
    (0,react.useEffect)(function() {
        if (!isShowPopupSetting || statusRefresh > 0 && !resumeStatusDetail.isSearchable || isSentViewProfileSettingRef.current) {
            return;
        }
        var statusRefreshText = "Unset";
        if (statusRefresh === type/* ERefreshProfile.Daily */.m.Daily) {
            statusRefreshText = "Daily";
        } else if (statusRefresh === type/* ERefreshProfile.Weekly */.m.Weekly) {
            statusRefreshText = "Weekly";
        }
        tracking({
            eventName: "js_profile_management:view_profile_settings",
            properties: {
                isOpenToWork: isOpenToWork,
                statusRefresh: statusRefreshText,
                statusRefreshId: statusRefresh,
                isSearchable: resumeStatusDetail.isSearchable
            }
        });
        isSentViewProfileSettingRef.current = true;
    }, [
        resumeStatusDetail,
        isShowPopupSetting
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileSettings_MakeProfileSearchable, {
                urlRefresh: REFRESH_PROFILE_API,
                loadingSearchable: loadingSearchable,
                setLoadingSearchable: function(e) {
                    return setLoadingSearchable(e);
                },
                trans: trans
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                gap: 24,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileSettings_ProfileStatus, {
                        trans: trans
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RefreshMyProfile, {
                        trans: trans
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HideMyProfile, {
                        trans: trans
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 80117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$t": function() { return /* binding */ apiUpdateResumeSetting; },
/* harmony export */   "Do": function() { return /* binding */ apiGetUnHiddenCompany; },
/* harmony export */   "I9": function() { return /* binding */ apiMakeRefresh; },
/* harmony export */   "Oy": function() { return /* binding */ apiUpdateUserHiddenCompanyName; },
/* harmony export */   "U3": function() { return /* binding */ apiUpdateUserHiddenDomain; },
/* harmony export */   "U4": function() { return /* binding */ apiGetUserHiddenCompanyName; },
/* harmony export */   "Vi": function() { return /* binding */ apiGetRefresh; },
/* harmony export */   "iF": function() { return /* binding */ apiGetResumeInfo; },
/* harmony export */   "mS": function() { return /* binding */ apiGetUserHiddenDomains; },
/* harmony export */   "oi": function() { return /* binding */ apiGetOpenToWork; }
/* harmony export */ });
/* unused harmony exports apiGetResumeLevel, apiChangeSearchable, apiAttachmentList */
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72072);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


var BASE_PATH = "https://ms.vietnamworks.com";
var REFRESH_PROFILE_API = "".concat(BASE_PATH).concat(_constants__WEBPACK_IMPORTED_MODULE_1__/* .API_REFRESH_PROFILE */ .nk);
var OPEN_TO_WORK_API = "".concat(BASE_PATH).concat(_constants__WEBPACK_IMPORTED_MODULE_1__/* .API_GET_OPEN_TO_WORK */ .H9);
var GET_RESUME_INFO_API = "".concat(BASE_PATH).concat(_constants__WEBPACK_IMPORTED_MODULE_1__/* .API_GET_RESUME_INFO */ .AT, "?date=").concat(Date.now());
var GET_LEVEL_PROFILE_API = "".concat(BASE_PATH).concat(_constants__WEBPACK_IMPORTED_MODULE_1__/* .API_LEVEL_PROFILE */ .DC);
var GET_NAME_API = "".concat(BASE_PATH).concat(_constants__WEBPACK_IMPORTED_MODULE_1__/* .API_GET_NAME */ .aY);
var GET_NAME_UNHIDDEN_API = "".concat(BASE_PATH).concat(_constants__WEBPACK_IMPORTED_MODULE_1__/* .API_GET_NAME_UNHIDDEN */ .C_);
var UPDATE_DOMAIN_API = "".concat(BASE_PATH).concat(_constants__WEBPACK_IMPORTED_MODULE_1__/* .API_UPDATE_DOMAIN */ .T_);
var GET_DOMAIN_API = "".concat(BASE_PATH).concat(_constants__WEBPACK_IMPORTED_MODULE_1__/* .API_GET_DOMAIN */ .xv);
var UPDATE_NAME_API = "".concat(BASE_PATH).concat(_constants__WEBPACK_IMPORTED_MODULE_1__/* .API_UPDATE_NAME */ .jA);
var CHANGE_SEARCHABLE_API = "".concat(BASE_PATH).concat(_constants__WEBPACK_IMPORTED_MODULE_1__/* .API_CHANGE_SEARCHABLE */ .Ye);
var UPDATE_RESUME_SETTING_OPTION_API = "".concat(BASE_PATH).concat(_constants__WEBPACK_IMPORTED_MODULE_1__/* .API_UPDATE_RESUME_SETTING_OPTION */ .$5);
var GET_RESUME_ATTACHMENT_LIST_API = "".concat(BASE_PATH).concat(_constants__WEBPACK_IMPORTED_MODULE_1__/* .API_GET_RESUME_ATTACHMENT_LIST */ .Kw, "?date=").concat(Date.now());
var apiGetUnHiddenCompany = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(token, langCode) {
        var companyName, savedJobResponse, _args = arguments;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    companyName = _args.length > 2 && _args[2] !== void 0 ? _args[2] : "";
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return fetch(GET_NAME_UNHIDDEN_API, {
                        method: "POST",
                        headers: {
                            Authorization: "Bearer ".concat(token),
                            "Content-Type": "application/json",
                            "Accept-Language": langCode
                        },
                        body: JSON.stringify({
                            companyName: companyName
                        })
                    });
                case 4:
                    savedJobResponse = _ctx.sent;
                    _ctx.next = 7;
                    return savedJobResponse.json();
                case 7:
                    return _ctx.abrupt("return", _ctx.sent);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](1);
                    console.log("apiGetUnHiddenCompany ", _ctx.t0);
                    return _ctx.abrupt("return", []);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                10
            ]
        ]);
    }));
    return function apiGetUnHiddenCompany(token, langCode) {
        return _ref.apply(this, arguments);
    };
}();
var apiGetUserHiddenDomains = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(token) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return fetch(GET_DOMAIN_API, {
                        method: "GET",
                        headers: {
                            Authorization: "Bearer ".concat(token),
                            "Content-Type": "application/json"
                        }
                    });
                case 3:
                    response = _ctx.sent;
                    _ctx.next = 6;
                    return response.json();
                case 6:
                    return _ctx.abrupt("return", _ctx.sent);
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log("apiGetUserHiddenDomains ", _ctx.t0);
                    return _ctx.abrupt("return", []);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                9
            ]
        ]);
    }));
    return function apiGetUserHiddenDomains(token) {
        return _ref.apply(this, arguments);
    };
}();
var apiGetUserHiddenCompanyName = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(token) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return fetch(GET_NAME_API, {
                        method: "GET",
                        headers: {
                            Authorization: "Bearer ".concat(token),
                            "Content-Type": "application/json"
                        }
                    });
                case 3:
                    response = _ctx.sent;
                    _ctx.next = 6;
                    return response.json();
                case 6:
                    return _ctx.abrupt("return", _ctx.sent);
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log("apiGetUserHiddenCompanyName ", _ctx.t0);
                    return _ctx.abrupt("return", []);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                9
            ]
        ]);
    }));
    return function apiGetUserHiddenCompanyName(token) {
        return _ref.apply(this, arguments);
    };
}();
var apiUpdateUserHiddenDomain = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(accessToken, langCode) {
        var data, response, _args = arguments;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    data = _args.length > 2 && _args[2] !== void 0 ? _args[2] : {
                        domain: "",
                        type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .UPDATE_TYPE.ADD */ .vi.ADD
                    };
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return fetch(UPDATE_DOMAIN_API, {
                        method: "POST",
                        headers: {
                            Authorization: "Bearer ".concat(accessToken),
                            "Content-Type": "application/json",
                            "Accept-Language": langCode
                        },
                        body: JSON.stringify(data)
                    });
                case 4:
                    response = _ctx.sent;
                    _ctx.next = 7;
                    return response.json();
                case 7:
                    return _ctx.abrupt("return", _ctx.sent);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](1);
                    console.log("apiUpdateUserHiddenDomain ", _ctx.t0);
                    return _ctx.abrupt("return", []);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                10
            ]
        ]);
    }));
    return function apiUpdateUserHiddenDomain(accessToken, langCode) {
        return _ref.apply(this, arguments);
    };
}();
var apiUpdateUserHiddenCompanyName = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(accessToken, langCode) {
        var data, response, _args = arguments;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    data = _args.length > 2 && _args[2] !== void 0 ? _args[2] : {
                        taxCode: "",
                        type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .UPDATE_TYPE.ADD */ .vi.ADD
                    };
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return fetch(UPDATE_NAME_API, {
                        method: "POST",
                        headers: {
                            Authorization: "Bearer ".concat(accessToken),
                            "Content-Type": "application/json",
                            "Accept-Language": langCode
                        },
                        body: JSON.stringify(data)
                    });
                case 4:
                    response = _ctx.sent;
                    _ctx.next = 7;
                    return response.json();
                case 7:
                    return _ctx.abrupt("return", _ctx.sent);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](1);
                    console.log("apiUpdateUserHiddenCompanyName ", _ctx.t0);
                    return _ctx.abrupt("return", []);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                10
            ]
        ]);
    }));
    return function apiUpdateUserHiddenCompanyName(accessToken, langCode) {
        return _ref.apply(this, arguments);
    };
}();
var apiGetResumeLevel = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(token) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return fetch(GET_LEVEL_PROFILE_API, {
                        method: "GET",
                        headers: {
                            Authorization: "Bearer ".concat(token),
                            "Content-Type": "application/json"
                        }
                    });
                case 3:
                    response = _ctx.sent;
                    _ctx.next = 6;
                    return response.json();
                case 6:
                    return _ctx.abrupt("return", _ctx.sent);
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log("apiGetResumeLevel ", _ctx.t0);
                    return _ctx.abrupt("return", []);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                9
            ]
        ]);
    }));
    return function apiGetResumeLevel(token) {
        return _ref.apply(this, arguments);
    };
}();
var apiChangeSearchable = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(accessToken, langCode) {
        var data, changeSearchableResponse, _args = arguments;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    data = _args.length > 2 && _args[2] !== void 0 ? _args[2] : {
                        resumeId: -1,
                        searchAble: false
                    };
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return fetch(CHANGE_SEARCHABLE_API, {
                        method: "POST",
                        headers: {
                            Authorization: "Bearer ".concat(accessToken),
                            "Content-Type": "application/json",
                            "Accept-Language": langCode
                        },
                        body: JSON.stringify(data)
                    });
                case 4:
                    changeSearchableResponse = _ctx.sent;
                    _ctx.next = 7;
                    return changeSearchableResponse.json();
                case 7:
                    return _ctx.abrupt("return", _ctx.sent);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](1);
                    console.log("apiChangeSearchable ", _ctx.t0);
                    return _ctx.abrupt("return", []);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                10
            ]
        ]);
    }));
    return function apiChangeSearchable(accessToken, langCode) {
        return _ref.apply(this, arguments);
    };
}();
var apiGetResumeInfo = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(accessToken) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return fetch(GET_RESUME_INFO_API, {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            "Cache-Control": "no-cache",
                            Pragma: "no-cache",
                            Expires: "0",
                            Authorization: "Bearer ".concat(accessToken)
                        }
                    });
                case 3:
                    response = _ctx.sent;
                    _ctx.next = 6;
                    return response.json();
                case 6:
                    return _ctx.abrupt("return", _ctx.sent);
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log("apiGetResumeInfo ", _ctx.t0);
                    return _ctx.abrupt("return", {});
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                9
            ]
        ]);
    }));
    return function apiGetResumeInfo(accessToken) {
        return _ref.apply(this, arguments);
    };
}();
var apiGetOpenToWork = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(accessToken) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return fetch(OPEN_TO_WORK_API, {
                        method: "GET",
                        headers: {
                            Authorization: "Bearer ".concat(accessToken),
                            "Content-Type": "application/json"
                        }
                    });
                case 3:
                    response = _ctx.sent;
                    _ctx.next = 6;
                    return response.json();
                case 6:
                    return _ctx.abrupt("return", _ctx.sent);
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log("apiGetOpenToWork ", _ctx.t0);
                    return _ctx.abrupt("return", null);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                9
            ]
        ]);
    }));
    return function apiGetOpenToWork(accessToken) {
        return _ref.apply(this, arguments);
    };
}();
var apiGetRefresh = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(token) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return fetch(REFRESH_PROFILE_API, {
                        method: "GET",
                        headers: {
                            Authorization: "Bearer ".concat(token),
                            "Content-Type": "application/json"
                        }
                    });
                case 3:
                    response = _ctx.sent;
                    _ctx.next = 6;
                    return response.json();
                case 6:
                    return _ctx.abrupt("return", _ctx.sent);
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log("apiGetRefresh ", _ctx.t0);
                    return _ctx.abrupt("return", []);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                9
            ]
        ]);
    }));
    return function apiGetRefresh(token) {
        return _ref.apply(this, arguments);
    };
}();
var apiMakeRefresh = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(accessToken, language) {
        var data, makeRefreshResponse, _args = arguments;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    data = _args.length > 2 && _args[2] !== void 0 ? _args[2] : {
                        type: -1,
                        status: 0
                    };
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return fetch(REFRESH_PROFILE_API, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer ".concat(accessToken),
                            "Accept-Language": language
                        },
                        body: JSON.stringify(data)
                    });
                case 4:
                    makeRefreshResponse = _ctx.sent;
                    _ctx.next = 7;
                    return makeRefreshResponse.json();
                case 7:
                    return _ctx.abrupt("return", _ctx.sent);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](1);
                    console.log("apiMakeRefresh ", _ctx.t0);
                    return _ctx.abrupt("return", []);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                10
            ]
        ]);
    }));
    return function apiMakeRefresh(accessToken, language) {
        return _ref.apply(this, arguments);
    };
}();
var apiUpdateResumeSetting = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(accessToken, language) {
        var data, makeRefreshResponse, _args = arguments;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    data = _args.length > 2 && _args[2] !== void 0 ? _args[2] : {
                        chooseCV: "",
                        chooseRefreshType: 0,
                        resumeId: -1
                    };
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return fetch(UPDATE_RESUME_SETTING_OPTION_API, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer ".concat(accessToken),
                            "Accept-Language": language
                        },
                        body: JSON.stringify(data)
                    });
                case 4:
                    makeRefreshResponse = _ctx.sent;
                    _ctx.next = 7;
                    return makeRefreshResponse.json();
                case 7:
                    return _ctx.abrupt("return", _ctx.sent);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](1);
                    console.log("apiUpdateResumeSetting ", _ctx.t0);
                    return _ctx.abrupt("return", []);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                10
            ]
        ]);
    }));
    return function apiUpdateResumeSetting(accessToken, language) {
        return _ref.apply(this, arguments);
    };
}();
var apiAttachmentList = function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(accessToken) {
        var response;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return fetch(GET_RESUME_ATTACHMENT_LIST_API, {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            "Cache-Control": "no-cache",
                            Pragma: "no-cache",
                            Expires: "0",
                            Authorization: "Bearer ".concat(accessToken)
                        }
                    });
                case 3:
                    response = _ctx.sent;
                    _ctx.next = 6;
                    return response.json();
                case 6:
                    return _ctx.abrupt("return", _ctx.sent);
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](0);
                    console.log("apiAttachmentList ", _ctx.t0);
                    return _ctx.abrupt("return", []);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                9
            ]
        ]);
    }));
    return function apiAttachmentList(accessToken) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 22825:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var translations = {
    Add: "Th\xeam",
    Remove: "Xo\xe1",
    Change: "Thay \u0111\u1ED5i",
    Save: "L\u01B0u",
    Cancel: "H\u1EE7y",
    "Save Changes": "L\u01B0u Thay \u0110\u1ED5i",
    "Save changes!": "L\u01B0u Thay \u0110\u1ED5i!",
    "Hide Profile": "\u1EA8n H\u1ED3 S\u01A1",
    "Hide My Profile": "\u1EA8n H\u1ED3 S\u01A1 C\u1EE7a T\xf4i",
    "To these companies": "V\u1EDBi nh\u1EEFng c\xf4ng ty  n\xe0y",
    "Add a company to hide your CV": "Th\xeam c\xf4ng ty \u0111\u1EC3 \u1EA9n h\u1ED3 s\u01A1",
    "Add company": "Th\xeam c\xf4ng ty",
    "Enter at least 3 letters": "H\xe3y nh\u1EADp \xedt nh\u1EA5t 3 k\xfd t\u1EF1 t\xean c\u1EE7a c\xf4ng ty",
    "Sorry can't add more than 9": "Xin l\u1ED7i, b\u1EA1n kh\xf4ng th\u1EC3 th\xeam h\u01A1n 9 c\xf4ng ty",
    "Max number of {0} companies reached": "\u0110\u01B0\u1EE3c th\xeam t\u1ED1i \u0111a {0} nh\xe0 tuy\u1EC3n d\u1EE5ng",
    "Please delete first before add other companies": "H\xe3y xo\xe1 b\u1EDBt tr\u01B0\u1EDBc khi th\xeam nh\xe0 tuy\u1EC3n d\u1EE5ng kh\xe1c",
    "Loading...": "\u0110ang t\u1EA3i...",
    "No result found...": "Kh\xf4ng c\xf3 k\u1EBFt qu\u1EA3...",
    "No options": "Kh\xf4ng c\xf3 l\u1EF1a ch\u1ECDn",
    "Enter company's email domain": "Nh\u1EADp domain email c\xf4ng ty",
    Recommended: "\u0110\u01B0\u1EE3c \u0111\u1EC1 ngh\u1ECB",
    Status: "Tr\u1EA1ng th\xe1i",
    On: "B\u1EADt",
    Off: "T\u1EAFt",
    "Or enter a company name": "Ho\u1EB7c nh\u1EADp t\xean c\xf4ng ty",
    "At least 3 letters": "\xcdt nh\u1EA5t 3 k\xfd t\u1EF1",
    "Hide My profile from Company": "\u1EA8n h\u1ED3 s\u01A1 c\u1EE7a t\xf4i v\u1EDBi c\xe1c c\xf4ng ty",
    "Listing the company that you do not allow searching your cv.": "Danh s\xe1ch c\xf4ng ty",
    "Profile Settings": "Thi\u1EBFt l\u1EADp h\u1ED3 s\u01A1",
    "Your resume": "H\u1ED3 s\u01A1 c\u1EE7a b\u1EA1n",
    "was uploaded on": "\u0111\u01B0\u1EE3c c\u1EADp nh\u1EADt ng\xe0y",
    Upload: "T\u1EA3i h\u1ED3 s\u01A1",
    "Upload CV": "T\u1EA3i CV l\xean",
    "You can only attach .doc, .docx, and .pdf files that are less than 2MB in size": "\u0110\u1ECBnh d\u1EA1ng file ch\u1EC9 c\xf3 th\u1EC3 l\xe0 .doc, .docx v\xe0 pdf, files ph\u1EA3i nh\u1ECF h\u01A1n 2MB.",
    Searchable: "Cho ph\xe9p t\xecm ki\u1EBFm",
    "You can track who viewed your profile": "B\u1EA1n c\xf3 th\u1EC3 theo d\xf5i \u0111\u01B0\u1EE3c ai \u0111\xe3 xem h\u1ED3 s\u01A1 c\u1EE7a b\u1EA1n",
    "Your Searchable Profile": "H\u1ED3 s\u01A1 cho ph\xe9p t\xecm ki\u1EBFm c\u1EE7a b\u1EA1n",
    "Searchable Profile": "Cho ph\xe9p t\xecm ki\u1EBFm h\u1ED3 s\u01A1",
    "Online Resume": "H\u1ED3 s\u01A1 online",
    "Attached Resume": "H\u1ED3 s\u01A1 \u0111\xednh k\xe8m",
    "Your Attached CV": "H\u1ED3 S\u01A1 \u0110\xednh K\xe8m",
    "Attached CV": "H\u1ED3 s\u01A1 \u0111\xednh k\xe8m",
    "Work Preferences": "C\xf4ng vi\u1EC7c mong mu\u1ED1n",
    "Contact Information": "Th\xf4ng tin li\xean h\u1EC7",
    "VietnamWorks profile": "H\u1ED3 s\u01A1 VietnamWorks",
    "Make Your Profile Searchable": "B\u1EADt cho ph\xe9p t\xecm ki\u1EBFm h\u1ED3 s\u01A1",
    "Make your profile searchable to increase your visibility to employers": "H\u1ED3 s\u01A1 c\u1EE7a b\u1EA1n s\u1EBD kh\xf4ng hi\u1EC3n th\u1ECB cho nh\xe0 tuy\u1EC3n d\u1EE5ng",
    "Add more information to be able to make this attached CV searchable.": "H\xe3y nh\u1EADp th\xeam th\xf4ng tin \u0111\u1EC3 nh\xe0 tuy\u1EC3n d\u1EE5ng c\xf3 th\u1EC3 t\xecm ki\u1EBFm h\u1ED3 s\u01A1 c\u1EE7a b\u1EA1n.",
    "Update Basic Info": "C\u1EADp Nh\u1EADt H\u1ED3 S\u01A1",
    "Preferred working location": "N\u01A1i L\xe0m Vi\u1EC7c Mong Mu\u1ED1n",
    "Please select": "Vui l\xf2ng ch\u1ECDn",
    "City / Province": "T\u1EC9nh / Th\xe0nh Ph\u1ED1",
    "District / Ward": "Qu\u1EADn / Huy\u1EC7n",
    "No matches found": "Kh\xf4ng t\xecm th\u1EA5y k\u1EBFt qu\u1EA3",
    "You can only select maximum of 3 options": "B\u1EA1n ch\u1EC9 c\xf3 th\u1EC3 ch\u1ECDn t\u1ED1i \u0111a 3 l\u1EF1a ch\u1ECDn",
    "All Districts": "T\u1EA5t C\u1EA3 C\xe1c Qu\u1EADn / Huy\u1EC7n",
    "All cities / provinces": "T\u1EA5t c\u1EA3 c\xe1c t\u1EC9nh / th\xe0nh ph\u1ED1",
    "All districts / wards": "T\u1EA5t c\u1EA3 c\xe1c qu\u1EADn / huy\u1EC7n",
    Download: "T\u1EA3i Xu\u1ED1ng",
    Close: "\u0110\xf3ng",
    "and is being processed.": "v\xe0 \u0111ang \u0111\u01B0\u1EE3c x\u1EED l\xfd.",
    Updated: "\u0110\xe3 c\u1EADp nh\u1EADt",
    Uploaded: "\u0110\xe3 t\u1EA3i l\xean",
    "Update Attached CV": "Thay \u0111\u1ED5i CV \u0111\xednh k\xe8m",
    "Change CV": "Thay \u0111\u1ED5i h\u1ED3 s\u01A1",
    "Do You Have Your Own CV?": "B\u1EA1n \u0111\xe3 c\xf3 CV?",
    "Upload and use your existing CV for the quick apply.": "T\u1EA3i l\xean CV \u0111\u1EC3 c\xf3 th\u1EC3 \u1EE9ng tuy\u1EC3n nhanh ch\xf3ng",
    "Upload Your CV": "T\u1EA3i l\xean CV",
    Size: "K\xedch th\u01B0\u1EDBc",
    View: "Xem",
    "The profile will be automatically refreshed and on top of the Employer's candidate search page within 15 days from the date of enabling the feature.": "H\u1ED3 s\u01A1 s\u1EBD \u0111\u01B0\u1EE3c t\u1EF1 \u0111\u1ED9ng l\xe0m m\u1EDBi v\xe0 l\xean \u0111\u1EA7u trang t\xecm ki\u1EBFm \u1EE9ng vi\xean c\u1EE7a Nh\xe0 tuy\u1EC3n d\u1EE5ng trong 15 ng\xe0y t\u1EEB ng\xe0y b\u1EADt t\xednh n\u0103ng.",
    "The profile will be automatically refreshed and will be on the top of the Employer's candidate search page until": "H\u1ED3 s\u01A1 s\u1EBD \u0111\u01B0\u1EE3c t\u1EF1 \u0111\u1ED9ng l\xe0m m\u1EDBi v\xe0 l\xean \u0111\u1EA7u trang t\xecm ki\u1EBFm \u1EE9ng vi\xean c\u1EE7a Nh\xe0 tuy\u1EC3n d\u1EE5ng cho \u0111\u1EBFn ng\xe0y",
    "You need to turn on searchable mode before using this feature to ensure your profile will be displayed on Employer's candidate search page": "B\u1EA1n c\u1EA7n b\u1EADt t\xednh n\u0103ng cho ph\xe9p t\xecm ki\u1EBFm h\u1ED3 s\u01A1 tr\u01B0\u1EDBc khi s\u1EED d\u1EE5ng t\xednh n\u0103ng n\xe0y \u0111\u1EC3 \u0111\u1EA3m b\u1EA3o h\u1ED3 s\u01A1 c\u1EE7a b\u1EA1n hi\u1EC3n th\u1ECB tr\xean trang t\xecm ki\u1EBFm \u1EE9ng vi\xean c\u1EE7a Nh\xe0 tuy\u1EC3n d\u1EE5ng.",
    "Refresh my profile Daily": "L\xe0m m\u1EDBi h\u1ED3 s\u01A1 h\xe0ng ng\xe0y",
    "Refresh my profile Weekly": "L\xe0m m\u1EDBi h\u1ED3 s\u01A1 h\xe0ng tu\u1EA7n",
    "Refresh Daily": "L\xe0m m\u1EDBi ng\xe0y",
    "Refresh Weekly": "L\xe0m m\u1EDBi tu\u1EA7n",
    "Turn Off Refresh": "T\u1EAFt l\xe0m m\u1EDBi",
    "By VietnamWorks profile": "B\u1EB1ng h\u1ED3 s\u01A1 VietnamWorks",
    "By attached CVs": "B\u1EB1ng h\u1ED3 s\u01A1 \u0111\xednh k\xe8m",
    "Refresh My Profile": "L\xe0m m\u1EDBi h\u1ED3 s\u01A1",
    "Manage attached CVs": "Qu\u1EA3n l\xfd h\u1ED3 s\u01A1 \u0111\xednh k\xe8m",
    "Searchable by Attached CV": "Cho ph\xe9p t\xecm ki\u1EBFm h\u1ED3 s\u01A1 \u0111\xednh k\xe8m",
    "To enable Attached CV, you need to complete:": "\u0110\u1EC3 b\u1EADt cho ph\xe9p t\xecm ki\u1EBFm h\u1ED3 s\u01A1 \u0111\xednh k\xe8m, b\u1EA1n c\u1EA7n cung c\u1EA5p:",
    "To enable VietnamWorks Profile, your VietnamWorks Profile needs to be completed and approved.": "\u0110\u1EC3 b\u1EADt cho ph\xe9p t\xecm ki\u1EBFm, h\u1ED3 s\u01A1 tr\u1EF1c tuy\u1EBFn VietnamWorks c\u1EA7n \u0111\u01B0\u1EE3c ho\xe0n thi\u1EC7n v\xe0 \u0111\u01B0\u1EE3c duy\u1EC7t",
    "Update profile": "C\u1EADp nh\u1EADt h\u1ED3 s\u01A1",
    Unfinished: "Ch\u01B0a ho\xe0n ch\u1EC9nh",
    Beginner: "C\u01A1 b\u1EA3n",
    Intermediate: "Trung b\xecnh",
    Expert: "T\u01B0\u01A1ng \u0111\u1ED1i ho\xe0n ch\u1EC9nh",
    "All Star": "Ho\xe0n ch\u1EC9nh",
    completed: "\u0111\xe3 ho\xe0n th\xe0nh",
    "Searchable status": "Tr\u1EA1ng th\xe1i cho ph\xe9p t\xecm ki\u1EBFm",
    "/my-profile": "/ho-so",
    "Not Approved": "Ch\u01B0a \u0111\u01B0\u1EE3c duy\u1EC7t",
    Done: "Ho\xe0n t\u1EA5t",
    "Refresh status": "Tr\u1EA1ng th\xe1i l\xe0m m\u1EDBi h\u1ED3 s\u01A1",
    "Refresh profile": "L\xe0m m\u1EDBi h\u1ED3 s\u01A1",
    "File name": "T\xean t\u1EADp tin",
    "job-search/all-jobs": "tim-viec-lam/tim-tat-ca-viec-lam",
    "To enable Searchable Profile, get your profile approved or complete: Attached CV, Contact Information and Work Preferences.": '\u0110\u1EC3 cho ph\xe9p nh\xe0 tuy\u1EC3n d\u1EE5ng t\xecm ki\u1EBFm h\u1ED3 s\u01A1, h\xe3y c\u1EADp nh\u1EADt h\u1ED3 s\u01A1 tr\u1EF1c tuy\u1EBFn VietnamWorks ho\u1EB7c nh\u1EADp c\xe1c th\xf4ng tin: "H\u1ED3 s\u01A1 \u0111\xednh k\xe8m", "Th\xf4ng tin li\xean h\u1EC7" v\xe0 "C\xf4ng vi\u1EC7c mong mu\u1ED1n"',
    "Turn on and allow employers to view your profile.": "B\u1EADt v\xe0 cho ph\xe9p nh\xe0 tuy\u1EC3n d\u1EE5ng xem h\u1ED3 s\u01A1 c\u1EE7a b\u1EA1n.",
    "Default searchable": "T\xecm ki\u1EBFm h\u1ED3 s\u01A1 m\u1EB7c \u0111\u1ECBnh",
    "Searchable CV": "Cho ph\xe9p t\xecm ki\u1EBFm h\u1ED3 s\u01A1",
    "Default searchable CV": "H\u1ED3 s\u01A1 t\xecm ki\u1EBFm m\u1EB7c \u0111\u1ECBnh",
    "Searchable CVs": "Cho ph\xe9p t\xecm ki\u1EBFm h\u1ED3 s\u01A1",
    "Turn off searchable CV?": "T\u1EAFt t\xecm ki\u1EBFm h\u1ED3 s\u01A1?",
    "Employer will not see your profile on Vietnamwork system.": "Nh\xe0 tuy\u1EC3n d\u1EE5ng s\u1EBD kh\xf4ng t\xecm ki\u1EBFm \u0111\u01B0\u1EE3c h\u1ED3 s\u01A1 c\u1EE7a b\u1EA1n tr\xean h\u1EC7 th\u1ED1ng Vietnamworks.",
    "You can add a maximum of": "B\u1EA1n ch\u1EC9 c\xf3 th\u1EC3 nh\u1EADp t\u1ED1i \u0111a",
    "email domains": "domain email",
    "Please select a job level": "Vui l\xf2ng ch\u1ECDn tr\xecnh \u0111\u1ED9 c\xf4ng vi\u1EC7c",
    "Searchable CV is disable": "T\xednh n\u0103ng b\u1EADt t\xecm ki\u1EBFm \u0111ang b\u1ECB kho\xe1",
    "Your searchable CV is disable now because of wrong contact information. Please contact with Vietnamworks to verify your information by email:": "Hi\u1EC7n t\u1EA1i b\u1EA1n kh\xf4ng th\u1EC3 b\u1EADt ch\u1EE9c n\u0103ng t\xecm ki\u1EBFm h\u1ED3 s\u01A1 v\xec nh\u1EADp sai th\xf4ng tin li\xean h\u1EC7. Vui l\xf2ng li\xean h\u1EC7 v\u1EDBi Vietnamworks \u0111\u1EC3 x\xe1c nh\u1EADn l\u1EA1i th\xf4ng tin qua email:",
    "Local Vietnamese": "Ng\u01B0\u1EDDi Vi\u1EC7t Nam",
    Foreigner: "Ng\u01B0\u1EDDi n\u01B0\u1EDBc ngo\xe0i",
    "Your changes has been saved successfully!": "Thay \u0111\u1ED5i c\u1EE7a b\u1EA1n \u0111\xe3 \u0111\u01B0\u1EE3c l\u01B0u th\xe0nh c\xf4ng",
    "Something went wrong with your change!": "\u0110\xe3 x\u1EA3y ra l\u1ED7i v\u1EDBi thay \u0111\u1ED5i c\u1EE7a b\u1EA1n",
    Success: "Th\xe0nh c\xf4ng",
    Error: "L\u1ED7i",
    "Select attached CVs": "Ch\u1ECDn CV \u0111\xe3 t\u1EA3i l\xean",
    "Updated on": "C\u1EADp nh\u1EADt ",
    "To make attached CV searchable, you need to:": "\u0110\u1EC3 cho ph\xe9p t\xecm ki\u1EBFm h\u1ED3 s\u01A1 \u0111\xednh k\xe8m, b\u1EA1n c\u1EA7n th\u1EF1c hi\u1EC7n:",
    "Complete basic information": "B\u1ED5 sung th\xf4ng tin c\u01A1 b\u1EA3n",
    "View CV": "Xem h\u1ED3 s\u01A1",
    "View as employer": "Xem nh\u01B0 nh\xe0 tuy\u1EC3n d\u1EE5ng",
    "preview-resume": "xem-truoc-ho-so",
    "Job-seeking status": "Tr\u1EA1ng th\xe1i t\xecm vi\u1EC7c",
    "New": "M\u1EDBi",
    "I am open to work": "T\xf4i \u0111ang t\xecm vi\u1EC7c m\u1EDBi",
    "Select Open to work to attract more employers": "Ch\u1ECDn tr\u1EA1ng th\xe1i \u0111ang t\xecm vi\u1EC7c gi\xfap h\u1ED3 s\u01A1 b\u1EA1n \u0111\u01B0\u1EE3c ch\xfa \xfd nhi\u1EC1u h\u01A1n",
    "The status is set until": "Tr\u1EA1ng th\xe1i n\xe0y s\u1EBD \u0111\u01B0\u1EE3c thi\u1EBFt l\u1EADp \u0111\u1EBFn ng\xe0y"
};
/* harmony default export */ __webpack_exports__["Z"] = (translations);


/***/ }),

/***/ 97282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ ERefreshProfile; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var ERefreshProfile;
(function(ERefreshProfile) {
    ERefreshProfile[ERefreshProfile["Unset"] = 0] = "Unset";
    ERefreshProfile[ERefreshProfile["Daily"] = 1] = "Daily";
    ERefreshProfile[ERefreshProfile["Weekly"] = 2] = "Weekly";
})(ERefreshProfile || (ERefreshProfile = {}));


/***/ }),

/***/ 42500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ns": function() { return /* binding */ MAX_LEVEL_ID; },
/* harmony export */   "Uc": function() { return /* binding */ strengthOption; },
/* harmony export */   "k8": function() { return /* binding */ BLOCK_MAPPING; },
/* harmony export */   "sY": function() { return /* binding */ PROFILE_STRENGTH_EVENT_NAME; }
/* harmony export */ });
/* unused harmony export EStrength */
/* harmony import */ var _services_profileTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93184);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

var PROFILE_STRENGTH_EVENT_NAME = "PROFILE_STRENGTH_OPEN_FORM";
var EStrength;
(function(EStrength) {
    EStrength["beginner"] = "Beginner";
    EStrength["intermediate"] = "Intermediate";
    EStrength["expert"] = "Expert";
    EStrength["allStar"] = "All Star";
})(EStrength || (EStrength = {}));
var strengthOption = [
    // { id: 0, name: 'Unfinished' },
    {
        id: 1,
        name: EStrength.beginner
    },
    {
        id: 2,
        name: EStrength.intermediate
    },
    {
        id: 3,
        name: EStrength.expert
    },
    {
        id: 4,
        name: EStrength.allStar
    }
];
var MAX_LEVEL_ID = 4;
var _obj;
var BLOCK_MAPPING = (_obj = {}, _defineProperty(_obj, _services_profileTypes__WEBPACK_IMPORTED_MODULE_0__/* .EProfileStrengthForm.BASIC_INFO */ .O5.BASIC_INFO, {
    name: "Basic Information"
}), _defineProperty(_obj, _services_profileTypes__WEBPACK_IMPORTED_MODULE_0__/* .EProfileStrengthForm.WORK_HISTORY */ .O5.WORK_HISTORY, {
    name: "Work History"
}), _defineProperty(_obj, _services_profileTypes__WEBPACK_IMPORTED_MODULE_0__/* .EProfileStrengthForm.CONTACT_INFO */ .O5.CONTACT_INFO, {
    name: "Contact Information"
}), _defineProperty(_obj, _services_profileTypes__WEBPACK_IMPORTED_MODULE_0__/* .EProfileStrengthForm.SKILLS */ .O5.SKILLS, {
    name: "Skills"
}), _defineProperty(_obj, _services_profileTypes__WEBPACK_IMPORTED_MODULE_0__/* .EProfileStrengthForm.REFERENCES */ .O5.REFERENCES, {
    name: "References"
}), _defineProperty(_obj, _services_profileTypes__WEBPACK_IMPORTED_MODULE_0__/* .EProfileStrengthForm.WORKING_PREFERENCES */ .O5.WORKING_PREFERENCES, {
    name: "Working Preference"
}), _defineProperty(_obj, _services_profileTypes__WEBPACK_IMPORTED_MODULE_0__/* .EProfileStrengthForm.SUMMARY */ .O5.SUMMARY, {
    name: "Summary"
}), _defineProperty(_obj, _services_profileTypes__WEBPACK_IMPORTED_MODULE_0__/* .EProfileStrengthForm.LANGUAGES */ .O5.LANGUAGES, {
    name: "Languages"
}), _defineProperty(_obj, _services_profileTypes__WEBPACK_IMPORTED_MODULE_0__/* .EProfileStrengthForm.EDUCATIONS */ .O5.EDUCATIONS, {
    name: "Education"
}), _obj);


/***/ }),

/***/ 61105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "kQ": function() { return /* binding */ buildCompanyUrl; },
  "wR": function() { return /* binding */ commaSeparateNumber; },
  "MC": function() { return /* binding */ createReverseTranslateFunction; },
  "Qz": function() { return /* binding */ createTFunction; },
  "U8": function() { return /* binding */ formatAttachmentList; },
  "tu": function() { return /* binding */ handleFailedStatus; },
  "Zp": function() { return /* binding */ handleSuccessStatus; },
  "Qb": function() { return /* binding */ removeScriptTag; },
  "BC": function() { return /* binding */ scrollToRef; },
  "lV": function() { return /* binding */ slugify; },
  "PD": function() { return /* binding */ stripFileName; }
});

// UNUSED EXPORTS: assetUrl, byteToSize, extractFilenameInfo, formatDate, handleFocusOnFirstErrorField, imageServerUrl, removeRedundantSpaces, scrollContainerTo, transformToLatin, translate

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Toast/index.js + 2 modules
var Toast = __webpack_require__(60500);
// EXTERNAL MODULE: ./resources/translations/vi.json
var vi = __webpack_require__(20279);
;// CONCATENATED MODULE: ./resources/translations/en.json
var en_namespaceObject = JSON.parse('{"meta_title":"Find Your Dream Job. Move Up Today!","meta_description":"Quickly search  for best suitable job vacancies in Vietnam&#039;s top companies from the biggest Job Search Website in Vietnam. New jobs added daily! Click Now!","field_JobTitle":"Job Title","field_Phone":"Phone","field_JobLevelId":"Job Level","field_Description":"Description","field_Description_Education":"Achievement","Current Activity":"Current Activity"}');
// EXTERNAL MODULE: ./components/Global/MainLayout/SideNavigation/constant.tsx
var constant = __webpack_require__(86368);
// EXTERNAL MODULE: ./helpers/date.ts
var date = __webpack_require__(41978);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
;// CONCATENATED MODULE: ./helpers/common.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}






function assetUrl(path) {
    return "https://www.vietnamworks.com/assets-career-container" + path;
}
function imageServerUrl(path) {
    return "https://images.vietnamworks.com" + path;
}
function translate(key, langCode) {
    if (langCode === constants/* ELanguage.EN */.Df.EN) {
        return en_namespaceObject[key] || key;
    }
    if (!vi[key]) console.log("".concat(langCode, " | --- ").concat(key, " --- translation is missing"));
    return vi[key] || key;
}
function createTFunction(langCode) {
    return function(key) {
        return translate(key, langCode);
    };
}
function createReverseTranslateFunction(langCode) {
    return function(key) {
        return langCode === constants/* ELanguage.VI */.Df.VI ? key : vi[key];
    };
}
function removeScriptTag(s) {
    if (typeof document === "undefined") {
        return s;
    }
    var div = document.createElement("div");
    div.innerHTML = s;
    var scripts = div.getElementsByTagName("script");
    var i = scripts.length;
    while(i--){
        var ref;
        (ref = scripts[i].parentNode) === null || ref === void 0 ? void 0 : ref.removeChild(scripts[i]);
    }
    return div.innerHTML;
}
function handleSuccessStatus(langCode, text) {
    (0,Toast/* showToast */.CF)(langCode === constants/* ELanguage.EN */.Df.EN ? "Success" : "Th\xe0nh C\xf4ng", text);
}
function handleFailedStatus(langCode, text) {
    (0,Toast/* showToast */.CF)(langCode === constants/* ELanguage.EN */.Df.EN ? "Error" : "L\u1ED7i", text, "error");
}
function scrollToRef(ref) {
    var _$ref;
    if ( false || typeof document === "undefined" || !ref) {
        return;
    }
    var elOffsetTop = ((_$ref = ref.current) === null || _$ref === void 0 ? void 0 : _$ref.getBoundingClientRect().top) || 0;
    var windowOffsetTop = document.documentElement.scrollTop;
    window.scrollTo({
        top: elOffsetTop + windowOffsetTop - 90,
        behavior: "smooth"
    });
}
var scrollContainerTo = function(containerSelector) {
    var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, top = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, left = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    if (!isDesktop()) {
        setTimeout(function() {
            var scrollContainer = document.querySelector(containerSelector);
            scrollContainer === null || scrollContainer === void 0 ? void 0 : scrollContainer.scroll({
                top: top,
                left: left
            });
        }, delay);
    }
};
var handleFocusOnFirstErrorField = function(container) {
    if (typeof document !== "undefined" && container) {
        var inputErrorSelector = '[class*="input-module_inputError"]';
        var benefitErrorSelector = ".benefit-has-error .tag-item:first-child";
        // Set timeout to make sure that all states are set and re-rendering have been made
        setTimeout(function() {
            var containerElement = typeof container === "string" ? document.querySelector(container) : container;
            var firstErrorField = containerElement === null || containerElement === void 0 ? void 0 : containerElement.querySelectorAll("".concat(inputErrorSelector, ", ").concat(benefitErrorSelector))[0];
            if (firstErrorField) {
                firstErrorField.focus();
            }
        }, 150);
    }
};
function removeRedundantSpaces(str) {
    return str.replace(/\s+/g, " ");
}
function buildCompanyUrl(companyId, companySlug, langCode) {
    var prefixPath = langCode === constants/* ELanguage.EN */.Df.EN ? "companies" : "nha-tuyen-dung";
    return "/".concat(prefixPath, "/").concat(companySlug, "-c").concat(companyId);
}
function byteToSize(size) {
    var calSizeResume = "";
    var ONE_MB = 1024 * 1000;
    var ONE_KB = 1024;
    if (size >= ONE_MB) {
        calSizeResume = (size / ONE_MB).toFixed(1) + "MB";
    } else {
        calSizeResume = (size / ONE_KB).toFixed(1) + "KB";
    }
    return calSizeResume;
}
function commaSeparateNumber(val) {
    while(/(\d+)(\d{3})/.test(val.toString())){
        val = val.toString().replace(/(\d+)(\d{3})/, "$1" + "," + "$2");
    }
    return val;
}
function formatDate(date) {
    var join = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "/";
    date = date || new Date();
    var options = {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
    };
    var formattedDate = date.toLocaleDateString("vi-VN", options).replaceAll("/", join);
    return formattedDate;
}
function transformToLatin(text) {
    text = text.toString().toLowerCase().trim();
    var sets = [
        {
            to: "a",
            from: "[\xc0\xc1\xc2\xc3\xc4\xc5\xc6\u0100\u0102\u0104\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1F00]"
        },
        {
            to: "c",
            from: "[\xc7\u0106\u0108\u010C]"
        },
        {
            to: "d",
            from: "[\xd0\u010E\u0110\xde]"
        },
        {
            to: "e",
            from: "[\xc8\xc9\xca\xcb\u0112\u0114\u0116\u0118\u011A\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6]"
        },
        {
            to: "g",
            from: "[\u011C\u011E\u0122\u01F4]"
        },
        {
            to: "h",
            from: "[\u0124\u1E26]"
        },
        {
            to: "i",
            from: "[\xcc\xcd\xce\xcf\u0128\u012A\u012E\u0130\u1EC8\u1ECA]"
        },
        {
            to: "j",
            from: "[\u0134]"
        },
        {
            to: "ij",
            from: "[\u0132]"
        },
        {
            to: "k",
            from: "[\u0136]"
        },
        {
            to: "l",
            from: "[\u0139\u013B\u013D\u0141]"
        },
        {
            to: "m",
            from: "[\u1E3E]"
        },
        {
            to: "n",
            from: "[\xd1\u0143\u0145\u0147]"
        },
        {
            to: "o",
            from: "[\xd2\xd3\xd4\xd5\xd6\xd8\u014C\u014E\u0150\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u01EA\u01EC\u01A0]"
        },
        {
            to: "oe",
            from: "[\u0152]"
        },
        {
            to: "p",
            from: "[\u1E55]"
        },
        {
            to: "r",
            from: "[\u0154\u0156\u0158]"
        },
        {
            to: "s",
            from: "[\xdf\u015A\u015C\u015E\u0160\u0218]"
        },
        {
            to: "t",
            from: "[\u0162\u0164]"
        },
        {
            to: "u",
            from: "[\xd9\xda\xdb\xdc\u0168\u016A\u016C\u016E\u0170\u0172\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u01AF]"
        },
        {
            to: "w",
            from: "[\u1E82\u0174\u1E80\u1E84]"
        },
        {
            to: "x",
            from: "[\u1E8D]"
        },
        {
            to: "y",
            from: "[\xdd\u0176\u0178\u1EF2\u1EF4\u1EF6\u1EF8]"
        },
        {
            to: "z",
            from: "[\u0179\u017B\u017D]"
        },
        {
            to: "-",
            from: "[\xb7/_,:;']"
        }
    ];
    sets.forEach(function(set) {
        text = text.replace(new RegExp(set.from, "gi"), set.to);
    });
    return text;
}
function slugify(slug) {
    slug = slug.replace(/^\s+|\s+$/g, "") // trim
    ;
    slug = slug.toLowerCase();
    // remove accents
    slug = transformToLatin(slug);
    slug = slug.replace(/[^a-z0-9 -]/g, "-") // invalid chars to -
    .replace(/\s+/g, "-") // collapse whitespace and replace by -
    .replace(/-+/g, "-") // collapse dashes
    ;
    return slug;
}
function extractFilenameInfo(fileName) {
    var splitFileNameByDot = fileName.split(".");
    if (!fileName.length || splitFileNameByDot.length < 2) {
        return {
            name: "",
            extension: ""
        };
    }
    var extension = splitFileNameByDot.pop().toLowerCase();
    return {
        name: splitFileNameByDot.join(""),
        extension: constant/* DEFAULT_ALLOW_EXT.some */.Wx.some(function(extensionWithDot) {
            return extensionWithDot.indexOf(extension) === 1;
        }) ? extension : ""
    };
}
var formatAttachmentList = function(data) {
    if (!data.length) {
        return [];
    }
    return (data || []).map(function(item) {
        var ref = extractFilenameInfo(item === null || item === void 0 ? void 0 : item.fileName), name = ref.name, extension = ref.extension;
        return _objectSpread({}, item, {
            id: item === null || item === void 0 ? void 0 : item.id,
            link: item === null || item === void 0 ? void 0 : item.link,
            updatedDate: (0,date/* formatDateFromGMT */.J5)(item === null || item === void 0 ? void 0 : item.updatedDate),
            name: name,
            extension: extension
        });
    });
};
function stripFileName(fileName) {
    var maxLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 15;
    var name = "";
    var matchExt = "";
    if (fileName.length <= maxLength) {
        return fileName;
    }
    // Find extension in filename
    constant/* DEFAULT_ALLOW_EXT.map */.Wx.map(function(extension) {
        if (fileName.indexOf(extension) > 0) {
            // Match
            matchExt = extension;
        }
    });
    name = fileName.replace(matchExt, "").slice(0, maxLength);
    return "".concat(name, "..").concat(matchExt);
}


/***/ }),

/***/ 61868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dn": function() { return /* binding */ resetUserCookies; },
/* harmony export */   "ej": function() { return /* binding */ getCookie; }
/* harmony export */ });
/* unused harmony exports setCookie, deleteCookie */
var getCookie = function(name) {
    var nameEQ = name + "=";
    if (typeof document !== "undefined") {
        var ca = document.cookie.split(";");
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) === " ")c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
    }
    return null;
};
var setCookie = function setCookie(name, value, days) {
    if (days) {
        var currentDay = new Date();
        currentDay.setTime(currentDay.getTime() + days * 24 * 60 * 60 * 1000);
        // @ts-ignore
        var expires = "; expires=" + currentDay.toGMTString();
    } else expires = "";
    document.cookie = name + "=" + value + expires + "; path=/";
};
var deleteCookie = function(name) {
    document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};
var resetUserCookies = function() {
    deleteCookie("PHPSESSID");
    deleteCookie("appliedXaloLeadCourse");
    deleteCookie("VNW_WS_COOKIE");
    deleteCookie("VNW_USER_COOKIE");
    deleteCookie("VNW128450527232960");
    deleteCookie("VNWWS128450527232960");
    deleteCookie("VNWISN128450527232960");
    deleteCookie("VNWJSAll128450527232960");
    deleteCookie("flo_vnw");
    deleteCookie("VNW94a08da1fecbb6e8b46990538c7b50b2");
    deleteCookie("VNWJSStoredKey");
};


/***/ }),

/***/ 41978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$5": function() { return /* binding */ EMPTY_DATE; },
/* harmony export */   "Bh": function() { return /* binding */ dateDiff; },
/* harmony export */   "J5": function() { return /* binding */ formatDateFromGMT; },
/* harmony export */   "UW": function() { return /* binding */ dateToString; },
/* harmony export */   "Xl": function() { return /* binding */ parseFromString; },
/* harmony export */   "ZG": function() { return /* binding */ isSame; },
/* harmony export */   "dM": function() { return /* binding */ formatMmYyyy; },
/* harmony export */   "jF": function() { return /* binding */ convertDateTime; },
/* harmony export */   "z3": function() { return /* binding */ formatDdMmYyyy; }
/* harmony export */ });
/* unused harmony exports formatYyyyMmDd, offsetDate, datetimeFormat, getLastUpdatedAttachment */
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);

var customParseFormat = __webpack_require__(10285);
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend(customParseFormat);
function formatMmYyyy(date) {
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).format("MM/YYYY");
}
function formatDdMmYyyy(date) {
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).format("DD/MM/YYYY");
}
function formatYyyyMmDd(date) {
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).format("YYYY-MM-DD");
}
function dateToString(date, format) {
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date).format(format);
}
function dateDiff(fromDate, toDate) {
    var unit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "month";
    var fromDateObj = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(formatYyyyMmDd(fromDate));
    var toDateObj = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(formatYyyyMmDd(toDate));
    // We need to format Date obj to YYYY-MM-DD before "diff" to make it compare only date not by time
    return toDateObj.diff(fromDateObj, unit);
}
function parseFromString(dateStr, format) {
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(dateStr, format).toDate();
}
function isSame(date1, date2) {
    return dayjs__WEBPACK_IMPORTED_MODULE_0___default()(dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date1)).isSame(dayjs__WEBPACK_IMPORTED_MODULE_0___default()(date2));
}
var EMPTY_DATE = "0000-00-00";
/**
 * We need to do this because the date value from DatePicker is sometimes one day off in the past
 * @see https://github.com/Hacker0x01/react-datepicker/issues/1018
 */ function offsetDate(date) {
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
}
/**
 * Convert GMT+7 to UTC
 * @param {number} timestamp from API server (Ex: 1638958392)
 * @return string dd-mm-yyyy
 * API return timestamp in GMT+7 this means we have to convert it to UTC.
 * If not convert then time will be +7 hours (Not correct time save in database)
 */ function formatDateFromGMT(timestamp) {
    var date = new Date(timestamp * 1000);
    var rawDay = date.getUTCDate();
    // Month is from 0 to 11
    var rawMonth = date.getUTCMonth() + 1;
    var day = rawDay < 10 ? "0".concat(rawDay) : rawDay;
    var month = rawMonth < 10 ? "0".concat(rawMonth) : rawMonth;
    return day + "/" + month + "/" + date.getUTCFullYear();
}
var days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
var months = [
    "",
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var nth = function(d) {
    if (d > 3 && d < 21) return "th";
    switch(d % 10){
        case 1:
            return "st";
        case 2:
            return "nd";
        case 3:
            return "rd";
        default:
            return "th";
    }
};
var convertDateTime = function(time) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var date = new Date(time);
    var day = date.getDate();
    var dayName = days[date.getDay()];
    var month = date.getMonth() + 1;
    var monthName = months[month];
    var year = date.getFullYear();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    switch(type){
        case 0:
            {
                // 30/10/2022 07:30
                var formatDate = String(day).padStart(2, "0") + "/" + String(month).padStart(2, "0") + "/" + year;
                var formatTime = String(hours).padStart(2, "0") + ":" + String(minutes).padStart(2, "0");
                return "".concat(formatDate, " ").concat(formatTime);
            }
        case 1:
            {
                // Friday, 15 Oct 2022
                return "".concat(dayName, ", ").concat(day, " ").concat(monthName, " ").concat(year);
            }
        case 2:
            {
                // Oct 5th, 2022
                return "".concat(monthName, " ").concat(day).concat(nth(day), ", ").concat(year);
            }
        case 3:
            {
                // 06:30
                return "".concat(String(hours).padStart(2, "0"), ":").concat(String(minutes).padStart(2, "0"));
            }
        case 4:
            {
                // 15 Wed, 2022
                return "".concat(day, " ").concat(monthName.slice(0, 3), ", ").concat(year);
            }
        case 5:
            {
                // Wed 15, 2022
                return "".concat(monthName.slice(0, 3), " ").concat(day, ", ").concat(year);
            }
        case 6:
            {
                // 2022-10-18 11:04:20
                return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
            }
        case 7:
            {
                // 30/10/2022
                var formatDate1 = String(day).padStart(2, "0") + "/" + String(month).padStart(2, "0") + "/" + year;
                return formatDate1;
            }
        case 8:
            {
                // 04:20
                return "".concat(minutes, ":").concat(seconds);
            }
        case 9:
            {
                // 2022-10-18 11:04:20
                return "".concat(month, "/").concat(year);
            }
        case 10:
            {
                // 2022-10-18 11:04:20
                return "".concat(year);
            }
        default:
            return "";
    }
};
function datetimeFormat(date, locale, options) {
    var newDate = date;
    var formatter = new Intl.DateTimeFormat(locale !== null && locale !== void 0 ? locale : "vi-VN", options !== null && options !== void 0 ? options : {
        dateStyle: "short"
    });
    return formatter.format(newDate);
}
function getLastUpdatedAttachment(attachInfo) {
    if (attachInfo.length === 0) {
        // Handle the case where the array is empty
        return null;
    }
    // Initialize maxItem with the first item in the array
    var maxItem = attachInfo[0];
    for(var i = 1; i < attachInfo.length; i++){
        if (attachInfo[i].updatedDate > maxItem.updatedDate) {
            // Update maxItem if we find an item with a larger updateDate
            maxItem = attachInfo[i];
        }
    }
    return maxItem;
}


/***/ }),

/***/ 65310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90222);
/* harmony import */ var _services_types_resume__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98688);
/* harmony import */ var _store_actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25800);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var DEFAULT_RESUME_ATTRIBUTE = {
    allowSearchableDisplay: 0,
    fileName: "",
    link: "",
    size: 0,
    id: 0,
    isAttach: 0,
    isSearchable: 0,
    updatedDate: 0
};
var ModelError = _microfrontends_react_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z;
function syncProfileSettingInfoStore(info, currentStoreInfo, dispatch) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var data = info.data, meta = info.meta;
    var currentInfo = currentStoreInfo;
    if (!(data === null || data === void 0 ? void 0 : data.attributes) || (data === null || data === void 0 ? void 0 : (ref = data.attributes) === null || ref === void 0 ? void 0 : ref.length) < 1) {
        var value = new ModelError({
            data: null,
            error: {
                details: {
                    ERROR_UPDATE: "Can't update data to store"
                },
                status: 500,
                message: "Can't update data to store"
            }
        });
        return [
            value
        ];
    }
    var attach = data === null || data === void 0 ? void 0 : (ref1 = data.attributes) === null || ref1 === void 0 ? void 0 : ref1.filter(function(cv) {
        return cv.isAttach === _services_types_resume__WEBPACK_IMPORTED_MODULE_0__/* .EProfile.isAttach */ .Yc.isAttach;
    });
    var profile = data === null || data === void 0 ? void 0 : (ref2 = data.attributes) === null || ref2 === void 0 ? void 0 : ref2.find(function(cv) {
        return cv.isAttach === _services_types_resume__WEBPACK_IMPORTED_MODULE_0__/* .EProfile.isProfile */ .Yc.isProfile;
    });
    var clonedProfileSettingInfo = JSON.parse(JSON.stringify(currentInfo));
    var ref7;
    dispatch({
        type: _store_actions__WEBPACK_IMPORTED_MODULE_2__/* .ACTION_SET_RESUME_SETTING_INFO */ .x_,
        payload: _objectSpread({}, clonedProfileSettingInfo, {
            resumeSetting: {
                attachInfo: attach,
                profileInfo: profile !== null && profile !== void 0 ? profile : DEFAULT_RESUME_ATTRIBUTE
            },
            searchableStatus: data.searchableStatus,
            unContactable: data.unContactable
        }, meta ? {
            meta: meta
        } : undefined, {
            resumeSettingOption: {
                chooseCV: (ref3 = data.profileSetting) === null || ref3 === void 0 ? void 0 : ref3.chooseCV,
                chooseRefreshType: (ref4 = data.profileSetting) === null || ref4 === void 0 ? void 0 : ref4.chooseRefreshType,
                resumeId: (ref5 = data.profileSetting) === null || ref5 === void 0 ? void 0 : ref5.resumeId,
                summary: (ref7 = (ref6 = data.profileSetting) === null || ref6 === void 0 ? void 0 : ref6.summary) !== null && ref7 !== void 0 ? ref7 : ""
            }
        })
    });
    return [
        "success"
    ];
}
/* harmony default export */ __webpack_exports__["Z"] = (syncProfileSettingInfoStore);


/***/ }),

/***/ 5672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Aw": function() { return /* binding */ splitFileExtension; },
/* harmony export */   "D2": function() { return /* binding */ checkMissingField; },
/* harmony export */   "K8": function() { return /* binding */ removeFileNameExtension; },
/* harmony export */   "Vh": function() { return /* binding */ locationRedirect; },
/* harmony export */   "gw": function() { return /* binding */ delay; },
/* harmony export */   "l1": function() { return /* binding */ getLocalizedName; },
/* harmony export */   "nD": function() { return /* binding */ calculateProfileStrength; },
/* harmony export */   "tq": function() { return /* binding */ isMobile; },
/* harmony export */   "ty": function() { return /* binding */ getLocalizedOptions; }
/* harmony export */ });
/* unused harmony export locationAssign */
/* harmony import */ var _microfrontends_app_shell_v2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64889);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var locationRedirect = function(url) {
    window.location.href = url;
};
var locationAssign = function(url) {
    window.location.assign(url);
};
var calculateProfileStrength = function(profileLevel, strengthOption) {
    var currentLevelPercentage = profileLevel.level / strengthOption.length * 100;
    var nextLevelPercentage = (profileLevel.level + 1) / strengthOption.length * 100;
    var percentage = currentLevelPercentage === 100 ? 100 : profileLevel.totalPoints > 0 ? currentLevelPercentage + profileLevel.passedPoints / profileLevel.totalPoints * (nextLevelPercentage - currentLevelPercentage) : 0;
    return percentage;
};
var isMobile = function isMobile() {
    return  true ? window.innerWidth < 769 : 0;
};
var getLocalizedOptions = function() {
    var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], langCode = arguments.length > 1 ? arguments[1] : void 0;
    return (data || []).map(function(param) {
        var id = param.id, name = param.name, nameEn = param.nameEn;
        return {
            id: id,
            name: langCode === _microfrontends_app_shell_v2__WEBPACK_IMPORTED_MODULE_0__/* .ELanguage.EN */ .Df.EN ? nameEn : name
        };
    });
};
var removeFileNameExtension = function() {
    var fileName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", isGetName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    if (fileName === "") {
        return fileName;
    }
    // Split by dot
    var fileNameSplitted = fileName.split(".");
    if (fileNameSplitted.length === 0) {
        return fileName;
    }
    var ref;
    var extension = (ref = fileNameSplitted.pop()) !== null && ref !== void 0 ? ref : "";
    return isGetName ? fileNameSplitted.join(".") : extension;
};
var splitFileExtension = function(fileName, extension) {
    var lastDotIndex = fileName.lastIndexOf(".");
    // If there's no dot in the file name, assume no extension
    if (lastDotIndex === -1) {
        return [
            fileName,
            extension
        ];
    }
    var name = fileName.slice(0, lastDotIndex);
    var extensionName = fileName.slice(lastDotIndex);
    return [
        name,
        extensionName
    ];
};
var getLocalizedName = function(data, langCode) {
    if (!data) {
        return "-";
    }
    return langCode === _microfrontends_app_shell_v2__WEBPACK_IMPORTED_MODULE_0__/* .ELanguage.EN */ .Df.EN ? data === null || data === void 0 ? void 0 : data.nameEn : data.name;
};
function delay(ms) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, ms);
    });
}
var checkMissingField = function(data) {
    return !!Object.entries(data).find(function(param) {
        var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
        if (Array.isArray(value)) {
            return value.length === 0;
        }
        if (!value) {
            return true;
        }
        return false;
    });
};


/***/ }),

/***/ 41396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GW": function() { return /* binding */ BASE_PATH; },
/* harmony export */   "af": function() { return /* binding */ API_UPLOAD_LINKEDIN; },
/* harmony export */   "aj": function() { return /* binding */ API_RELOAD_USER; },
/* harmony export */   "eq": function() { return /* binding */ PROFILE_API_BASE_PATH_V2; },
/* harmony export */   "fx": function() { return /* binding */ PROFILE_API_BASE_PATH; },
/* harmony export */   "gl": function() { return /* binding */ API_LINKEDIN_STATUS; }
/* harmony export */ });
/* unused harmony exports API_LINKEDIN, API_LINKEDIN_AVAILABLE_STATUS, API_ATTACHMENT_RESUME_LINK */
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helpers_date__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41978);
/* harmony import */ var _userService__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76219);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var BASE_PATH = "https://ms.vietnamworks.com";
var PROFILE_API_BASE_PATH = "".concat(BASE_PATH, "/api-gateway/v1.0/profile");
var PROFILE_API_BASE_PATH_V2 = "".concat(BASE_PATH, "/api-gateway/v2.0/profile");
var API_LINKEDIN = "".concat(BASE_PATH, "/api-gateway/v1.0/single-crawl");
var API_LINKEDIN_STATUS = "".concat(BASE_PATH, "/api-gateway/v1.0/crawl-status");
var API_LINKEDIN_AVAILABLE_STATUS = "".concat(BASE_PATH, "/api-gateway/v1.0/linkedin-crawler-service-status");
var API_UPLOAD_LINKEDIN = "".concat(BASE_PATH, "/api-gateway/v1.0/linkedin-parse-pdf");
var API_RELOAD_USER = "".concat("https://www.vietnamworks.com", "/jobseekers/ajax.php?action=reload-user-ajax");
var API_ATTACHMENT_RESUME_LINK = "".concat(BASE_PATH, "/api-gateway/v1.0/profile/resume-file/");
var ProfileService = /*#__PURE__*/ function() {
    "use strict";
    function ProfileService() {
        var _this = this;
        _classCallCheck(this, ProfileService);
        // Resume Detail fields
        this._resumeDetailDataCache = null;
        this._resumeDetailDataRequested = false;
        this._aiSONO = "";
        // Constants
        this.RESUME_DETAIL_API = "".concat(PROFILE_API_BASE_PATH, "/resume-detail");
        this.USER_CONTACT_INFO_API = "".concat(PROFILE_API_BASE_PATH, "/contact");
        this.SUMMARY_API = "".concat(PROFILE_API_BASE_PATH, "/summary");
        this.REFERENCE_API = "".concat(PROFILE_API_BASE_PATH, "/reference");
        this.SORT_API = "".concat(PROFILE_API_BASE_PATH, "/update-order");
        this.LEVEL_API = "".concat(PROFILE_API_BASE_PATH, "/level");
        this.LEVEL_CALCULATE_API = "".concat(PROFILE_API_BASE_PATH, "/level-calculate");
        this.AVATAR_API = "".concat(PROFILE_API_BASE_PATH, "/avatar");
        this.CERTIFICATION_API = "".concat(PROFILE_API_BASE_PATH, "/certification");
        this.RECOMMENDATION_API = "".concat(PROFILE_API_BASE_PATH, "/recommendation");
        this.RECOMMENDATION_SORT_API = "".concat(PROFILE_API_BASE_PATH, "/recommendation-order");
        this.RECOMMENDATION_TOOLTIP_API = "".concat(PROFILE_API_BASE_PATH, "/recommendation-tooltip");
        this.PROFILE_INFO_API = "".concat(PROFILE_API_BASE_PATH, "/info");
        this.PROFILE_INFO_API_V2 = "".concat(PROFILE_API_BASE_PATH_V2, "/info");
        this.LEVEL_PARAMS_MAPPING = {
            1: "beginner",
            2: "intermediate",
            3: "advanced",
            4: "completed"
        };
        this._resumeDetail = new Promise(function(resolve) {
            _this._resumeDetailResolver = resolve;
        });
    }
    var _proto = ProfileService.prototype;
    _proto._getResumeDetailData = function _getResumeDetailData() {
        var _this = this;
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var token, soNo, aiResumeReviewPath, request, response;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _this._resumeDetailDataRequested = true;
                        _ctx.next = 3;
                        return _userService__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getAccessToken */ .Z.getAccessToken();
                    case 3:
                        token = _ctx.sent;
                        soNo = _this._aiSONO;
                        aiResumeReviewPath = "";
                        if (soNo) {
                            aiResumeReviewPath = "?soNo=".concat(soNo);
                        }
                        request = new Request(_this.RESUME_DETAIL_API + aiResumeReviewPath, {
                            method: "get",
                            headers: {
                                Authorization: "Bearer ".concat(token)
                            }
                        });
                        _ctx.next = 10;
                        return fetch(request);
                    case 10:
                        _ctx.next = 12;
                        return _ctx.sent.json();
                    case 12:
                        response = _ctx.sent;
                        // Cache the json data
                        _this._resumeDetailDataCache = response;
                        // Resolve the data
                        _this._resumeDetailResolver(response);
                        return _ctx.abrupt("return", response);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.setAIResumeReview = function setAIResumeReview(id) {
        this._aiSONO = id;
    };
    _proto.getResumeDetail = function getResumeDetail() {
        var _this = this;
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!_this._resumeDetailDataCache) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", _this._resumeDetailDataCache);
                    case 2:
                        // Otherwise, return the promise, we also need to fetch the data if it's not requested yet
                        if (!_this._resumeDetailDataRequested) _this._getResumeDetailData();
                        return _ctx.abrupt("return", _this._resumeDetail);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.createRequest = function createRequest(path) {
        var method = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "GET", body = arguments.length > 2 ? arguments[2] : void 0, langCode = arguments.length > 3 ? arguments[3] : void 0;
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var token, mainBody;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _userService__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getAccessToken */ .Z.getAccessToken();
                    case 2:
                        token = _ctx.sent;
                        mainBody = {
                            method: method,
                            headers: {
                                Authorization: "Bearer ".concat(token),
                                "Content-Type": "application/json",
                                "Accept-Language": langCode
                            }
                        };
                        if (method !== "GET" && method !== "HEAD") {
                            mainBody = Object.assign({}, mainBody, {
                                body: body
                            });
                        }
                        return _ctx.abrupt("return", new Request(path, mainBody));
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.createRequestForm = function createRequestForm(path, body, langCode) {
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var token, data, res;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _userService__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getAccessToken */ .Z.getAccessToken();
                    case 2:
                        token = _ctx.sent;
                        data = body;
                        _ctx.next = 6;
                        return fetch(path || "", {
                            body: data,
                            method: "POST",
                            headers: {
                                Authorization: "Bearer ".concat(token),
                                "Accept-Language": langCode
                            }
                        });
                    case 6:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res.json());
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.updateRequestForm = function updateRequestForm(path, body, langCode) {
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var token, data, res;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _userService__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getAccessToken */ .Z.getAccessToken();
                    case 2:
                        token = _ctx.sent;
                        data = body;
                        _ctx.next = 6;
                        return fetch(path || "", {
                            body: data,
                            method: "PUT",
                            headers: {
                                Authorization: "Bearer ".concat(token),
                                "Accept-Language": langCode
                            }
                        });
                    case 6:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res.json());
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.getRequestSingle = function getRequestSingle(path) {
        var _this = this;
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var request, response, responseData;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.createRequest(path);
                    case 2:
                        request = _ctx.sent;
                        _ctx.next = 5;
                        return fetch(request);
                    case 5:
                        response = _ctx.sent;
                        if (!response.ok) {
                            _ctx.next = 11;
                            break;
                        }
                        _ctx.next = 9;
                        return response.json();
                    case 9:
                        responseData = _ctx.sent;
                        return _ctx.abrupt("return", _objectSpread({}, responseData === null || responseData === void 0 ? void 0 : responseData.data.attributes, {
                            id: responseData === null || responseData === void 0 ? void 0 : responseData.data.id
                        }));
                    case 11:
                        return _ctx.abrupt("return", null);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.getRawData = function getRawData(path) {
        var _this = this;
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var request, response, responseData;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.createRequest(path);
                    case 2:
                        request = _ctx.sent;
                        _ctx.next = 5;
                        return fetch(request);
                    case 5:
                        response = _ctx.sent;
                        if (!response.ok) {
                            _ctx.next = 11;
                            break;
                        }
                        _ctx.next = 9;
                        return response.json();
                    case 9:
                        responseData = _ctx.sent;
                        return _ctx.abrupt("return", responseData);
                    case 11:
                        return _ctx.abrupt("return", null);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.getRequestCollection = function getRequestCollection(path) {
        var _this = this;
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var request, response, responseData, data;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.createRequest(path);
                    case 2:
                        request = _ctx.sent;
                        _ctx.next = 5;
                        return fetch(request);
                    case 5:
                        response = _ctx.sent;
                        if (!response.ok) {
                            _ctx.next = 14;
                            break;
                        }
                        _ctx.next = 9;
                        return response.json();
                    case 9:
                        responseData = _ctx.sent;
                        data = responseData.data;
                        if (!Array.isArray(data)) {
                            _ctx.next = 13;
                            break;
                        }
                        return _ctx.abrupt("return", data.map(function(item) {
                            return _objectSpread({}, item.attributes, {
                                id: item.id
                            });
                        }));
                    case 13:
                        return _ctx.abrupt("return", []);
                    case 14:
                        return _ctx.abrupt("return", []);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.postRequest = function postRequest(path, body, langCode) {
        var _this = this;
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var request, response, responseData;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.createRequest(path, "POST", body, langCode);
                    case 2:
                        request = _ctx.sent;
                        _ctx.next = 5;
                        return fetch(request);
                    case 5:
                        response = _ctx.sent;
                        _ctx.next = 8;
                        return response.json();
                    case 8:
                        responseData = _ctx.sent;
                        return _ctx.abrupt("return", {
                            data: responseData.data,
                            meta: responseData.meta,
                            error: responseData.message,
                            errorCode: responseData.errorCode
                        });
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.putRequest = function putRequest(path, body, langCode) {
        var _this = this;
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var request, response, responseData;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.createRequest(path, "PUT", body, langCode);
                    case 2:
                        request = _ctx.sent;
                        _ctx.next = 5;
                        return fetch(request);
                    case 5:
                        response = _ctx.sent;
                        _ctx.next = 8;
                        return response.json();
                    case 8:
                        responseData = _ctx.sent;
                        return _ctx.abrupt("return", {
                            data: responseData.data,
                            meta: responseData.meta,
                            error: responseData.message
                        });
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.deleteRequest = function deleteRequest(path, body) {
        var _this = this;
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var request, response, responseData;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.createRequest(path, "DELETE", body);
                    case 2:
                        request = _ctx.sent;
                        _ctx.next = 5;
                        return fetch(request);
                    case 5:
                        response = _ctx.sent;
                        _ctx.next = 8;
                        return response.json();
                    case 8:
                        responseData = _ctx.sent;
                        return _ctx.abrupt("return", {
                            data: responseData.data,
                            meta: responseData.meta,
                            error: responseData.message
                        });
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.getSummary = function getSummary() {
        var refresh = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var _this = this;
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var resumeDetail, ref, ref1;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!refresh) {
                            _ctx.next = 6;
                            break;
                        }
                        _ctx.next = 3;
                        return _this.getRequestSingle(_this.SUMMARY_API);
                    case 3:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 6:
                        _ctx.next = 8;
                        return _this.getResumeDetail();
                    case 8:
                        resumeDetail = _ctx.sent;
                        if (!resumeDetail) {
                            _ctx.next = 12;
                            break;
                        }
                        ;
                        return _ctx.abrupt("return", _objectSpread({}, (ref = resumeDetail.summary) === null || ref === void 0 ? void 0 : ref.data.attributes, {
                            resumeId: (ref1 = resumeDetail.summary) === null || ref1 === void 0 ? void 0 : ref1.data.id
                        }));
                    case 12:
                        return _ctx.abrupt("return", null);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.getRecommendTooltip = function getRecommendTooltip() {
        var _this = this;
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.getRawData(_this.RECOMMENDATION_TOOLTIP_API);
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.postRecommendTooltip = function postRecommendTooltip() {
        var _this = this;
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.postRequest(_this.RECOMMENDATION_TOOLTIP_API, JSON.stringify({}));
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.postSummary = function postSummary(summary, resumeId) {
        var _this = this;
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var request, response, resData, errorData;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.createRequest(_this.SUMMARY_API, "POST", JSON.stringify({
                            summary: summary,
                            resumeId: resumeId
                        }));
                    case 2:
                        request = _ctx.sent;
                        _ctx.next = 5;
                        return fetch(request);
                    case 5:
                        response = _ctx.sent;
                        if (!response.ok) {
                            _ctx.next = 13;
                            break;
                        }
                        _ctx.next = 9;
                        return response.json();
                    case 9:
                        resData = _ctx.sent;
                        return _ctx.abrupt("return", {
                            error: false,
                            data: {
                                id: resData === null || resData === void 0 ? void 0 : resData.data.id
                            }
                        });
                    case 13:
                        if (!(response.status === 400)) {
                            _ctx.next = 18;
                            break;
                        }
                        _ctx.next = 16;
                        return response.json();
                    case 16:
                        errorData = _ctx.sent;
                        return _ctx.abrupt("return", {
                            error: errorData.message || "",
                            data: null
                        });
                    case 18:
                        return _ctx.abrupt("return", {
                            error: "unknown",
                            data: null
                        });
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.getUserContactInfo = function getUserContactInfo() {
        var _this = this;
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var rawData, transformedData;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.getRequestSingle(_this.USER_CONTACT_INFO_API);
                    case 2:
                        rawData = _ctx.sent;
                        if (!rawData) {
                            _ctx.next = 6;
                            break;
                        }
                        transformedData = _objectSpread({}, rawData, {
                            isSearchable: Boolean(rawData.isSearchable),
                            birthday: rawData.birthday ? (0,_helpers_date__WEBPACK_IMPORTED_MODULE_1__/* .parseFromString */ .Xl)(rawData.birthday) : null
                        });
                        return _ctx.abrupt("return", Promise.resolve(transformedData));
                    case 6:
                        return _ctx.abrupt("return", null);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.updateUserContactInfo = function updateUserContactInfo(data) {
        var _this = this;
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var postData;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        postData = _objectSpread({}, data, {
                            isSearchable: data.isSearchable ? 1 : 0
                        });
                        return _ctx.abrupt("return", _this.postRequest(_this.USER_CONTACT_INFO_API, JSON.stringify(postData)));
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.getReference = function getReference() {
        var refresh = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var _this = this;
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var resumeDetail, ref;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!refresh) {
                            _ctx.next = 6;
                            break;
                        }
                        _ctx.next = 3;
                        return _this.getRequestCollection(_this.REFERENCE_API);
                    case 3:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 6:
                        _ctx.next = 8;
                        return _this.getResumeDetail();
                    case 8:
                        resumeDetail = _ctx.sent;
                        if (!resumeDetail) {
                            _ctx.next = 12;
                            break;
                        }
                        ;
                        return _ctx.abrupt("return", (ref = resumeDetail.references) === null || ref === void 0 ? void 0 : ref.data.map(function(item) {
                            return _objectSpread({}, item.attributes, {
                                id: item.id
                            });
                        }));
                    case 12:
                        return _ctx.abrupt("return", []);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.getRecommendation = function getRecommendation() {
        var _this = this;
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.getRequestCollection(_this.RECOMMENDATION_API);
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.postReference = function postReference(resumeId, data) {
        var _this = this;
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var id, restData, postData;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        id = data.id, restData = _objectWithoutProperties(data, [
                            "id"
                        ]);
                        postData = _objectSpread({}, restData, {
                            resumeId: resumeId,
                            referenceId: data.id
                        });
                        return _ctx.abrupt("return", _this.postRequest(_this.REFERENCE_API, JSON.stringify(postData)));
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.postRecommendation = function postRecommendation(data, isNew) {
        var _this = this;
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var url;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        url = _this.RECOMMENDATION_API;
                        if (isNew) {
                            _ctx.next = 4;
                            break;
                        }
                        url += "?type=sender&entryId=".concat(data.entryId);
                        return _ctx.abrupt("return", _this.putRequest(url, JSON.stringify(data)));
                    case 4:
                        return _ctx.abrupt("return", _this.postRequest(url, JSON.stringify(data)));
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.deleteRecommendation = function deleteRecommendation(entryId) {
        var _this = this;
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var deleteData;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        deleteData = {
                            entryId: entryId
                        };
                        return _ctx.abrupt("return", _this.deleteRequest(_this.RECOMMENDATION_API, JSON.stringify(deleteData)));
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.deleteReference = function deleteReference(resumeId, referenceId) {
        var _this = this;
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var postData;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        postData = {
                            resumeId: resumeId,
                            referenceId: referenceId
                        };
                        return _ctx.abrupt("return", _this.deleteRequest(_this.REFERENCE_API, JSON.stringify(postData)));
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.sortComponent = function sortComponent(resumeId, sortedIds, component) {
        var _this = this;
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var postData;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        postData = {
                            resumeId: resumeId,
                            id: sortedIds.reverse(),
                            component: component
                        };
                        return _ctx.abrupt("return", _this.postRequest(_this.SORT_API, JSON.stringify(postData)));
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.sortRecommendations = function sortRecommendations(orderIds) {
        var _this = this;
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var postData;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        postData = {
                            orderIds: orderIds
                        };
                        return _ctx.abrupt("return", _this.putRequest(_this.RECOMMENDATION_SORT_API, JSON.stringify(postData)));
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.getLevel = function getLevel() {
        var _this = this;
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", _this.getRequestSingle(_this.LEVEL_API));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.getLevelSuggestion = function getLevelSuggestion(levelId) {
        var _this = this;
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var levelParam;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        levelParam = _this.LEVEL_PARAMS_MAPPING[levelId] || null;
                        if (levelParam) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", Promise.resolve(null));
                    case 3:
                        return _ctx.abrupt("return", _this.getRequestSingle("".concat(_this.LEVEL_CALCULATE_API, "?level=").concat(levelParam)));
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.deleteAvatar = function deleteAvatar(resumeId) {
        var _this = this;
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var postData;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        postData = {
                            resumeId: resumeId
                        };
                        return _ctx.abrupt("return", _this.deleteRequest(_this.AVATAR_API, JSON.stringify(postData)));
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.getCertification = function getCertification() {
        var refresh = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var _this = this;
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var resumeDetail, ref;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!refresh) {
                            _ctx.next = 6;
                            break;
                        }
                        _ctx.next = 3;
                        return _this.getRequestCollection(_this.CERTIFICATION_API);
                    case 3:
                        return _ctx.abrupt("return", _ctx.sent.map(function(item) {
                            return _objectSpread({}, item, {
                                certificationId: item.id
                            });
                        }));
                    case 6:
                        _ctx.next = 8;
                        return _this.getResumeDetail();
                    case 8:
                        resumeDetail = _ctx.sent;
                        if (!resumeDetail) {
                            _ctx.next = 12;
                            break;
                        }
                        ;
                        return _ctx.abrupt("return", (ref = resumeDetail.certifications) === null || ref === void 0 ? void 0 : ref.data.map(function(item) {
                            return _objectSpread({}, item.attributes, {
                                certificationId: item.id
                            });
                        }));
                    case 12:
                        return _ctx.abrupt("return", []);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.postCertification = function postCertification(data) {
        var _this = this;
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", _this.postRequest(_this.CERTIFICATION_API, JSON.stringify(data)));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.deleteCertification = function deleteCertification(id) {
        var _this = this;
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", _this.deleteRequest(_this.CERTIFICATION_API, JSON.stringify({
                            certificationId: id
                        })));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.postProfileInfo = function postProfileInfo(data, langCode) {
        var _this = this;
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        data.isSearchable = data.isSearchable ? 1 : 0;
                        return _ctx.abrupt("return", _this.postRequest(_this.PROFILE_INFO_API_V2, JSON.stringify(data), langCode));
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.attachmentResumeLink = function attachmentResumeLink(params) {
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var resumeId, accessToken, requestOptions, response, fileLink, blob;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        resumeId = params.resumeId, accessToken = params.accessToken;
                        if (accessToken) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        requestOptions = {
                            method: "POST",
                            headers: {
                                Authorization: "Bearer ".concat(accessToken)
                            }
                        };
                        _ctx.next = 7;
                        return fetch("".concat(API_ATTACHMENT_RESUME_LINK).concat(resumeId), requestOptions);
                    case 7:
                        response = _ctx.sent;
                        fileLink = "";
                        if (!((response === null || response === void 0 ? void 0 : response.status) === 200)) {
                            _ctx.next = 14;
                            break;
                        }
                        _ctx.next = 12;
                        return response.blob();
                    case 12:
                        blob = _ctx.sent;
                        fileLink = URL.createObjectURL(blob);
                    case 14:
                        return _ctx.abrupt("return", fileLink);
                    case 17:
                        _ctx.prev = 17;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error("Error when get file link", _ctx.t0);
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    17
                ]
            ]);
        }))();
    };
    return ProfileService;
}();
var profileService = new ProfileService();
/* harmony default export */ __webpack_exports__["ZP"] = (profileService);


/***/ }),

/***/ 93184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O5": function() { return /* binding */ EProfileStrengthForm; },
/* harmony export */   "Yh": function() { return /* binding */ ESortableComponent; }
/* harmony export */ });
/* unused harmony export EAttachmentResumeType */
var EProfileStrengthForm;
(function(EProfileStrengthForm) {
    EProfileStrengthForm["CONTACT_INFO"] = "ContactInfo";
    EProfileStrengthForm["WORK_HISTORY"] = "WorkingHistories";
    EProfileStrengthForm["SKILLS"] = "Skills";
    EProfileStrengthForm["REFERENCES"] = "References";
    EProfileStrengthForm["WORKING_PREFERENCES"] = "WorkingPreferences";
    EProfileStrengthForm["BASIC_INFO"] = "BasicInfo";
    EProfileStrengthForm["SUMMARY"] = "Summary";
    EProfileStrengthForm["LANGUAGES"] = "Languages";
    EProfileStrengthForm["EDUCATIONS"] = "Educations";
    EProfileStrengthForm["RECOMMENDATION"] = "Recommendation";
    EProfileStrengthForm["PROJECTS"] = "Projects";
})(EProfileStrengthForm || (EProfileStrengthForm = {}));
var ESortableComponent;
(function(ESortableComponent) {
    ESortableComponent["Reference"] = "reference";
    ESortableComponent["WorkHistory"] = "experience";
    ESortableComponent["Education"] = "education";
    ESortableComponent["Activity"] = "activity";
    ESortableComponent["Certification"] = "certification";
    ESortableComponent["UserProjects"] = "project";
})(ESortableComponent || (ESortableComponent = {}));
var EAttachmentResumeType;
(function(EAttachmentResumeType) {
    EAttachmentResumeType[EAttachmentResumeType["Default"] = 0] = "Default";
    EAttachmentResumeType[EAttachmentResumeType["ViewApplied"] = 1] = "ViewApplied";
    EAttachmentResumeType[EAttachmentResumeType["NewUpload"] = 2] = "NewUpload";
})(EAttachmentResumeType || (EAttachmentResumeType = {}));


/***/ }),

/***/ 98688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Yc": function() { return /* binding */ EProfile; },
/* harmony export */   "t4": function() { return /* binding */ ESearchableStatus; }
/* harmony export */ });
/* unused harmony exports EProfileType, ERefreshProfile */
var ESearchableStatus;
(function(ESearchableStatus) {
    ESearchableStatus[ESearchableStatus["On"] = 1] = "On";
    ESearchableStatus[ESearchableStatus["Off"] = 0] = "Off";
})(ESearchableStatus || (ESearchableStatus = {}));
var EProfile;
(function(EProfile) {
    EProfile[EProfile["isAttach"] = 1] = "isAttach";
    EProfile[EProfile["isProfile"] = 0] = "isProfile";
})(EProfile || (EProfile = {}));
var EProfileType;
(function(EProfileType) {
    EProfileType["AttachCV"] = "attach-cv";
    EProfileType["Profile"] = "profile";
})(EProfileType || (EProfileType = {}));
var ERefreshProfile;
(function(ERefreshProfile) {
    ERefreshProfile[ERefreshProfile["Unset"] = 0] = "Unset";
    ERefreshProfile[ERefreshProfile["Daily"] = 1] = "Daily";
    ERefreshProfile[ERefreshProfile["Weekly"] = 2] = "Weekly";
})(ERefreshProfile || (ERefreshProfile = {}));


/***/ }),

/***/ 76219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ ESearchSetting; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var ESearchSetting;
(function(ESearchSetting) {
    ESearchSetting[ESearchSetting["DEFAULT"] = 0] = "DEFAULT";
    ESearchSetting[ESearchSetting["RELEVANT"] = 1] = "RELEVANT";
})(ESearchSetting || (ESearchSetting = {}));
var UserService = /*#__PURE__*/ function() {
    "use strict";
    function UserService() {
        var _this = this;
        _classCallCheck(this, UserService);
        this._userResolver = null;
        this._user = new Promise(function(resolve) {
            _this._userResolver = resolve;
        });
    }
    var _proto = UserService.prototype;
    _proto.setUser = function setUser(user) {
        this._userResolver && this._userResolver(user);
    };
    /**
     * This will return a user promise, and will resolve to `TAuthUser` or `null` if user has not signed in
     */ _proto.getUser = function getUser() {
        return this._user;
    };
    _proto.getAccessToken = function getAccessToken() {
        var _this = this;
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var user;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.getUser();
                    case 2:
                        user = _ctx.sent;
                        return _ctx.abrupt("return", (user === null || user === void 0 ? void 0 : user.accessToken) || "");
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    /**
     * This method is called once in Master Layout when the component mounted
     */ _proto.authenticate = function authenticate(jsToken, wsToken) {
        var _this = this;
        return _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var response, responseData, singleData, user;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetch("https://secure.vietnamworks.com/api/v1/users/get-info-from-token", {
                            method: "post",
                            headers: {
                                "Content-Type": "application/vnd.api+json",
                                Accept: "application/vnd.api+json"
                            },
                            body: JSON.stringify({
                                jsToken: jsToken,
                                wsToken: wsToken
                            })
                        });
                    case 2:
                        response = _ctx.sent;
                        if (!(response.status === 200)) {
                            _ctx.next = 13;
                            break;
                        }
                        _ctx.next = 6;
                        return response.json();
                    case 6:
                        responseData = _ctx.sent;
                        singleData = responseData.data[0];
                        user = _objectSpread({}, singleData.id, singleData.attributes);
                        _this.setUser(user);
                        return _ctx.abrupt("return", user);
                    case 13:
                        // If fail
                        _this.setUser(null);
                        return _ctx.abrupt("return", null);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return UserService;
}();
/* harmony default export */ __webpack_exports__["Z"] = (new UserService());


/***/ }),

/***/ 66591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ph": function() { return /* binding */ GET_JOB_ALERT_REQUEST; },
/* harmony export */   "sf": function() { return /* binding */ GET_JOB_ALERT_ERROR; },
/* harmony export */   "tx": function() { return /* binding */ GET_JOB_ALERT_SUCCESS; }
/* harmony export */ });
var GET_JOB_ALERT_REQUEST = "GET_JOB_ALERT_REQUEST";
var GET_JOB_ALERT_SUCCESS = "GET_JOB_ALERT_SUCCESS";
var GET_JOB_ALERT_ERROR = "GET_JOB_ALERT_ERROR";


/***/ }),

/***/ 50209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NB": function() { return /* binding */ iniStore; },
/* harmony export */   "lp": function() { return /* binding */ ProfileSettingProvider; },
/* harmony export */   "n2": function() { return /* binding */ useProfileSettingStore; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_Page_ProfileSettings_type__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97282);



var iniStore = {
    state: {
        resumeId: 0,
        isOpenToWork: false,
        statusRefresh: _components_Page_ProfileSettings_type__WEBPACK_IMPORTED_MODULE_2__/* .ERefreshProfile.Unset */ .m.Unset,
        expiredDate: "",
        isTurnOnRefresh: false
    },
    setState: function() {}
};
var Context = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext(iniStore);
var ProfileSettingProvider = function(param) {
    var children = param.children, state = param.state, setState = param.setState;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Context.Provider, {
        value: {
            state: state,
            setState: setState
        },
        children: children
    });
};
var useProfileSettingStore = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(Context);
};



/***/ }),

/***/ 25800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$m": function() { return /* binding */ ACTION_FINISHED; },
/* harmony export */   "FD": function() { return /* binding */ ACTION_SET_RECOMMENDATIONS; },
/* harmony export */   "Hl": function() { return /* binding */ ACTION_SET_RECOMMENDATION_FROM_REFERENCE; },
/* harmony export */   "ID": function() { return /* binding */ ACTION_LOADING; },
/* harmony export */   "NH": function() { return /* binding */ ACTION_SET_BREAKPOINT; },
/* harmony export */   "NL": function() { return /* binding */ ACTION_SET_DEVICE; },
/* harmony export */   "X3": function() { return /* binding */ ACTION_SET_RESUME; },
/* harmony export */   "YZ": function() { return /* binding */ ACTION_SET_LANGUAGE; },
/* harmony export */   "Z_": function() { return /* binding */ ACTION_SHOW_SETTING_PROFILE; },
/* harmony export */   "bx": function() { return /* binding */ ACTION_SET_LIST_WORK_HISTORY; },
/* harmony export */   "gS": function() { return /* binding */ ACTION_SET_USER; },
/* harmony export */   "gx": function() { return /* binding */ ACTION_SET_LIST_MORE_SECTION_LENGTH; },
/* harmony export */   "i6": function() { return /* binding */ ACTION_SET_RESUME_DETAIL; },
/* harmony export */   "lS": function() { return /* binding */ ACTION_SET_LIST_JOB_ALERT; },
/* harmony export */   "r2": function() { return /* binding */ ACTION_SET_CONTACT_INFO; },
/* harmony export */   "sC": function() { return /* binding */ ACTION_SET_PROFILE_LEVEL; },
/* harmony export */   "vQ": function() { return /* binding */ ACTION_SET_IS_MOBILE; },
/* harmony export */   "xM": function() { return /* binding */ ACTION_SET_LAST_BLOCK_UPDATE; },
/* harmony export */   "x_": function() { return /* binding */ ACTION_SET_RESUME_SETTING_INFO; },
/* harmony export */   "yT": function() { return /* binding */ ACTION_SET_BASIC_INFO; }
/* harmony export */ });
var ACTION_SET_USER = "SET_USER";
var ACTION_SET_IS_MOBILE = "SET_IS_MOBILE";
var ACTION_SET_DEVICE = "SET_DEVICE";
var ACTION_SET_PROFILE_LEVEL = "SET_PROFILE_LEVEL";
var ACTION_SET_LAST_BLOCK_UPDATE = "SET_LAST_BLOCK_UPDATE";
var ACTION_SET_CONTACT_INFO = "SET_CONTACT_INFO";
var ACTION_SET_RESUME = "SET_RESUME";
var ACTION_SET_LIST_MORE_SECTION_LENGTH = "SET_MORE_SECTION_LENGTH";
var ACTION_SET_LIST_WORK_HISTORY = "SET_LIST_WORK_HISTORY";
var ACTION_SET_LANGUAGE = "ACTION_SET_LANGUAGE";
var ACTION_SET_BREAKPOINT = "ACTION_SET_BREAKPOINT";
var ACTION_SET_LIST_JOB_ALERT = "ACTION_SET_LIST_JOB_ALERT";
var ACTION_SET_RESUME_SETTING_INFO = "SET_RESUME_SETTING_INFO";
var ACTION_LOADING = "ACTION_LOADING";
var ACTION_FINISHED = "ACTION_FINISHED";
var ACTION_SET_BASIC_INFO = "ACTION_SET_BASIC_INFO";
var ACTION_SET_RECOMMENDATIONS = "SET_RECOMMENDATION_LIST";
var ACTION_SET_RECOMMENDATION_FROM_REFERENCE = "SET_RECOMMENDATION_FROM_REFERENCE";
var ACTION_SET_RESUME_DETAIL = "ACTION_SET_RESUME_DETAIL";
var ACTION_SHOW_SETTING_PROFILE = "ACTION_SHOW_SETTING_PROFILE";


/***/ }),

/***/ 43634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "kA": function() { return /* binding */ AppStoreProvider; },
  "a2": function() { return /* binding */ EDevice; },
  "mI": function() { return /* binding */ ERefreshProfile; },
  "Yp": function() { return /* binding */ useJobAlertStore; },
  "oR": function() { return /* binding */ useStore; }
});

// UNUSED EXPORTS: initAppStoreState

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@microfrontends/app-shell-v2/dist/index.modern.js
var index_modern = __webpack_require__(64889);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./helpers/common.ts + 1 modules
var common = __webpack_require__(61105);
// EXTERNAL MODULE: ./store/actions.ts
var actions = __webpack_require__(25800);
;// CONCATENATED MODULE: ./store/reducer.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var reducer = function(state, action) {
    switch(action.type){
        case actions/* ACTION_SET_USER */.gS:
            {
                return _objectSpread({}, state, {
                    user: _objectSpread({}, state.user, action.payload)
                });
            }
        case actions/* ACTION_SET_IS_MOBILE */.vQ:
            {
                return _objectSpread({}, state, {
                    isMobile: action.payload || false
                });
            }
        case actions/* ACTION_SET_DEVICE */.NL:
            {
                if (state.device !== action.payload) {
                    return _objectSpread({}, state, {
                        device: action.payload
                    });
                } else {
                    return state;
                }
            }
        case actions/* ACTION_SET_PROFILE_LEVEL */.sC:
            {
                return _objectSpread({}, state, {
                    profileLevel: action.payload
                });
            }
        case actions/* ACTION_SET_LAST_BLOCK_UPDATE */.xM:
            {
                return _objectSpread({}, state, {
                    lastBlockUpdate: _toConsumableArray(state.lastBlockUpdate).concat([
                        action.payload.lastBlockUpdate
                    ]),
                    isDowngraded: action.payload.isDowngraded
                });
            }
        case actions/* ACTION_SET_CONTACT_INFO */.r2:
            {
                return _objectSpread({}, state, {
                    resume: _objectSpread({}, state.resume, {
                        contactInfo: _objectSpread({}, state.resume.contactInfo, action.payload)
                    })
                });
            }
        case actions/* ACTION_SET_RESUME */.X3:
            {
                return _objectSpread({}, state, {
                    resume: _objectSpread({}, state.resume, action.payload)
                });
            }
        case actions/* ACTION_SET_LIST_MORE_SECTION_LENGTH */.gx:
            {
                return _objectSpread({}, state, {
                    listMoreSectionsLength: action.payload
                });
            }
        case actions/* ACTION_SET_LIST_WORK_HISTORY */.bx:
            {
                return _objectSpread({}, state, {
                    workHistoryList: action.payload
                });
            }
        case actions/* ACTION_SET_LANGUAGE */.YZ:
            {
                return _objectSpread({}, state, {
                    langCode: action.payload
                });
            }
        case actions/* ACTION_SET_BREAKPOINT */.NH:
            {
                return _objectSpread({}, state, {
                    breakpoint: action.payload
                });
            }
        case actions/* ACTION_SET_LIST_JOB_ALERT */.lS:
            {
                return _objectSpread({}, state, {
                    listJobAlert: action.payload
                });
            }
        case actions/* ACTION_SET_RESUME_SETTING_INFO */.x_:
            {
                return _objectSpread({}, state, {
                    profileSettingInfo: action.payload
                });
            }
        case actions/* ACTION_LOADING */.ID:
            {
                return _objectSpread({}, state, {
                    loading: true
                });
            }
        case actions/* ACTION_FINISHED */.$m:
            {
                return _objectSpread({}, state, {
                    loading: false
                });
            }
        case actions/* ACTION_SET_BASIC_INFO */.yT:
            {
                return _objectSpread({}, state, {
                    profileInfo: action.payload
                });
            }
        case actions/* ACTION_SET_RECOMMENDATIONS */.FD:
            {
                return _objectSpread({}, state, {
                    recommendations: action.payload
                });
            }
        case actions/* ACTION_SET_RECOMMENDATION_FROM_REFERENCE */.Hl:
            {
                return _objectSpread({}, state, {
                    recommedation: action.payload
                });
            }
        case actions/* ACTION_SET_RESUME_DETAIL */.i6:
            {
                return _objectSpread({}, state, {
                    resumeDetail: action.payload.resumeDetail
                });
            }
        case actions/* ACTION_SHOW_SETTING_PROFILE */.Z_:
            {
                return _objectSpread({}, state, {
                    isShowPopupSetting: action.payload
                });
            }
    }
    return state;
};
/* harmony default export */ var store_reducer = (reducer);

// EXTERNAL MODULE: ./store/JobAlertStore/constant.ts
var constant = __webpack_require__(66591);
;// CONCATENATED MODULE: ./store/JobAlertStore/reducer.tsx
function reducer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function reducer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            reducer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var jobAlertReducer = function(state, action) {
    switch(action.type){
        case constant/* GET_JOB_ALERT_REQUEST */.Ph:
            {
                return reducer_objectSpread({}, state, {
                    loading: true
                });
            }
        case constant/* GET_JOB_ALERT_SUCCESS */.tx:
            {
                return {
                    first: false,
                    error: "",
                    loading: false,
                    data: action.payload
                };
            }
        case constant/* GET_JOB_ALERT_ERROR */.sf:
            {
                return {
                    first: false,
                    error: action.payload,
                    loading: false,
                    data: []
                };
            }
        default:
            return state;
    }
};
/* harmony default export */ var JobAlertStore_reducer = (jobAlertReducer);

;// CONCATENATED MODULE: ./store/JobAlertStore/index.tsx



var initJobAlertState = {
    first: true,
    loading: true,
    error: "",
    data: []
};
var JobAlertContext = /*#__PURE__*/ (0,react.createContext)({
    state: initJobAlertState,
    dispatch: function() {
        return null;
    }
});
var JobAlertProvider = function(param) {
    var children = param.children;
    var ref = (0,react.useReducer)(JobAlertStore_reducer, initJobAlertState), state = ref[0], dispatch = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(JobAlertContext.Provider, {
        value: {
            state: state,
            dispatch: dispatch
        },
        children: children
    });
};


// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/PostHog/HogProvider/index.js
var HogProvider = __webpack_require__(74313);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/PostHog/hooks/useHog/index.js + 1 modules
var useHog = __webpack_require__(89083);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/constants.js
var constants = __webpack_require__(96306);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Popup/index.js + 4 modules
var Popup = __webpack_require__(8918);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/LayoutSystem/Row.js
var Row = __webpack_require__(39724);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/LayoutSystem/Col.js
var Col = __webpack_require__(18978);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/UploadResumeModal/index.js + 11 modules
var UploadResumeModal = __webpack_require__(62024);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Utils/helpers.js + 1 modules
var helpers = __webpack_require__(75052);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/Toast/index.js + 2 modules
var Toast = __webpack_require__(60500);
// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/hooks/useMakeSearchable/index.js + 2 modules
var useMakeSearchable = __webpack_require__(13325);
// EXTERNAL MODULE: ./components/Page/ProfileSettings/index.tsx + 14 modules
var ProfileSettings = __webpack_require__(14325);
// EXTERNAL MODULE: ./components/Page/ProfileSettings/translations.ts
var translations = __webpack_require__(22825);
// EXTERNAL MODULE: ./components/Global/MainLayout/index.tsx + 2 modules
var MainLayout = __webpack_require__(37696);
// EXTERNAL MODULE: ./helpers/util.ts
var util = __webpack_require__(5672);
// EXTERNAL MODULE: ./components/Page/ProfileSettings/constants.tsx
var ProfileSettings_constants = __webpack_require__(72072);
// EXTERNAL MODULE: ./components/Page/ProfileSettings/services.ts
var services = __webpack_require__(80117);
// EXTERNAL MODULE: ./helpers/syncData/syncProfileSettingInfoStore.ts
var syncProfileSettingInfoStore = __webpack_require__(65310);
// EXTERNAL MODULE: ./store/ProfileSetting/index.tsx
var ProfileSetting = __webpack_require__(50209);
// EXTERNAL MODULE: ./components/Global/MainLayout/SideNavigation/constant.tsx
var SideNavigation_constant = __webpack_require__(86368);
;// CONCATENATED MODULE: ./services/openToWork.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

var OPEN_TO_WORK_ENDPOINT = "api-gateway/v1.0/profile/open-to-work";
var _NEXT_PUBLIC_MS_BASE_PATH;
var DOMAIN = (_NEXT_PUBLIC_MS_BASE_PATH = "https://ms.vietnamworks.com") !== null && _NEXT_PUBLIC_MS_BASE_PATH !== void 0 ? _NEXT_PUBLIC_MS_BASE_PATH : "";
var makePofileOpenToWork = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(param) {
        var isOpenToWork, langCode, accessToken, response, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    isOpenToWork = param.isOpenToWork, langCode = param.langCode, accessToken = param.accessToken;
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return fetch("".concat(DOMAIN, "/").concat(OPEN_TO_WORK_ENDPOINT), {
                        method: "POST",
                        headers: {
                            Authorization: "Bearer ".concat(accessToken),
                            "Content-Type": "application/json",
                            "Accept-Language": langCode
                        },
                        body: JSON.stringify({
                            isOpenToWork: isOpenToWork
                        })
                    });
                case 4:
                    response = _ctx.sent;
                    _ctx.next = 7;
                    return response.json();
                case 7:
                    data = _ctx.sent;
                    if (!(!data || data.error)) {
                        _ctx.next = 11;
                        break;
                    }
                    console.error(data.error);
                    return _ctx.abrupt("return", null);
                case 11:
                    return _ctx.abrupt("return", data.message);
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](1);
                    console.error(_ctx.t0);
                    return _ctx.abrupt("return", null);
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                14
            ]
        ]);
    }));
    return function makePofileOpenToWork(_) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./node_modules/@microfrontends/react-components/components/services/model/index.js
var model = __webpack_require__(90222);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./helpers/date.ts
var helpers_date = __webpack_require__(41978);
// EXTERNAL MODULE: ./components/Page/ProfileSettings/MakeProfileSearchable/makeProfileSearchable.css.tsx
var makeProfileSearchable_css = __webpack_require__(49279);
;// CONCATENATED MODULE: ./components/ProfileSettingContainer/index.tsx
function ProfileSettingContainer_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ProfileSettingContainer_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return ProfileSettingContainer_arrayLikeToArray(arr);
}
function ProfileSettingContainer_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ProfileSettingContainer_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ProfileSettingContainer_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ProfileSettingContainer_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function ProfileSettingContainer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function ProfileSettingContainer_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ProfileSettingContainer_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ProfileSettingContainer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ProfileSettingContainer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || ProfileSettingContainer_unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function ProfileSettingContainer_toConsumableArray(arr) {
    return ProfileSettingContainer_arrayWithoutHoles(arr) || ProfileSettingContainer_iterableToArray(arr) || ProfileSettingContainer_unsupportedIterableToArray(arr) || ProfileSettingContainer_nonIterableSpread();
}
function ProfileSettingContainer_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ProfileSettingContainer_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ProfileSettingContainer_arrayLikeToArray(o, minLen);
}





















var PROFILE_SETTINGS_TAB = "profile-settings";
var DELAY_TIME_TO_SHOW_POPUP = 1000;
function ProfileSettingContainer(param) {
    var children = param.children;
    var router = (0,next_router.useRouter)();
    var ref10 = useStore(), state = ref10.state, dispatch = ref10.dispatch;
    var langCode = state.langCode, user = state.user, profileSettingInfo = state.profileSettingInfo;
    var isOpen1 = state.isShowPopupSetting;
    var userProfileInfo = state.profileInfo;
    var resumeSetting = profileSettingInfo.resumeSetting, resumeSettingOption = profileSettingInfo.resumeSettingOption, searchableStatus1 = profileSettingInfo.searchableStatus, unContactable = profileSettingInfo.unContactable, profileInfo1 = profileSettingInfo.resumeSetting.profileInfo;
    var tracking = (0,useHog/* default */.Z)().tracking;
    var t = helpers/* createTranslator */.eX({
        translations: translations/* default */.Z,
        currentLanguage: langCode,
        defaultLanguage: constants/* ELanguage.EN */.Df.EN
    });
    var ref1 = (0,react.useState)(ProfileSetting/* iniStore.state */.NB.state), settingState = ref1[0], disPatchSettingState = ref1[1];
    var ref2 = (0,react.useState)(false), isShowUpload = ref2[0], setIsShowUpload = ref2[1];
    var ref3 = (0,react.useState)(false), isShowSetting = ref3[0], setIsShowSetting = ref3[1];
    var ref4 = (0,react.useState)(false), isShowUncontactable = ref4[0], setIsShowUncontactable = ref4[1];
    var ref5 = (0,react.useState)(1), attachCVStep = ref5[0], setAttachCVStep = ref5[1];
    var ref6 = (0,react.useState)(false), isOpenUploadCV = ref6[0], setIsOpenUploadCV = ref6[1];
    var settingRef = (0,react.useRef)();
    var timer = (0,react.useRef)();
    var isFromUploadResumeRef = (0,react.useRef)(false);
    var jobLevelList = (0,util/* getLocalizedOptions */.ty)(index_modern/* initialDataProvider.getLevels */.Bz.getLevels(), langCode);
    var locationList = (0,util/* getLocalizedOptions */.ty)(index_modern/* initialDataProvider.getLocations */.Bz.getLocations(), langCode);
    var nationalityOptions = (0,ProfileSettings_constants/* nationalityList */.Ah)(langCode);
    var countryOptions = (0,util/* getLocalizedOptions */.ty)(index_modern/* initialDataProvider.getCountries */.Bz.getCountries(), langCode);
    var cityOptions = (0,util/* getLocalizedOptions */.ty)(index_modern/* initialDataProvider.getLocations */.Bz.getLocations(), langCode);
    var districtOptions = index_modern/* initialDataProvider.getDistricts */.Bz.getDistricts();
    var ref7, _NEXT_PUBLIC_MS_BASE_PATH;
    var initDataMakeSearchable = {
        data: {
            resumes: ProfileSettingContainer_toConsumableArray([
                resumeSetting.profileInfo
            ]).concat(ProfileSettingContainer_toConsumableArray(resumeSetting.attachInfo)),
            profileSetting: resumeSettingOption,
            searchableStatus: searchableStatus1,
            unContactable: unContactable
        },
        accessToken: (ref7 = user === null || user === void 0 ? void 0 : user.accessToken) !== null && ref7 !== void 0 ? ref7 : "",
        langCode: langCode,
        baseMsUrl: (_NEXT_PUBLIC_MS_BASE_PATH = "https://ms.vietnamworks.com") !== null && _NEXT_PUBLIC_MS_BASE_PATH !== void 0 ? _NEXT_PUBLIC_MS_BASE_PATH : "",
        isUpdateCookies: false
    };
    var ref8 = _slicedToArray(useMakeSearchable/* default */.ZP(initDataMakeSearchable), 3), _ = ref8[0], handleSearchable = ref8[1], priorityResume = ref8[2];
    var doRefreshProfile = function() {
        var _ref = ProfileSettingContainer_asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        if (user === null || user === void 0 ? void 0 : user.accessToken) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", null);
                    case 3:
                        body = {
                            status: settingState.statusRefresh !== ERefreshProfile.Unset ? 1 : 0,
                            type: settingState.statusRefresh
                        };
                        _ctx.next = 6;
                        return (0,services/* apiMakeRefresh */.I9)(user.accessToken, langCode, body);
                    case 6:
                        res = _ctx.sent;
                        if (!(res.code === SideNavigation_constant/* SUCCESS_CODE */.Gh)) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", body);
                    case 9:
                        return _ctx.abrupt("return", null);
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error(_ctx.t0);
                        return _ctx.abrupt("return", null);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function doRefreshProfile() {
            return _ref.apply(this, arguments);
        };
    }();
    var opentoWork = function() {
        var _ref = ProfileSettingContainer_asyncToGenerator(runtime_default().mark(function _callee() {
            var res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        if (user === null || user === void 0 ? void 0 : user.accessToken) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", null);
                    case 3:
                        _ctx.next = 5;
                        return makePofileOpenToWork({
                            isOpenToWork: settingState.isOpenToWork ? 1 : 0,
                            langCode: langCode,
                            accessToken: user === null || user === void 0 ? void 0 : user.accessToken
                        });
                    case 5:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res);
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error(_ctx.t0);
                        return _ctx.abrupt("return", null);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    9
                ]
            ]);
        }));
        return function opentoWork() {
            return _ref.apply(this, arguments);
        };
    }();
    var onClose = function() {
        dispatch({
            type: actions/* ACTION_SHOW_SETTING_PROFILE */.Z_,
            payload: false
        });
        setIsShowSetting(false);
        setIsShowUpload(false);
        if (isFromUploadResumeRef.current) {
            window.location.reload();
            return;
        }
    };
    var getResumeInfo = function() {
        var _ref = ProfileSettingContainer_asyncToGenerator(runtime_default().mark(function _callee() {
            var resumeInfoResponse;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return (0,services/* apiGetResumeInfo */.iF)((user === null || user === void 0 ? void 0 : user.accessToken) || "");
                    case 3:
                        resumeInfoResponse = _ctx.sent;
                        if (resumeInfoResponse !== undefined && resumeInfoResponse.data !== undefined && resumeInfoResponse.data.attributes !== undefined) {
                            (0,syncProfileSettingInfoStore/* default */.Z)(resumeInfoResponse, profileSettingInfo, dispatch);
                        }
                        _ctx.next = 10;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error(_ctx.t0);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function getResumeInfo() {
            return _ref.apply(this, arguments);
        };
    }();
    var onSyncDataToStoreWhenDoneStep = function() {
        var _ref = ProfileSettingContainer_asyncToGenerator(runtime_default().mark(function _callee(step, value) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return getResumeInfo();
                    case 2:
                        if (step === 3) {
                            // Save Job title to user
                            dispatch({
                                type: actions/* ACTION_SET_USER */.gS,
                                payload: ProfileSettingContainer_objectSpread({}, user, {
                                    jobTitle: value.jobTitle
                                })
                            });
                            setIsShowSetting(true);
                        }
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSyncDataToStoreWhenDoneStep(step, value) {
            return _ref.apply(this, arguments);
        };
    }();
    var onClickAllowSearchable = function() {
        var _ref = ProfileSettingContainer_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, doSearchable, promiseRefreshProfile, promiseOpenToWork, response, isHasErr, ref9, statusRefresh, chooseCV;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        if (settingState.resumeId) {
                            _ctx.next = 6;
                            break;
                        }
                        Toast/* showToast */.CF(t("Error"), "Missing resume info", "error");
                        onClose();
                        return _ctx.abrupt("return");
                    case 6:
                        _ctx.next = 8;
                        return handleSearchable(true, settingState.resumeId);
                    case 8:
                        doSearchable = _ctx.sent;
                        if (!(!doSearchable || _instanceof(doSearchable, model/* default */.Z))) {
                            _ctx.next = 17;
                            break;
                        }
                        if (!profileSettingInfo.unContactable) {
                            _ctx.next = 14;
                            break;
                        }
                        onClose();
                        setIsShowUncontactable(true);
                        return _ctx.abrupt("return");
                    case 14:
                        Toast/* showToast */.CF(t("Error"), t("Something went wrong with your change!"), "error");
                        onClose();
                        return _ctx.abrupt("return");
                    case 17:
                        promiseRefreshProfile = doRefreshProfile();
                        promiseOpenToWork = opentoWork();
                        _ctx.next = 21;
                        return Promise.allSettled([
                            promiseRefreshProfile,
                            promiseOpenToWork
                        ]);
                    case 21:
                        response = _ctx.sent;
                        isHasErr = ((ref = response.filter(function(e) {
                            return e.status === "rejected";
                        })) === null || ref === void 0 ? void 0 : ref.length) > 0;
                        if (isHasErr) {
                            _ctx.next = 36;
                            break;
                        }
                        ;
                        settingRef.current = {
                            resumeId: settingState.resumeId,
                            isOpenToWork: settingState.isOpenToWork,
                            statusRefresh: settingState.statusRefresh,
                            expiredDate: settingState.expiredDate,
                            isTurnOnRefresh: settingState.statusRefresh !== ERefreshProfile.Unset
                        };
                        setTimeout(function() {
                            return getResumeInfo();
                        }, 1000);
                        Toast/* showToast */.CF(t("Success"), t("Your changes has been saved successfully!"));
                        statusRefresh = response[0].status === "fulfilled" ? (ref9 = response[0].value) === null || ref9 === void 0 ? void 0 : ref9.type : resumeSettingOption.chooseRefreshType;
                        chooseCV = profileInfo1.id === settingState.resumeId ? ProfileSettings_constants/* ResumeType.Profile */.$P.Profile : ProfileSettings_constants/* ResumeType.AttachCV */.$P.AttachCV;
                        (0,services/* apiUpdateResumeSetting */.$t)((user === null || user === void 0 ? void 0 : user.accessToken) || "", langCode, {
                            chooseCV: profileInfo1.id === settingState.resumeId ? ProfileSettings_constants/* ResumeType.Profile */.$P.Profile : ProfileSettings_constants/* ResumeType.AttachCV */.$P.AttachCV,
                            chooseRefreshType: statusRefresh,
                            resumeId: settingState.resumeId
                        });
                        tracking({
                            eventName: "js_profile_management:searchable_turn_on_success",
                            properties: {
                                isOnlineProfile: chooseCV === "profile",
                                isAttachment: chooseCV === "attach-cv",
                                resumeId: settingState.resumeId
                            }
                        });
                        if (response[0].status === "fulfilled" && settingState.statusRefresh !== ERefreshProfile.Unset) {
                            tracking({
                                eventName: "js_profile_management:refresh_turn_on_success",
                                properties: {
                                    typeRefresh: settingState.statusRefresh === 1 ? "daily" : "weekly",
                                    resumeId: settingState.resumeId,
                                    cvType: chooseCV
                                }
                            });
                        }
                        if (response[1].status === "fulfilled" && settingState.isOpenToWork) {
                            tracking({
                                eventName: "js_profile_management:urgent_turn_on_success"
                            });
                        }
                        onClose();
                        return _ctx.abrupt("return");
                    case 36:
                        Toast/* showToast */.CF(t("Error"), t("Something went wrong with your change!"), "error");
                        onClose();
                        return _ctx.abrupt("return");
                    case 41:
                        _ctx.prev = 41;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error(_ctx.t0);
                    case 44:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    41
                ]
            ]);
        }));
        return function onClickAllowSearchable() {
            return _ref.apply(this, arguments);
        };
    }();
    var memoConfigPopupUpload = (0,react.useMemo)(function() {
        var config = {
            showUploadResume: false,
            step: 1
        };
        if (!isOpen1 || !(profileSettingInfo === null || profileSettingInfo === void 0 ? void 0 : profileSettingInfo.meta)) {
            return config;
        }
        var meta = profileSettingInfo.meta, searchableStatus = profileSettingInfo.searchableStatus;
        // Don't have searchable status
        if (!meta.isAttach && searchableStatus === 0) {
            config.showUploadResume = true;
        } else if (meta.isAttach && !meta.isContactInformation) {
            config.showUploadResume = true;
            config.step = 2;
        } else if (meta.isAttach && meta.isContactInformation && !meta.isWorkingPreferenceWeb) {
            config.showUploadResume = true;
            config.step = 3;
        } else {
            config.showUploadResume = false;
            config.step = 1;
        }
        return config;
    }, [
        profileSettingInfo,
        isOpen1
    ]);
    var isDisableSearchableButton = (0,react.useMemo)(function() {
        var ref, ref11, ref12;
        var isEqual = true;
        if (((ref = settingRef.current) === null || ref === void 0 ? void 0 : ref.isOpenToWork) !== settingState.isOpenToWork) {
            isEqual = false;
        }
        if (((ref11 = settingRef.current) === null || ref11 === void 0 ? void 0 : ref11.resumeId) !== settingState.resumeId) {
            isEqual = false;
        }
        if (((ref12 = settingRef.current) === null || ref12 === void 0 ? void 0 : ref12.statusRefresh) !== settingState.statusRefresh) {
            isEqual = false;
        }
        var _resumeSetting = profileSettingInfo.resumeSetting, attachInfo = _resumeSetting.attachInfo, profileInfo = _resumeSetting.profileInfo;
        var isDisabledSearchableOnline = profileInfo.isSearchable === 0;
        var filteredSearchableAttach = attachInfo.filter(function(item) {
            return item.isSearchable === 1;
        });
        // Do not disable primary button when
        // There is no searchable is turned on
        if (filteredSearchableAttach.length === 0 && isDisabledSearchableOnline) {
            return false;
        }
        return isEqual;
    }, [
        settingState
    ]);
    var onCloseUploadResumeModal = function() {
        setIsShowUpload(false);
        dispatch({
            type: actions/* ACTION_SHOW_SETTING_PROFILE */.Z_,
            payload: false
        });
        isFromUploadResumeRef.current = true;
    };
    var onCancelUploadResumeModal = function() {
        if (false) {}
        window.location.reload();
    };
    var getRefresh = function() {
        var _ref = ProfileSettingContainer_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, response, ref13, ref14, ref15, ref16, ref17, ref18, date, ref19;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (user === null || user === void 0 ? void 0 : user.accessToken) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        _ctx.next = 5;
                        return (0,services/* apiGetRefresh */.Vi)(user === null || user === void 0 ? void 0 : user.accessToken);
                    case 5:
                        response = _ctx.sent;
                        if (((ref = response.meta) === null || ref === void 0 ? void 0 : ref.status) === 200) {
                            ;
                            date = new Date();
                            date.setDate(date.getDate() + 15);
                            ;
                            disPatchSettingState(ProfileSettingContainer_objectSpread({}, settingState, {
                                expiredDate: (0,helpers_date/* convertDateTime */.jF)(((ref13 = response.data) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.attributes) === null || ref14 === void 0 ? void 0 : ref14.expiredDate) || date, 7),
                                statusRefresh: (ref19 = (ref15 = response.data) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.attributes) === null || ref16 === void 0 ? void 0 : ref16.type) !== null && ref19 !== void 0 ? ref19 : 0,
                                isTurnOnRefresh: ((ref17 = response.data) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.attributes) === null || ref18 === void 0 ? void 0 : ref18.isTurnOn) === 1
                            }));
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getRefresh() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (!isOpen1) {
            return;
        }
        var _resumeSetting = profileSettingInfo.resumeSetting, attachInfo = _resumeSetting.attachInfo, profileInfo = _resumeSetting.profileInfo;
        var ref;
        var currentSearchableResumeId = profileInfo.isSearchable === 1 ? profileInfo.id : (ref = priorityResume === null || priorityResume === void 0 ? void 0 : priorityResume.id) !== null && ref !== void 0 ? ref : 0;
        // Profile online is not searchable then maybe attach is searchable
        if (profileInfo.isSearchable === 0) {
            var filteredAttach = attachInfo.filter(function(item) {
                return item.isSearchable === 1;
            });
            if (filteredAttach.length > 0) {
                currentSearchableResumeId = filteredAttach[0].id;
            }
        }
        if ((priorityResume === null || priorityResume === void 0 ? void 0 : priorityResume.id) && typeof priorityResume.id === "number") {
            var ref20, ref21;
            var settingValue = {
                resumeId: currentSearchableResumeId,
                statusRefresh: resumeSettingOption.chooseRefreshType,
                expiredDate: ""
            };
            disPatchSettingState(ProfileSettingContainer_objectSpread({}, settingValue, settingState));
            var ref22, ref23;
            settingRef.current = ProfileSettingContainer_objectSpread({}, settingValue, {
                isOpenToWork: (ref22 = (ref20 = settingRef.current) === null || ref20 === void 0 ? void 0 : ref20.isOpenToWork) !== null && ref22 !== void 0 ? ref22 : settingState.isOpenToWork,
                isTurnOnRefresh: (ref23 = (ref21 = settingRef.current) === null || ref21 === void 0 ? void 0 : ref21.isTurnOnRefresh) !== null && ref23 !== void 0 ? ref23 : settingState.isTurnOnRefresh
            });
        }
        if (memoConfigPopupUpload.showUploadResume) {
            setIsShowUpload(isOpen1);
        } else {
            setIsShowSetting(isOpen1);
        }
    }, [
        isOpen1,
        memoConfigPopupUpload,
        priorityResume
    ]);
    (0,react.useEffect)(function() {
        if (timer.current) {
            clearTimeout(timer.current);
            return;
        }
        var tab = router.query.tab;
        if (tab !== PROFILE_SETTINGS_TAB) return;
        timer.current = setTimeout(function() {
            dispatch({
                type: actions/* ACTION_SHOW_SETTING_PROFILE */.Z_,
                payload: true
            });
            router.replace(router.pathname, undefined, {
                shallow: true
            });
        }, DELAY_TIME_TO_SHOW_POPUP);
        return function() {
            onClose();
            clearTimeout(timer.current);
        };
    }, []);
    (0,react.useEffect)(function() {
        var onCloseProfileSettingPopup = function() {
            setIsOpenUploadCV(true);
            setAttachCVStep(2);
            onClose();
        };
        window.addEventListener("CLOSE_PROFILE_SETTING_POPUP", onCloseProfileSettingPopup);
        return function() {
            window.removeEventListener("CLOSE_PROFILE_SETTING_POPUP", onCloseProfileSettingPopup);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (!(user === null || user === void 0 ? void 0 : user.accessToken)) {
            return;
        }
        getRefresh();
    }, [
        user === null || user === void 0 ? void 0 : user.accessToken
    ]);
    (0,react.useEffect)(function() {
        if (userProfileInfo.userId === 0) {
            return;
        }
        var currentIsOpenToWork = userProfileInfo.isOpenToWork === 1;
        disPatchSettingState(ProfileSettingContainer_objectSpread({}, settingState, {
            isOpenToWork: currentIsOpenToWork
        }));
    }, [
        userProfileInfo
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProfileSetting/* ProfileSettingProvider */.lp, {
        state: settingState,
        setState: disPatchSettingState,
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popup/* default */.Z, {
                isShow: isShowSetting,
                lang: langCode,
                text: {
                    header: t("Profile Settings"),
                    secondaryBtn: t("Cancel"),
                    primaryBtn: t("Searchable")
                },
                onClose: onClose,
                onClickOutside: onClose,
                onClickPrimary: onClickAllowSearchable,
                option: {
                    disabledPrimary: isDisableSearchableButton
                },
                custom: {
                    additionalFooterHeight: 0
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    container: {
                        sm: 16
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileSettings/* default */.Z, {})
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popup/* default */.Z, {
                isShow: isShowUncontactable,
                onClose: function() {
                    return setIsShowUncontactable(false);
                },
                onClickPrimary: function() {
                    return setIsShowUncontactable(false);
                },
                onClickOutside: function() {
                    return setIsShowUncontactable(false);
                },
                lang: langCode,
                styleOption: {
                    size: "sm"
                },
                text: {
                    header: t("Searchable CV is disable")
                },
                option: {
                    isShowSecondaryButton: false
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(makeProfileSearchable_css/* WarningSearchableModal */.dd, {
                    children: [
                        t("Your searchable CV is disable now because of wrong contact information. Please contact with Vietnamworks to verify your information by email:"),
                        "\xa0",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "mailto:contact@vietnamworks.com",
                            children: "contact@vietnamworks.com"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadResumeModal/* default */.Z, {
                isOpen: isShowUpload,
                onClose: onCloseUploadResumeModal,
                onCancel: onCancelUploadResumeModal,
                jobLevelOptions: jobLevelList.filter(function(item) {
                    return item.id !== -1;
                }),
                jobLocationOptions: locationList,
                jobIndustryOptions: index_modern/* initialDataProvider.getIndustries */.Bz.getIndustries(),
                jobFunctionOptions: index_modern/* initialDataProvider.getJobFunction */.Bz.getJobFunction(),
                nationalityOptions: nationalityOptions,
                countryOptions: countryOptions,
                cityOptions: cityOptions,
                districtOptions: districtOptions,
                accessToken: user === null || user === void 0 ? void 0 : user.accessToken,
                apiAutoCompleteJobTitle: "/api-gateway/v1.0/suggest-job-title",
                baseApiUrl: "https://ms.vietnamworks.com",
                lang: langCode,
                stepJump: memoConfigPopupUpload.step,
                resumeId: profileInfo1.id,
                checkDoneStep: onSyncDataToStoreWhenDoneStep,
                isReplace: true,
                enableJobFunction: MainLayout/* ENABLE_JOB_FUNCTION */.Mp
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadResumeModal/* default */.Z, {
                isOpen: isOpenUploadCV,
                onTogglePopup: function(isOpen) {
                    return setIsOpenUploadCV(isOpen);
                },
                isReloadOnClose: true,
                onClose: function() {
                    return setIsOpenUploadCV(false);
                },
                jobLevelOptions: jobLevelList.filter(function(item) {
                    return item.id !== -1;
                }),
                jobLocationOptions: locationList,
                jobIndustryOptions: index_modern/* initialDataProvider.getIndustries */.Bz.getIndustries(),
                jobFunctionOptions: index_modern/* initialDataProvider.getJobFunction */.Bz.getJobFunction(),
                nationalityOptions: nationalityOptions,
                countryOptions: countryOptions,
                cityOptions: cityOptions,
                districtOptions: districtOptions,
                accessToken: user === null || user === void 0 ? void 0 : user.accessToken,
                apiAutoCompleteJobTitle: "/api-gateway/v1.0/suggest-job-title",
                baseApiUrl: "https://ms.vietnamworks.com",
                lang: langCode,
                stepJump: attachCVStep,
                hiddenStep: attachCVStep - 1,
                resumeId: profileInfo1.id,
                isReplace: true,
                enableJobFunction: MainLayout/* ENABLE_JOB_FUNCTION */.Mp
            })
        ]
    });
}
/* harmony default export */ var components_ProfileSettingContainer = (/*#__PURE__*/(0,react.memo)(ProfileSettingContainer));

;// CONCATENATED MODULE: ./store/index.tsx
function store_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function store_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            store_defineProperty(target, key, source[key]);
        });
    }
    return target;
}








var EDevice;
(function(EDevice) {
    EDevice["MOBILE"] = "mobile";
    EDevice["TABLET"] = "tablet";
    EDevice["LAPTOP"] = "laptop";
    EDevice["DESKTOP"] = "desktop";
})(EDevice || (EDevice = {}));
var ERefreshProfile;
(function(ERefreshProfile) {
    ERefreshProfile[ERefreshProfile["Unset"] = 0] = "Unset";
    ERefreshProfile[ERefreshProfile["Daily"] = 1] = "Daily";
    ERefreshProfile[ERefreshProfile["Weekly"] = 2] = "Weekly";
})(ERefreshProfile || (ERefreshProfile = {}));
var initAppStoreState = {
    langCode: index_modern/* ELanguage.VI */.Df.VI,
    device: EDevice.TABLET,
    user: null,
    t: (0,common/* createTFunction */.Qz)(index_modern/* ELanguage.VI */.Df.VI),
    reverseTranslate: (0,common/* createReverseTranslateFunction */.MC)(index_modern/* ELanguage.VI */.Df.VI),
    isMobile: false,
    lastBlockUpdate: [],
    isDowngraded: false,
    resume: {
        contactInfo: {
            phone: null
        },
        highestDegreeId: 0
    },
    workHistoryList: [],
    listMoreSectionsLength: {
        activity: 0,
        certification: 0
    },
    breakpoint: "md",
    profileLevel: {
        level: 0,
        passedPoints: 0,
        totalPoints: 0,
        status: "",
        profileStrength: 0
    },
    profileSettingInfo: {
        resumeSetting: {
            attachInfo: [
                {
                    allowSearchableDisplay: 0,
                    fileName: "",
                    link: "",
                    size: 0,
                    id: 0,
                    isAttach: 1,
                    isSearchable: 0,
                    updatedDate: 0
                }
            ],
            profileInfo: {
                allowSearchableDisplay: 0,
                fileName: "",
                link: "",
                size: 0,
                id: 0,
                isAttach: 0,
                isSearchable: 0,
                updatedDate: 0
            }
        },
        searchableStatus: 0,
        unContactable: 0,
        meta: {
            isAttach: false,
            isBasicInfo: false,
            isContactInformation: false,
            isWorkingPreference: false,
            isWorkingPreferenceWeb: false
        },
        resumeSettingOption: {
            chooseCV: "",
            chooseRefreshType: 0,
            resumeId: 0
        }
    },
    loading: false,
    profileInfo: {
        userId: 0,
        resumeId: 0,
        firstName: "",
        lastName: "",
        fullName: "",
        highestDegreeId: 0,
        isDownload: false,
        isOpenToWork: 0,
        jobTitle: "",
        jobLevelId: 0,
        yearsExperience: -1,
        avatar: "",
        lastCompany: "",
        wowcvTemplateId: 0,
        currentSalary: 0,
        currentIndustries: [],
        currentJobFunction: []
    },
    recommedation: null,
    recommendations: [],
    resumeDetail: null,
    isShowPopupSetting: false
};
var isOptOutUserAgentFilter = "1" === "1";
var StoreContext = /*#__PURE__*/ react.createContext({
    state: initAppStoreState,
    dispatch: function() {
        return null;
    }
});
var GlobalProvider = function(param) {
    var children = param.children, _langCode = param.langCode, langCode = _langCode === void 0 ? index_modern/* ELanguage.VI */.Df.VI : _langCode;
    var ref = (0,react.useReducer)(store_reducer, store_objectSpread({}, initAppStoreState, {
        langCode: langCode
    })), state = ref[0], dispatch = ref[1];
    var t = (0,common/* createTFunction */.Qz)(state.langCode);
    var reverseTranslate = (0,common/* createReverseTranslateFunction */.MC)(state.langCode);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreContext.Provider, {
        value: {
            state: store_objectSpread({}, state, {
                t: t,
                reverseTranslate: reverseTranslate
            }),
            dispatch: dispatch
        },
        children: children
    });
};
var AppStoreProvider = function(param) {
    var children = param.children, _langCode = param.langCode, langCode = _langCode === void 0 ? index_modern/* ELanguage.VI */.Df.VI : _langCode;
    var _NEXT_PUBLIC_POSTHOG_API_KEY, _NEXT_PUBLIC_POSTHOG_API_HOST;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalProvider, {
        langCode: langCode,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HogProvider/* default */.Z, {
            posthogConfig: {
                key: (_NEXT_PUBLIC_POSTHOG_API_KEY = "phc_MPcl1lKQzHItt2rWP3yrQgoIeqjtTgJ4ngki2IWCP5A") !== null && _NEXT_PUBLIC_POSTHOG_API_KEY !== void 0 ? _NEXT_PUBLIC_POSTHOG_API_KEY : "",
                host: (_NEXT_PUBLIC_POSTHOG_API_HOST = "https://pht.vietnamworks.com") !== null && _NEXT_PUBLIC_POSTHOG_API_HOST !== void 0 ? _NEXT_PUBLIC_POSTHOG_API_HOST : "",
                options: {
                    optOutUserAgentFilter: isOptOutUserAgentFilter
                }
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ProfileSettingContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JobAlertProvider, {
                    children: children
                })
            })
        })
    });
};
var useStore = function() {
    return (0,react.useContext)(StoreContext);
};
var useJobAlertStore = function() {
    return (0,react.useContext)(JobAlertContext);
};



/***/ }),

/***/ 20279:
/***/ (function(module) {

module.exports = JSON.parse('{"meta_title":"Tuyển dụng, việc làm, tìm việc làm nhanh mới nhất","meta_description":"Tìm kiếm thông tin tuyển dụng và việc làm nhanh hơn tại website việc làm lớn nhất Việt Nam. Cập nhật công việc mới mỗi ngày. Tìm hiểu ngay tại VietnamWorks!","Job Title":"Chức Danh","Years of Experience:":"Năm Kinh Nghiệm:","Years":"Năm","Year":"Năm","years":"năm","year":"năm","Update":"Cập Nhật","year experience":"năm kinh nghiệm","years experience":"năm kinh nghiệm","Latest Company":"Công Ty Gần Đây Nhất","e.g. VietnamWorks":"Ví dụ: VietnamWorks","Highest Education":"Bằng Cấp Cao Nhất","First Name":"Tên","This field is required.":"Vui lòng nhập thông tin.","Basic Information":"Thông Tin Cơ Bản","Year Of Experience need to be more than 0":"Số năm kinh nghiệm phải lớn hơn 0","Your Basic Information has been updated successfully":"Thông Tin Cơ Bản của bạn đã được cập nhật thành công","Last Name":"Họ","Current job title e.g. Developer":"Vị trí hiện tại. Ví du: Developer","Current Job Level":"Cấp bậc hiện tại","Current Job Function":"Ngành nghề hiện tại","Select job function":"Chọn ngành nghề","Current Industry":"Lĩnh vực hiện tại","Current Salary":"Mức lương hiện tại","I am a new graduate / have no work experience":"Tôi mới tốt nghiệp / chưa có kinh nghiệm làm việc","Add Year of Experience":"Thêm Số năm kinh nghiệm","Years of Experience":"Số Năm Kinh Nghiệm","e.g. 7":"Ví dụ: 7","Please select...":"Vui lòng chọn...","This is required field":"Thông tin bắt buộc","Add Job Title":"Thêm Chức Danh","Add Latest Company":"Thêm Công Ty Gần Đây Nhất","Add Highest Education":"Thêm Bằng Cấp Cao Nhất","Add Current Job Level":"Thêm Cấp Bậc Hiện Tại","Add Address":"Thêm Địa Chỉ","Add Expected Location":"Thêm nơi làm việc","Add Expected Salary":"Thêm mức lương mong muốn","Please do not enter numbers or special characters.":"Vui lòng không nhập số hoặc kí tự đặc biệt.","Please do not enter phone number or email.":"Vui lòng không nhập số điện thoại hoặc email","Please do not enter special characters.":"Vui lòng không nhập kí tự đặc biệt.","Delete Education":"Xóa Bằng Cấp","Are you sure you want to delete this Education?":"Bạn có chắc muốn xóa bằng cấp này không?","Your Education has been created successfully":"Học Vấn của bạn đã được thêm thành công","Your Education has been updated successfully":"Học Vấn của bạn đã được cập nhật thành công","Your Education has been deleted successfully":"Học Vấn của bạn đã được xóa thành công","Your Education has been sorted successfully":"Học Vấn của bạn đã được sắp xếp thành công","e.g. 09/2008 - 12/2014":"Ví dụ: 09/2008 - 12/2014","jobTitle is invalid":"Chức danh không phù hợp","Cancel":"Hủy","Close":"Đóng","Save":"Lưu","Send email":"Gửi email","Edit":"Thay Đổi","My Profile":"Hồ Sơ Của Tôi","/my-profile":"/ho-so","Account Settings":"Quản Lý Tài Khoản","/account-settings":"/quan-ly-tai-khoan","High school":"Trung học","Associate\'s degree":"Trung cấp","College":"Cao đẳng","Bachelors":"Cử nhân","Masters":"Thạc sĩ","Doctorate":"Tiến sĩ","Others":"Khác","Career Objective":"Mục Tiêu Nghề Nghiệp","Summary":"Thông Tin Chung","Introduce yourself and describe your career objectives":"Giới thiệu bản thân và miêu tả mục tiêu nghề nghiệp của bạn","Add Career Objective Information":"Thêm Mục Tiêu Nghề Nghiệp","Career Objective has been updated successfully":"Mục Tiêu Nghề Nghiệp của bạn đã được cập nhật thành công","Skills":"Kỹ Năng","Skill Name":"Tên Kỹ Năng","Level":"Trình Độ","Type your area of expertise.":"Hãy điền thông tin về lĩnh vực chuyên môn của bạn.","In this section, you should list skills that are relevant to the position or career area you are interested in.":"Trong phần này, bạn nên liệt kê các kỹ năng phù hợp với vị trí hoặc lĩnh vực nghề nghiệp mà bạn quan tâm.","Add Skill":"Thêm Kỹ Năng","Add New Skills":"Thêm Kỹ Năng Mới","Your Skill":"Kỹ Năng Của Bạn","Edit Skills":"Sửa Kỹ Năng","Add Skills":"Thêm Kỹ Năng","Suggested Skills For You":"Kỹ Năng Được Đề Xuất","Your skill tags are under reviewing and will appear when it approve":"Kỹ năng của bạn đang được xem xét và sẽ xuất hiện sau khi được phê duyệt","Your Skill has been added successfully":"Kỹ Năng của bạn đã được thêm thành công","Your Skill has been updated successfully":"Kỹ năng của bạn đã được cập nhật thành công","Your Skill has been removed successfully":"Kỹ Năng của bạn đã được xóa thành công","Skill cannot be blank":"kỹ năng không được trống","You have reached the maximum number of skills. Please delete one to add another.":"Số lượng kỹ năng bạn tạo đã đạt mức tối đa. Vui lòng bỏ bớt để tạo thêm.","Some skills which have been deleted due to our new Skill Tag Policy":"Bạn có những từ khóa bị xoá theo Chính Sách Từ Khoá mới của chúng tôi","delete skill error":"Lỗi khi xóa kỹ năng","View the list":"Xem danh sách","Add":"Thêm","Languages":"Ngoại Ngữ","Language":"Ngoại Ngữ","Add Language":"Thêm Ngoại Ngữ","Edit Language":"Sửa Ngoại Ngữ","Remove Language":"Xóa Ngoại Ngữ","Add all the languages you can speak to increase your job prospects.":"Cập nhật thông tin ngoại ngữ, điều này sẽ giúp tăng triển vọng tìm kiếm công việc.","Your Language has been added successfully":"Ngôn Ngữ của bạn đã được thêm thành công","Your Language has been updated successfully":"Ngôn Ngữ của bạn đã được cập nhật thành công","Your Language has been sorted successfully":"Ngôn Ngữ của bạn đã được sắp xếp thành công","Your Language has been removed successfully":"Ngôn Ngữ của bạn đã được xóa thành công","invalid language (max item is 3)":"Chỉ có thể nhập tối đa 3 ngôn ngữ","Are you sure you want to remove this language ?":"Bạn có chắc muốn xóa ngôn ngữ này không ?","Fields cannot be blank":"Thông tin không được trống","Proficiency":"Mức Độ Thành Thạo","Add References":"Thêm Người Tham Khảo","Edit References":"Sửa Người Tham Khảo","Delete Reference":"Xóa Người Tham Khảo","Reference":" Người Tham Khảo","Recommendations":"Lời Nhận Xét","Add A Recommendation Request":"Tạo Yêu Cầu Nhận Xét","References help increase the credibility of your profile and provides you with an opportunity to prove your competence.":"Thông tin Người Tham Khảo giúp tăng độ tin cậy cho hồ sơ của bạn và là cơ hội giúp bạn chứng minh năng lực của bản thân.","Are you sure you want to delete this Reference?":"Bạn có chắc muốn xóa Người Tham Khảo này không?","Full Name":"Họ Tên","Recommender\'s Full Name":"Họ Tên Của Người Nhận Xét","Position":"Chức Danh","Company":"Công Ty","Phone Number":"Số Điện Thoại","Input your cell number":"Số điện thoại của bạn","Add Reference":"Thêm Người Tham Khảo","Add a recommendation request":"Tạo yêu cầu nhận xét","Add New Reference":"Thêm Người Tham Khảo","Edit Reference":"Chỉnh Sửa Người Tham Khảo","Your Reference has been created successfully":"Người Tham Khảo của bạn đã được thêm thành công","Your Reference has been updated successfully":"Người Tham Khảo của bạn đã được cập nhật thành công","Your Reference has been removed successfully":"Người Tham Khảo của bạn đã được xóa thành công","You sent a request for a recommenadtion successfully.":"Bạn đã thành công gửi yêu cầu viết nhận xét.","Your Recommendations has been updated successfully":"Lời Nhận Xét của bạn đã được cập nhật thành công","Your Recommendations has been removed successfully":"Lời Nhận Xét của bạn đã được xóa thành công","Are you sure you want to delete this Recommendations?":"Bạn có chắc muốn xóa Lời Nhận Xét này không?","Delete Recommendations":"Xóa Lời Nhận Xét","No Result Found":"Không Có Kết Quả Nào","Search":"Tìm","Successfully":"Thành Công","Success":"Thành Công","Error":"Lỗi","Work History":"Kinh Nghiệm Làm Việc","Months":"Tháng","Month":"Tháng","months":"tháng","month":"tháng","Add Work Experience":"Thêm Kinh Nghiệm Làm Việc","Add New Work Experience":"Thêm Kinh Nghiệm Làm Việc","Edit Work Experience":"Sửa Kinh Nghiệm Làm Việc","Delete Work History":"Xóa Kinh Nghiệm","Are you sure you want to delete this Work History?":"Bạn có chắc muốn xóa kinh nghiệm này không?","Your Work History has been added successfully":"Kinh Nghiệm Làm Việc của bạn đã được thêm thành công","Your Work History has been updated successfully":"Kinh Nghiệm Làm Việc của bạn đã được cập nhật thành công","Your Work History has been deleted successfully":"Kinh Nghiệm Làm Việc của bạn đã được xóa thành công","Your Work History has been sorted successfully":"Kinh Nghiệm Làm Việc của bạn đã được sắp xếp thành công","Delete":"Xóa","Input details of your employment history. The more detail you include about your previous experience, the more likely you are to appear in search results":"Mô tả kinh nghiệm làm việc của bạn càng chi tiết càng tốt, điều đó giúp bạn có cơ hội hiển thị nhiều hơn trong kết quả tìm kiếm","From Date":"Từ Ngày","To Date":"Đến Ngày","From Month":"Từ Tháng","To Month":"Đến Tháng","Description":"Mô Tả","The from month must be before to month":"Tháng kết thúc phải lớn hơn tháng bắt đầu","You\'ve created a new work history successfully":"Kinh nghiệm làm việc đã được thêm mới","You\'ve updated work history successfully":"Kinh nghiệm làm việc đã được cập nhật","/my-career-center/dashboard":"/quan-ly-nghe-nghiep/tong-quan","/my-career-center/who-view-my-resume":"/quan-ly-nghe-nghiep/nha-tuyen-dung-nao-xem-ho-so-cua-ban","/my-career-center/my-jobs":"/quan-ly-nghe-nghiep/viec-lam-cua-toi","/my-career-center/my-job-alert":"/quan-ly-nghe-nghiep/thong-bao-viec-lam","/my-career-center/profile-settings":"/quan-ly-nghe-nghiep/thiet-lap-ho-so","/my-career-center/referral-candidates":"/quan-ly-nghe-nghiep/gioi-thieu-ung-vien","/my-career-center/my-companies":"/quan-ly-nghe-nghiep/cong-ty-cua-toi","/my-profile?tab=profile-settings&scroll=true":"/ho-so?tab=profile-settings&scroll=true","/order-management":"/quan-ly-don-hang","/account-center":"/tai-khoan-ca-nhan","/gross-net-salary-converter":"/tinh-luong-gross-net","/salary/all-jobs":"/muc-luong/tat-ca-viec-lam","/numerology":"/nhan-so-hoc","/interview/all-jobs":"/cau-hoi-phong-van/tat-ca-viec-lam","/career-path":"/lo-trinh-su-nghiep","/empower-growth-2023/en":"/empower-growth-2023","Change photo":"Thay đổi hình ảnh","Remove this photo":"Xóa ảnh này","Edit Photo":"Chỉnh sửa hình ảnh","Please select photo region to the crop image":"Vui lòng chọn vùng ảnh muốn giữ","Preview your avatar":"Xem thử","Crop Image":"Chọn","Avatar":"Hình Ảnh","Remove Photo Confirmation":"Xác Nhận Xóa Hình Ảnh","Are you sure you want to remove this photo?":"Bạn có chắc chắn muốn xóa ảnh này?","Yes, remove this photo":"Đồng ý xóa ảnh","Change":"Thay Đổi","Remove":"Xóa","Change Photo":"Chọn Ảnh Khác","Add New":"Thêm Mới","You can only upload .jpg, .png, and .gif files that are less than 10MB in size":"Định dạng file chỉ có thể là .jpg, .png và .gif, files phải nhỏ hơn 1MB","characters remaining":"ký tự còn lại","Dashboard":"Tổng Quan","My Companies":"Công Ty Của Tôi","My Jobs":"Việc Làm Của Tôi","Job Alerts":"Thông Báo Việc Làm","Order Management":"Quản Lý Đơn Hàng","My Career Center":"Quản Lý Nghề Nghiệp","Referral Candidates":"Giới Thiệu Ứng Viên","in":"trong","Contact Information":"Thông Tin Cá Nhân","Add contact information":" Thêm thông tin liên hệ","Edit Contact Information":"Sửa thông tin liên hệ","Your Contact Info has been updated successfully\'":"Thông Tin Liên Hệ của bạn đã được cập nhật thành công","Please choose gender":"Chọn giới tính","e.g.":"Ví dụ:","e.g. 0903012825":"Ví dụ: 09030123825","e.g. 28/04/1986":"Ví dụ: 28/04/1986","e.g. Ho Chi Minh":"Ví dụ: Hồ Chí Minh","e.g. District 3":"Ví dụ: Quận 3","e.g. 11 Doan Van Bo":"Ví dụ: 11 Đoàn Văn Bơ","e.g. Vietnam":"Ví dụ: Việt Nam","e.g. UI/UX Designer":"Ví dụ: UI/UX Designer","e.g. 09/2008":"Ví dụ: 09/2008","e.g. 12/2014":"Ví dụ: 12/2014","e.g. Tran Thai Son":"Ví dụ: Trần Thái Sơn","e.g. Project Manager":"Ví dụ: Quản Lý Dự Án","e.g. Navigos Group Vietnam":"Ví dụ: Tập Đoàn Navigos Việt Nam","e.g. reference@navigosgroup.com":"Ví dụ: reference@navigosgroup.com","e.g. 0903035333":"Ví dụ: 0903035333","Please choose marital status":"Vui lòng chọn tình trạng hôn nhân","Working Preferences":"Công Việc Mong Muốn","Work Preferences":"Công Việc Mong Muốn","Working Preference":"Công Việc Mong Muốn","References":"Người Tham Khảo","Education":"Học Vấn","Add New Education":"Thêm Học Vấn","Add Education":"Thêm Học Vấn","Edit Education":"Sửa Học Vấn","Subject":"Chuyên Ngành","School":"Trường","Qualifications":"Bằng Cấp","Achievements":"Thành Tựu","Input details of your education, as well as any professional qualifications or relevant training":"Mô tả toàn bộ quá trình học vấn của bạn, cũng như các bằng cấp bạn đã được và các khóa huấn luyện bạn đã tham gia","Describe your outstanding projects to attract employers":"Mô tả các dự án nổi bật của bạn nhằm thu hút nhà tuyển dụng","Beginner":"Cơ bản","Intermediate":"Trung bình","Advanced":"Tương đối hoàn chỉnh","Completed":"Hoàn chỉnh","Expert":"Tương đối hoàn chỉnh","All Star":"Hoàn chỉnh","field_JobTitle":"Chức Danh","field_Phone":"Số Điện Thoại","field_JobLevelId":"Chức Danh","field_Description":"Mô Tả","field_Description_Education":"Thành Tựu","Complete the sections below to take your profile to the next level:":"Điền vào những nội dung sau để tăng bậc hồ sơ","Profile Strength":"Hoàn Chỉnh Hồ Sơ","You profile will be reviewed in 1 working day":"Hồ sơ của bạn sẽ được duyệt trong 1 ngày làm việc","You profile will be reviewed within 1 working day.":"Hồ sơ của bạn sẽ được duyệt trong 1 ngày làm việc","Until":"Đến","From":"Từ","To Present":"Hiện Tại","Present":"Hiện Tại","Current Job":"Công Việc Hiện Tại","Email":"Email","Date of Birth":"Ngày sinh","Gender":"Giới tính","Country":"Quốc gia","Select a country":"Chọn quốc gia","Select categories":"Chọn ngành nghề","Select a category":"Chọn ngành nghề","District":"Quận/Huyện","Address":"Địa chỉ","Cell Number":"Điện thoại","Nationality":"Quốc tịch","Marital Status":"Tình trạng hôn nhân","Province/City":"Tỉnh/Thành phố","Male":"Nam","Female":"Nữ","Single":"Độc thân","Married":"Đã kết hôn","Local Vietnamese":"Người Việt Nam","Foreigner":"Người nước ngoài","Select nationality":"Chọn quốc tịch","The phone number format is invalid.":"Số điện thoại của bạn không hợp lệ.","Accept 7 - 15 digits.":"Chấp nhận 7 - 15 chữ số.","Back to Dashboard":"Trở về trang tổng quan","e.g. 23/09/1990":"Ví dụ: 23/09/1990","Expected Location":"Nơi làm việc","Willing to relocate":"Có thể thay đổi nơi làm việc","Expected Function":"Ngành nghề","Expected Job Function":"Ngành nghề","Expected Industry":"Lĩnh vực","Expected Job Level":"Cấp bậc mong muốn","Expected Salary (USD per month)":"Mức lương mong muốn (USD / tháng)","Expected Salary":"Mức lương mong muốn","USD/month":"USD/tháng","Expected Top 5 Benefits":"Top 5 Phúc Lợi Tôi Mong Muốn Nhất","You have selected the maximum number of benefits! Remove one to add another.":"Bạn đã chọn tối đa số lượng phúc lợi! Xóa bớt để có thể chọn thêm.","This information is required":"Thông tin bắt buộc","There were some errors. Please try again later":"Đã có lỗi, vui lòng thử lại sau","Your Working Preference has been updated successfully":"Công Việc Mong Muốn của bạn đã được cập nhật thành công","You have selected the max number of 3 categories":"Bạn đã lựa chọn tối đa 3 ngành nghề","Working Preference was updated successfully!":"Công Việc Mong Muốn đã được cập nhật thành công","There were errors. Please try again later":"Đã có lỗi. Vui lòng thử lại sau","e.g. International Business":"Ví dụ: Kinh Doanh Quốc Tế","e.g. University of Economics of Ho Chi Minh City":"Ví dụ: Đại học Kinh Tế Tp. Hồ Chí Minh","This is not a valid email address":"Địa chỉ email không hợp lệ","This is not a valid email address.":"Địa chỉ email không hợp lệ.","e.g. 5000":"Ví dụ: 5000","Your salary may seem unrealistic. Note that this is the salary in USD per month":"Mức lương của bạn có vẻ không thực tế. Lưu ý đây là mức lương theo USD mỗi tháng","Reference information needs to be different from your personal information.":"Thông tin của Người Tham Khảo cần khác với thông tin cá nhân của bạn.","You cannot recommend yourself.":"Bạn không thể đưa nhận xét cho chính bạn.","Contact info was updated successfully!":"Thông tin cá nhân cập nhật thành công!","Your Reference has been sorted successfully":"Người tham khảo được sắp xếp thành công!","Your Recommendations has been sorted successfully":"Lời nhận xét được sắp xếp thành công!","Add Location":"Thêm nơi làm việc","Edit Work Preferences":"Sửa Công Việc Mong Muốn","Exceeded maximum character length of":"Đã vượt quá độ dài ký tự tối đa là","You have entered either phone or email. Please remove it.":"Bạn đã nhập email hoặc số điện thoại. Vui lòng xóa những thông tin đó.","New Work Experience":"Thêm Kinh Nghiệm Làm Việc","View more":"Xem thêm","View less":"Thu gọn","Download Profile":"Tải Hồ Sơ","Your profile must be completed and approved before downloading":"Bạn phải hoàn chỉnh hồ sơ và được duyệt trước khi tải về","/download-resume":"/tai-ho-so","Activities":"Hoạt Động","Activity Name":"Tên Chương Trình","Function Title":"Vai Trò","Organization":"Tên Tổ Chức","Add Activity":"Thêm Hoạt Động","Edit Activity":"Sửa Hoạt Động","Delete Activity":"Xóa Hoạt Động","Current Activity":"Hoạt Động Hiện Tại","Are you sure you want to delete this Activity block?":"Bạn có chắc muốn xóa hoạt động này không?","Activities make your profile more dynamic.":"Bổ sung các hoạt động giúp hồ sơ của bạn năng động hơn.","Activities do not impact your profile strength.":"Hoạt động không ảnh hưởng đến bậc hồ sơ của bạn.","Your Activity has been created successfully":"Hoạt động của bạn đã được thêm thành công","Your Activity has been updated successfully":"Hoạt động của bạn đã được cập nhật thành công","Your Activity has been removed successfully":"Hoạt động của bạn đã được xóa thành công","Your Activity has been sorted successfully":"Hoạt động của bạn đã được sắp xếp thành công","Add more sections to make your CV more attractive.":"Bổ sung thêm các thông tin giúp CV của bạn cuốn hút hơn.","invalid Activity":"Hoạt động không hợp lệ","invalid Position":"Chức danh không hợp lệ","More Sections":"Thêm Mục","Add Activities":"Thêm Hoạt Động","Certifications":"Chứng Chỉ","Add Certification":"Thêm Chứng Chỉ","Add Certifications":"Thêm Chứng Chỉ","Add New Certification":"Thêm Chứng Chỉ","Edit Certification":"Sửa Chứng Chỉ","Certification Name":"Tên Chứng Chỉ","Delete Certification":"Xóa Chứng Chỉ","Are you sure you want to delete this Certification?":"Bạn có chắc muốn xóa chứng chỉ này không?","Institution":"Tổ Chức","Certification Link":"Đường Dẫn Chứng Chỉ","Paste or type a link of your certification":"Dán hoặc gõ đường dẫn tới chứng chỉ của bạn","Your Certification has been added successfully":"Chứng Chỉ của bạn đã được thêm thành công","Your Certification has been updated successfully":"Chứng Chỉ của bạn đã được cập nhật thành công","Your Certification has been deleted successfully":"Chứng Chỉ của bạn đã được xóa thành công","Your Certification has been sorted successfully":"Chứng Chỉ của bạn đã được sắp xếp thành công","Certifications demonstrate your passion and provide evidence of your specific expertise and skills.":"Các chứng chỉ giúp nhà tuyển dụng dễ dàng biết được những kiến thức và kỹ năng bạn đã được đào tạo.","Certification name is required":"Thông tin bắt buộc","Certifications do not impact your profile strength.":"Chứng chỉ không ảnh hưởng đến bậc hồ sơ của bạn.","This is not a valid URL":"Đường dẫn không hợp lệ","Add Awards":"Thêm Giải Thưởng","Add Hobbies":"Thêm Sở Thích","Jobs You Will Love":"Việc Làm Bạn Sẽ Thích","Who view my profile":"Nhà tuyển dụng xem hồ sơ","Career center":"Nghề nghiệp","Profile Settings":"Thiết Lập Hồ Sơ","Skill name limited to 40 characters":"Tên kỹ năng giới hạn 40 ký tự","Trusted company":"Công ty uy tín","Profile strength will be downgraded":"Độ hoàn chỉnh của hồ sơ sẽ bị hạ cấp","Because of removing some primary information that will impact your profile, such as:":"Do xóa một số thông tin chính sẽ ảnh hưởng đến hồ sơ của bạn, chi tiết như:","Searchable by VietnamWorks profile will be turned off.":"Cho phép tìm kiếm theo hồ sơ trực tuyến VietnamWorks sẽ bị tắt.","It takes time to get approval CV again.":"Phải xét duyệt lại CV.","Yes, I am aware":"Tôi chắc chắn","Keep it":"Giữ nguyên","Are you sure you want to downgrade your profile strength?":"Bạn có chắc chắn hạ cấp của hồ sơ của mình?","You have reached the maximum number of certifications. Please delete one to add another.":"Số lượng chứng chỉ bạn tạo đã đạt mức tối đa. Vui lòng bỏ bớt để tạo thêm.","Vietnamworks profile":"Hồ sơ Vietnamworks","My attached CVs":"Hồ sơ đính kèm","Profile settings":"Thiết lập hồ sơ","Linkedin profile":"Hồ sơ Linkedin","Cover letter":"Lời nhắn","This recommendation is hidden":"Nhận xét này đang ẩn","This recommendation is shown":"Nhận xét này đang hiển thị","What a person talks about you can add more credit to your profile.":"Điều người khác nói về bạn có thể tăng sự uy tín cho hồ sơ của bạn.","Pending":"Đang chờ","Received":"Đã nhận","Hi":"Xin chào",", would you write me a recommendation please?":", bạn có thể viết một vài dòng nhận xét về tôi không?","Ask for a recommendation":"Gửi yêu cầu viết nhận xét","Ask this person to give you a recommendation":"Gửi yêu cầu người này viết nhận xét về bạn","A recommendation":"Lời nhận xét","is a commendation written by a person (colleagues / managers / subordinates / professors) to recognize your work. It is more trustworthy if employers see your profiles attached with recommendations.":"(Recommendation) là một sự khen ngợi của người khác (đồng nghiệp / cấp trên / cấp dưới / giảng viên), nhằm ghi nhận quá trình và kết quả làm việc của bạn. Hồ sơ của bạn sẽ đáng tin cậy hơn đối với nhà tuyển dụng nếu được đính kèm với những lời nhận xét này.","To request a recommendation,":"Để tạo yêu cầu nhận xét,","Fill information in the Recommendations request form":"Điền đầy đủ thông tin tại mẫu yêu cầu nhận xét","Click":"Bấm","Recommender receives a link to input their comment":"Người viết nhận xét sẽ nhận được một liên kết để nhập nhận xét cho bạn","You can show the recommendations on your Vietnamworks profile or WowCV.":"Bạn có thể hiển thị những lời nhận xét trên Hồ sơ Vietnamworks hoặc WowCV.","We find that your recommender hasn’t responded your email. The email may be marked as “Promotions“ or “Spam”, so please ask them directly to check the one whose subject is “Write _firstName a recommendations”.":"Chúng tôi nhận thấy yêu cầu viết lời nhận xét của bạn chưa được phản hồi. Thư yêu cầu đó có thể đã bị đánh dấu \\"Quảng cáo\\" hoặc \\"Thư rác\\", do đó bạn hãy liên hệ trực tiếp với người nhận để yêu cầu kiểm tra thư có tiêu đề \\"Hãy viết cho _firstName vài lời nhận xét\\".","Add to profile":"Thêm vào hồ sơ","Don\'t include":"Không thêm","Replace":"Thay thế","We found the new \'Career Objective\' content in your resume. Add it to your Vietnamworks Profile so employers can see your complete information.":"Chúng tôi tìm thấy nội dung \\"Mục Tiêu Nghề Nghiệp\\" mới trong hồ sơ đính kèm của bạn. Hãy thêm nội dung này vào Hồ sơ Vietnamworks, để nhà tuyển dụng có thể xem đầy đủ thông tin của bạn.","Notifications":"Thông báo","Login":"Đăng nhập","Make profile searchable":"Cho phép tìm kiếm hồ sơ","Salary convertor":"Công cụ tính lương","Salary report":"Báo cáo lương","Numerology":"Nhân số học","Interview question":"Câu hỏi phỏng vấn","Career path":"Lộ trình sự nghiệp","Logout":"Thoát","Your searchable CV is disable now because of wrong contact information. Please contact with Vietnamworks to verify your information by email:":"Hiện tại bạn không thể bật chức năng tìm kiếm hồ sơ vì nhập sai thông tin liên hệ. Vui lòng liên hệ với Vietnamworks để xác nhận lại thông tin qua email:","Searchable CV is disable":"Tính năng bật tìm kiếm đang bị khoá","Your changes has been saved successfully!":"Thay đổi của bạn đã được lưu thành công!","Profile is not eligible to make searchable":"Hồ sơ chưa đủ điều kiện cho phép tìm kiếm","Turn off searchable CV?":"Tắt tìm kiếm hồ sơ?","Employer will not see your profile on Vietnamwork system.":"Nhà tuyển dụng sẽ không tìm kiếm được hồ sơ của bạn trên hệ thống Vietnamworks.","VietnamWorks online profile":"Hồ sơ trực tuyến VietnamWorks","Charge station":"Trạm sạc","Projects":"Dự án","Add Projects":"Thêm Dự Án","Edit Projects":"Sửa Dự Án","Project Name":"Tên Dự Án","Client / Company":"Khách Hàng / Công Ty","Role in project":"Vai trò trong dự án","Your Role":"Vai Trò Của Bạn","Description project":"Mô Tả Dự Án","Images project":"Hình Ảnh Dự Án","Skills project":"Công Việc","Project url":"Project url","Delete Project":"Xóa Dự Án","Country/ City/ District":"Quốc gia/ Tỉnh thành/ Quận huyện","Select your location":"Chọn địa điểm của bạn","Location":"Địa điểm","Your Project has been created successfully":"Dự Án của bạn đã được thêm thành công","Your Project has been updated successfully":"Dự Án của bạn đã được cập nhật thành công","Your Project has been deleted successfully":"Dự Án của bạn đã được xóa thành công","Your Project has been sorted successfully":"Dự Án của bạn đã được sắp xếp thành công","Are you sure you want to delete this Project?":"Bạn có chắc muốn xóa dự án này không?","Your searchable profile will be more outstanding with <strong>\\"Open to work\\"</strong> tag":"Hồ sơ tìm kiếm của bạn sẽ nổi bật hơn với thẻ <strong>\\"Open to work\\"</strong>"}');

/***/ })

}]);